(() => {
  "use strict";

  const SAVE_KEY = "overtime-career-save-v1";
  const CURRENT_YEAR = 2026;

  const COUNTRY_REGION_DEFAULTS = {
    asia: { region: "亚洲赛区", majorRegion: "亚洲", trait: "跨地区适应", mods: { mechanics: 2, mentality: 2 } },
    europe: { region: "欧洲赛区", majorRegion: "欧洲", trait: "欧洲联赛体系", mods: { gameSense: 2, teamwork: 2 } },
    americas: { region: "美洲赛区", majorRegion: "美洲", trait: "敢打敢拼", mods: { mechanics: 2, mentality: 2 } }
  };
  const makeCountry = (id, name, flag, group, language, english = 45, locals = [], overrides = {}) => ({
    id, name, flag, language, english, locals, group,
    ...COUNTRY_REGION_DEFAULTS[group],
    ...overrides
  });
  const COUNTRIES = [
    makeCountry("cn", "中国", "🇨🇳", "asia", "中文", 28, ["tyloo", "lynn", "rare_atom", "jijiehao", "fengda", "ctg"], { trait: "纪律训练", mods: { teamwork: 3, mentality: 2 } }),
    makeCountry("mn", "蒙古", "🇲🇳", "asia", "蒙古语", 38, ["mongolz", "atox", "nuclear", "huns", "chinggis", "eruption"], { trait: "无畏对枪", mods: { mechanics: 4, mentality: 1 }, extraLanguages: { "俄语": 42 } }),
    makeCountry("au", "澳大利亚", "🇦🇺", "asia", "英语", 100, ["flyquest", "rooster", "mindfreak"], { trait: "大洋洲韧性" }),
    makeCountry("nz", "新西兰", "🇳🇿", "asia", "英语", 100),
    makeCountry("jp", "日本", "🇯🇵", "asia", "日语", 42),
    makeCountry("kr", "韩国", "🇰🇷", "asia", "韩语", 48),
    makeCountry("in", "印度", "🇮🇳", "asia", "印地语", 72),
    makeCountry("pk", "巴基斯坦", "🇵🇰", "asia", "乌尔都语", 68),
    makeCountry("bd", "孟加拉国", "🇧🇩", "asia", "孟加拉语", 58),
    makeCountry("id", "印度尼西亚", "🇮🇩", "asia", "印度尼西亚语", 54, ["alterego"]),
    makeCountry("my", "马来西亚", "🇲🇾", "asia", "马来语", 76),
    makeCountry("sg", "新加坡", "🇸🇬", "asia", "英语", 100),
    makeCountry("ph", "菲律宾", "🇵🇭", "asia", "菲律宾语", 78),
    makeCountry("th", "泰国", "🇹🇭", "asia", "泰语", 46),
    makeCountry("vn", "越南", "🇻🇳", "asia", "越南语", 42),
    makeCountry("kz", "哈萨克斯坦", "🇰🇿", "asia", "哈萨克语", 42, [], { trait: "CIS 枪法传统", extraLanguages: { "俄语": 92 } }),
    makeCountry("uz", "乌兹别克斯坦", "🇺🇿", "asia", "乌兹别克语", 38, [], { extraLanguages: { "俄语": 72 } }),
    makeCountry("kg", "吉尔吉斯斯坦", "🇰🇬", "asia", "吉尔吉斯语", 36, [], { extraLanguages: { "俄语": 78 } }),
    makeCountry("hk", "中国香港", "🇭🇰", "asia", "粤语", 70, [], { extraLanguages: { "中文": 88 } }),
    makeCountry("tw", "中国台北", "🇹🇼", "asia", "中文", 58),
    makeCountry("sa", "沙特阿拉伯", "🇸🇦", "asia", "阿拉伯语", 58, ["falcons"]),
    makeCountry("ae", "阿联酋", "🇦🇪", "asia", "阿拉伯语", 78),
    makeCountry("il", "以色列", "🇮🇱", "europe", "希伯来语", 86, [], { trait: "国际阵容适应" }),
    makeCountry("jo", "约旦", "🇯🇴", "asia", "阿拉伯语", 64),
    makeCountry("lb", "黎巴嫩", "🇱🇧", "asia", "阿拉伯语", 72),
    makeCountry("iq", "伊拉克", "🇮🇶", "asia", "阿拉伯语", 46),
    makeCountry("ir", "伊朗", "🇮🇷", "asia", "波斯语", 48),
    makeCountry("za", "南非", "🇿🇦", "asia", "英语", 100, [], { trait: "非洲赛区先锋" }),
    makeCountry("ma", "摩洛哥", "🇲🇦", "asia", "阿拉伯语", 58, [], { extraLanguages: { "法语": 72 } }),
    makeCountry("tn", "突尼斯", "🇹🇳", "asia", "阿拉伯语", 56, [], { extraLanguages: { "法语": 68 } }),
    makeCountry("dz", "阿尔及利亚", "🇩🇿", "asia", "阿拉伯语", 54, [], { extraLanguages: { "法语": 66 } }),
    makeCountry("eg", "埃及", "🇪🇬", "asia", "阿拉伯语", 58),

    makeCountry("dk", "丹麦", "🇩🇰", "europe", "丹麦语", 78, ["astralis", "heroic", "ecstatic"], { trait: "体系素养", mods: { gameSense: 3, teamwork: 2 } }),
    makeCountry("ru", "俄罗斯", "🇷🇺", "europe", "俄语", 34, ["spirit", "aurora", "9pandas", "betboom"], { trait: "枪法底蕴", mods: { mechanics: 3, gameSense: 2 } }),
    makeCountry("ua", "乌克兰", "🇺🇦", "europe", "乌克兰语", 48, ["navi", "b8", "passionua"], { trait: "大赛韧性", mods: { mentality: 4, gameSense: 1 }, extraLanguages: { "俄语": 68 } }),
    makeCountry("fr", "法国", "🇫🇷", "europe", "法语", 50, ["vitality", "3dmax", "genone"], { trait: "明星气质", mods: { mechanics: 2, fame: 180 } }),
    makeCountry("se", "瑞典", "🇸🇪", "europe", "瑞典语", 82, ["nip", "eyeballers", "alliance"], { trait: "传统强国", mods: { gameSense: 2, mechanics: 2 } }),
    makeCountry("de", "德国", "🇩🇪", "europe", "德语", 80, ["mouz", "g2", "big", "gamerlegion"], { trait: "严谨体系" }),
    makeCountry("fi", "芬兰", "🇫🇮", "europe", "芬兰语", 84, ["ence"], { trait: "冷静沟通" }),
    makeCountry("pl", "波兰", "🇵🇱", "europe", "波兰语", 58, [], { trait: "枪法传统", mods: { mechanics: 3, mentality: 1 } }),
    makeCountry("pt", "葡萄牙", "🇵🇹", "europe", "葡萄牙语", 62, ["saw"]),
    makeCountry("rs", "塞尔维亚", "🇷🇸", "europe", "塞尔维亚语", 66, ["aurora", "parivision"]),
    makeCountry("ro", "罗马尼亚", "🇷🇴", "europe", "罗马尼亚语", 62, ["nexus"]),
    makeCountry("cz", "捷克", "🇨🇿", "europe", "捷克语", 74, ["sinners"]),
    makeCountry("tr", "土耳其", "🇹🇷", "europe", "土耳其语", 48, ["fut"], { trait: "高强度对枪", mods: { mechanics: 3, mentality: 1 } }),
    makeCountry("no", "挪威", "🇳🇴", "europe", "挪威语", 92),
    makeCountry("ee", "爱沙尼亚", "🇪🇪", "europe", "爱沙尼亚语", 88, [], { trait: "残局纪律" }),
    makeCountry("lv", "拉脱维亚", "🇱🇻", "europe", "拉脱维亚语", 78, [], { extraLanguages: { "俄语": 52 } }),
    makeCountry("lt", "立陶宛", "🇱🇹", "europe", "立陶宛语", 82),
    makeCountry("sk", "斯洛伐克", "🇸🇰", "europe", "斯洛伐克语", 76),
    makeCountry("ba", "波黑", "🇧🇦", "europe", "波斯尼亚语", 68, [], { trait: "明星步枪传统", mods: { mechanics: 3, gameSense: 1 } }),
    makeCountry("xk", "科索沃", "🇽🇰", "europe", "阿尔巴尼亚语", 66, [], { trait: "新生代火力", mods: { mechanics: 3, mentality: 1 } }),
    makeCountry("bg", "保加利亚", "🇧🇬", "europe", "保加利亚语", 64),
    makeCountry("hr", "克罗地亚", "🇭🇷", "europe", "克罗地亚语", 76),
    makeCountry("si", "斯洛文尼亚", "🇸🇮", "europe", "斯洛文尼亚语", 82),
    makeCountry("mk", "北马其顿", "🇲🇰", "europe", "马其顿语", 62),
    makeCountry("al", "阿尔巴尼亚", "🇦🇱", "europe", "阿尔巴尼亚语", 64),
    makeCountry("at", "奥地利", "🇦🇹", "europe", "德语", 88),
    makeCountry("be", "比利时", "🇧🇪", "europe", "荷兰语", 88, [], { extraLanguages: { "法语": 72 } }),
    makeCountry("by", "白俄罗斯", "🇧🇾", "europe", "白俄罗斯语", 46, [], { extraLanguages: { "俄语": 92 } }),
    makeCountry("es", "西班牙", "🇪🇸", "europe", "西班牙语", 62),
    makeCountry("gb", "英国", "🇬🇧", "europe", "英语", 100),
    makeCountry("ie", "爱尔兰", "🇮🇪", "europe", "英语", 100),
    makeCountry("nl", "荷兰", "🇳🇱", "europe", "荷兰语", 94),
    makeCountry("ch", "瑞士", "🇨🇭", "europe", "德语", 92, [], { extraLanguages: { "法语": 68 } }),
    makeCountry("it", "意大利", "🇮🇹", "europe", "意大利语", 58),
    makeCountry("gr", "希腊", "🇬🇷", "europe", "希腊语", 68),
    makeCountry("hu", "匈牙利", "🇭🇺", "europe", "匈牙利语", 72),
    makeCountry("is", "冰岛", "🇮🇸", "europe", "冰岛语", 94),
    makeCountry("md", "摩尔多瓦", "🇲🇩", "europe", "罗马尼亚语", 54, [], { extraLanguages: { "俄语": 66 } }),
    makeCountry("ge", "格鲁吉亚", "🇬🇪", "europe", "格鲁吉亚语", 58, [], { extraLanguages: { "俄语": 56 } }),

    makeCountry("br", "巴西", "🇧🇷", "americas", "葡萄牙语", 36, ["furia", "pain", "legacy", "imperial", "mibr", "fluxo", "sharks", "red_canids"], { trait: "激情主场", mods: { mentality: 2, fame: 260 } }),
    makeCountry("us", "美国", "🇺🇸", "americas", "英语", 100, ["faze", "liquid", "complexity", "m80", "wildcard", "nrg", "boss", "nouns"], { trait: "商业舞台", mods: { mechanics: 2, fame: 160 } }),
    makeCountry("ca", "加拿大", "🇨🇦", "americas", "英语", 100, [], { trait: "国际阵容适应" }),
    makeCountry("ar", "阿根廷", "🇦🇷", "americas", "西班牙语", 48, ["9z", "bestia"]),
    makeCountry("mx", "墨西哥", "🇲🇽", "americas", "西班牙语", 58),
    makeCountry("gt", "危地马拉", "🇬🇹", "americas", "西班牙语", 54),
    makeCountry("cl", "智利", "🇨🇱", "americas", "西班牙语", 54),
    makeCountry("co", "哥伦比亚", "🇨🇴", "americas", "西班牙语", 52),
    makeCountry("pe", "秘鲁", "🇵🇪", "americas", "西班牙语", 46),
    makeCountry("uy", "乌拉圭", "🇺🇾", "americas", "西班牙语", 52),
    makeCountry("ve", "委内瑞拉", "🇻🇪", "americas", "西班牙语", 48),
    makeCountry("bo", "玻利维亚", "🇧🇴", "americas", "西班牙语", 44),
    makeCountry("py", "巴拉圭", "🇵🇾", "americas", "西班牙语", 46),
    makeCountry("cr", "哥斯达黎加", "🇨🇷", "americas", "西班牙语", 62),
    makeCountry("cu", "古巴", "🇨🇺", "americas", "西班牙语", 42)
  ];

  const ROLES = [
    { id: "rifler", name: "步枪手", code: "RF", desc: "稳定输出，全面适配多数战术体系", mods: { mechanics: 5, teamwork: 2 } },
    { id: "awper", name: "狙击手", code: "AWP", desc: "掌控关键枪位，但表现波动更受关注", mods: { mechanics: 7, mentality: 1 } },
    { id: "entry", name: "突破手", code: "EN", desc: "打开进攻空间，以风险换取团队上限", mods: { mechanics: 6, mentality: 3, fitness: 2 } },
    { id: "igl", name: "指挥", code: "IGL", desc: "阅读比赛并领导团队，个人数据次要", mods: { gameSense: 8, teamwork: 4, mechanics: -2 } },
    { id: "support", name: "辅助 / 自由人", code: "SP", desc: "道具、残局与补枪，职业寿命更稳定", mods: { gameSense: 4, teamwork: 6 } }
  ];

  const MAPS = [
    { id: "inferno", name: "Inferno", code: "INF", style: "香蕉道资源与残局" },
    { id: "dust2", name: "Dust II", code: "D2", style: "长距离对枪与默认控图" },
    { id: "mirage", name: "Mirage", code: "MIR", style: "中路控制与快速夹击" },
    { id: "ancient", name: "Ancient", code: "ANC", style: "道具交换与中路争夺" },
    { id: "anubis", name: "Anubis", code: "ANB", style: "水道控制与快速夹层" },
    { id: "nuke", name: "Nuke", code: "NUK", style: "立体转点与外场控制" },
    { id: "cache", name: "Cache", code: "CCH", style: "中路争夺与快速转点" },
  ];

  const STAT_META = [
    ["mechanics", "枪法"], ["gameSense", "意识"], ["teamwork", "团队"],
    ["mentality", "心态"], ["fitness", "状态"]
  ];

  const COUNTRY_LANGUAGES = Object.fromEntries(COUNTRIES.map((item) => [item.name, item.language]));
  const ENGLISH_TEAMS = new Set([
    "heroic", "aurora", "navi", "vitality", "nip", "mouz", "g2", "faze", "liquid", "complexity",
    "big", "gamerlegion", "ence", "parivision", "m80", "wildcard", "flyquest", "falcons"
  ]);

  const ABILITIES = [
    { id: "one_tap", code: "01", name: "准星焊死", rarity: "稀有", desc: "日复一日的定位练习已经成为肌肉记忆。", effects: { mechanics: 8 }, perk: "rawAim" },
    { id: "ice", code: "02", name: "冰冷血液", rarity: "稀有", desc: "比分越接近，呼吸越平稳。关键局获得额外稳定性。", effects: { mentality: 8 }, perk: "clutch" },
    { id: "chess", code: "03", name: "棋盘视角", rarity: "稀有", desc: "你总能比对手早半拍理解地图上正在发生什么。", effects: { gameSense: 8 }, perk: "reader" },
    { id: "glue", code: "04", name: "更衣室核心", rarity: "普通", desc: "你让五个性格迥异的人愿意朝同一目标前进。", effects: { teamwork: 7, mentality: 2 }, perk: "chemistry" },
    { id: "first_in", code: "05", name: "第一身位", rarity: "史诗", desc: "没有人喜欢第一个冲进包点——除了你。", effects: { mechanics: 6, fitness: 3, fame: 220 }, perk: "entryBoost", roles: ["entry"] },
    { id: "lab_rat", code: "06", name: "训练室常客", rarity: "普通", desc: "别人离开服务器以后，你才刚刚开始。", effects: { mechanics: 3, fitness: 5 }, perk: "fastGrowth" },
    { id: "big_stage", code: "07", name: "为舞台而生", rarity: "史诗", desc: "灯光与欢呼不会带来压力，只会让你更加专注。", effects: { mentality: 5, fame: 420 }, perk: "bigStage" },
    { id: "utility", code: "08", name: "道具博士", rarity: "普通", desc: "每一颗闪光弹都有目的，每一秒燃烧都有价值。", effects: { gameSense: 4, teamwork: 5 }, perk: "utility" },
    { id: "comeback", code: "09", name: "永不掉线", rarity: "稀有", desc: "糟糕的上半场不会定义你，低谷反而让你清醒。", effects: { mentality: 6, fitness: 3 }, perk: "resilient" },
    { id: "caller", code: "10", name: "第二指挥", rarity: "稀有", desc: "回合中期的一个判断，足以把僵局变成胜势。", effects: { gameSense: 6, teamwork: 4 }, perk: "midround", roles: ["igl"] },
    { id: "highlight", code: "11", name: "高光制造机", rarity: "史诗", desc: "你总能用最不可思议的方式登上赛事集锦。", effects: { mechanics: 4, fame: 600 }, perk: "showman" },
    { id: "anchor", code: "12", name: "钢铁守点", rarity: "普通", desc: "即使只剩你一个人，包点也从来不算空。", effects: { teamwork: 4, mentality: 5 }, perk: "anchor", roles: ["support", "rifler"] },
    { id: "polyglot", code: "13", name: "国际语言", rarity: "普通", desc: "跨国阵容里的沟通与文化差异不再是障碍。", effects: { teamwork: 5, fame: 140, english: 25 }, perk: "polyglot" },
    { id: "economist", code: "14", name: "经济局专家", rarity: "稀有", desc: "半甲手枪在你手里，也能成为改写比赛的机会。", effects: { gameSense: 4, mechanics: 3 }, perk: "ecoKing" },
    { id: "opening_pick", code: "15", name: "首杀准则", rarity: "稀有", desc: "回合刚开始，你已经知道第一枪应该落在哪里。", effects: { mechanics: 5, gameSense: 3 }, perk: "openingPick", roles: ["awper"] },
    { id: "angle_memory", code: "16", name: "像素记忆", rarity: "普通", desc: "每一条架枪缝隙和过点高度都刻进了肌肉记忆。", effects: { mechanics: 3, mentality: 4 }, perk: "angleMemory", roles: ["awper"] },
    { id: "tempo_awp", code: "17", name: "节奏大狙", rarity: "史诗", desc: "你不只等待目标，还会用 AWP 主动改变整张地图的节奏。", effects: { mechanics: 7, mentality: 3, fame: 240 }, perk: "tempoAwp", roles: ["awper"] },
    { id: "second_shot", code: "18", name: "第二枪保险", rarity: "稀有", desc: "第一枪没有结束回合时，你的复位速度依然快得惊人。", effects: { mechanics: 4, fitness: 3 }, perk: "secondShot", roles: ["awper"] },
    { id: "space_creator", code: "19", name: "空间制造者", rarity: "稀有", desc: "哪怕没有击杀，你的路线也会迫使防守方交出关键资源。", effects: { mechanics: 4, teamwork: 3, fitness: 2 }, perk: "spaceCreator", roles: ["entry"] },
    { id: "flash_entry", code: "20", name: "闪光同步", rarity: "普通", desc: "你和辅助位的闪光永远同时抵达，突破不再依靠运气。", effects: { gameSense: 3, teamwork: 4 }, perk: "flashEntry", roles: ["entry", "support"] },
    { id: "chaos_entry", code: "21", name: "混沌突破", rarity: "史诗", desc: "越是拥挤混乱的包点，你越能找到唯一的击杀窗口。", effects: { mechanics: 7, mentality: 3, fame: 260 }, perk: "chaosEntry", roles: ["entry"] },
    { id: "spray_control", code: "22", name: "弹道雕刻", rarity: "稀有", desc: "三十发子弹在你手里不是扩散，而是一条可以控制的轨迹。", effects: { mechanics: 7 }, perk: "sprayMaster", roles: ["rifler"] },
    { id: "trade_machine", code: "23", name: "补枪机器", rarity: "普通", desc: "队友倒下后的半秒，你总能让人数重新回到平衡。", effects: { mechanics: 3, teamwork: 5 }, perk: "tradeMachine", roles: ["rifler", "support"] },
    { id: "burst_reset", code: "24", name: "急停重置", rarity: "稀有", desc: "短点、横拉、再次急停，每一轮交火都保持第一发精度。", effects: { mechanics: 5, mentality: 3 }, perk: "burstReset", roles: ["rifler"] },
    { id: "master_caller", code: "25", name: "全局指挥", rarity: "史诗", desc: "暂停结束前，你已经为接下来的三个回合准备了不同答案。", effects: { gameSense: 7, teamwork: 5 }, perk: "masterCaller", roles: ["igl"] },
    { id: "anti_strat", code: "26", name: "反制手册", rarity: "稀有", desc: "对手的默认和小习惯会在录像里留下可以利用的规律。", effects: { gameSense: 6, mentality: 3 }, perk: "antiStrat", roles: ["igl"] },
    { id: "economy_caller", code: "27", name: "经济调度", rarity: "普通", desc: "你能让五个人的装备和战术目标始终处于同一节奏。", effects: { gameSense: 4, teamwork: 4 }, perk: "economyCaller", roles: ["igl", "support"] },
    { id: "clutch_support", code: "28", name: "残局保险", rarity: "稀有", desc: "道具耗尽、队友倒下以后，你仍能把残局拆成清晰步骤。", effects: { teamwork: 5, gameSense: 4, mentality: 2 }, perk: "clutchSupport", roles: ["support"] },
    { id: "smoke_clock", code: "29", name: "烟雾时钟", rarity: "普通", desc: "你精确记得每颗烟雾消散的秒数，并提前站好下一枪位。", effects: { gameSense: 4, teamwork: 5 }, perk: "smokeClock", roles: ["support"] },
    { id: "lurker", code: "30", name: "影子自由人", rarity: "稀有", desc: "你用安静的地图控制让对手永远不敢放心转点。", effects: { gameSense: 5, mechanics: 3 }, perk: "lurker", roles: ["rifler", "support"] },
    { id: "pistol_ace", code: "31", name: "手枪局王牌", rarity: "稀有", desc: "手枪局和强起局不是过渡，而是你最擅长偷走的回合。", effects: { mechanics: 4, mentality: 3 }, perk: "pistolAce" },
    { id: "map_specialist", code: "32", name: "地图专精", rarity: "稀有", desc: "你会把一张优势地图研究到连对手的反制都提前准备。", effects: { mapStrong: 5, gameSense: 2 }, perk: "mapSpecialist" },
    { id: "data_analyst", code: "33", name: "数据教练", rarity: "普通", desc: "热区、首杀率与道具效率会转化成下一场的具体调整。", effects: { gameSense: 5, teamwork: 2 }, perk: "analyst", roles: ["igl", "support"] },
    { id: "reset_proof", code: "34", name: "拒绝重置", rarity: "普通", desc: "输掉关键局以后，你仍能在下一回合恢复正确的操作节奏。", effects: { mentality: 5, fitness: 4 }, perk: "resetProof" },
    { id: "bootcamp_leader", code: "35", name: "集训领袖", rarity: "普通", desc: "高强度集训不会拖垮队伍，反而让你把所有人带进同一节奏。", effects: { teamwork: 4, fitness: 3, cohesion: 2 }, perk: "bootcampLeader" },
    { id: "lan_animal", code: "36", name: "线下猛兽", rarity: "史诗", desc: "隔音房、观众与舞台灯光会让你的操作比训练室更加果断。", effects: { mentality: 5, mechanics: 4, fame: 350 }, perk: "lanAnimal" }
  ];

  const ABILITY_COMBOS = [
    { id: "awp_network", name: "狙击天网", requires: ["opening_pick", "angle_memory"], desc: "架点反应加成，AWP 对局更加稳定。", matchBonus: 2.2, scenario: { reaction: 2 }, unlockEffects: { mentality: 1 } },
    { id: "superstar_awp", name: "明星大狙", requires: ["tempo_awp", "big_stage"], desc: "Major 与线下大赛获得额外统治力。", matchBonus: 1.2, majorBonus: 2.5, unlockEffects: { fame: 180 } },
    { id: "entry_storm", name: "无畏突破", requires: ["first_in", "space_creator"], desc: "快速多杀与扫射转移获得额外影响。", matchBonus: 2.1, scenario: { aim: 1, spray: 2 }, unlockEffects: { fitness: 1 } },
    { id: "flash_breach", name: "爆弹开路", requires: ["flash_entry", "utility"], desc: "道具与突破完全同步，强化团队进攻。", matchBonus: 1.8, unlockEffects: { teamwork: 1 } },
    { id: "rifle_harvest", name: "步枪收割机", requires: ["spray_control", "highlight"], desc: "连续多杀和扫射转移更容易形成高光。", matchBonus: 2, scenario: { aim: 2, spray: 2 }, unlockEffects: { fame: 160 } },
    { id: "trade_engine", name: "队伍引擎", requires: ["trade_machine", "glue"], desc: "补枪和团队关系互相放大，阵容更稳定。", matchBonus: 2.2, unlockEffects: { cohesion: 3 } },
    { id: "iron_site", name: "双枪位铁闸", requires: ["anchor", "clutch_support"], desc: "守点与残局结合，劣势回合仍有翻盘窗口。", matchBonus: 2.1, unlockEffects: { mentality: 1 } },
    { id: "chessmaster", name: "战术大脑", requires: ["master_caller", "chess"], desc: "全局规划与临场阅读形成完整指挥体系。", matchBonus: 3, unlockEffects: { gameSense: 1 } },
    { id: "anti_library", name: "反制数据库", requires: ["anti_strat", "data_analyst"], desc: "面对高 VRS 对手时获得额外赛前优势。", matchBonus: 1.5, underdogBonus: 2, unlockEffects: { teamwork: 1 } },
    { id: "utility_clock", name: "道具时钟", requires: ["smoke_clock", "utility"], desc: "道具持续时间与转点节奏被精确衔接。", matchBonus: 2, unlockEffects: { gameSense: 1 } },
    { id: "shadow_control", name: "影子棋手", requires: ["lurker", "chess"], desc: "自由人控制与比赛阅读共同限制对手转点。", matchBonus: 2.2, unlockEffects: { mechanics: 1 } },
    { id: "eco_hero", name: "经济奇迹", requires: ["pistol_ace", "economist"], desc: "沙鹰翻盘与强起局获得显著加成。", matchBonus: 1.2, scenario: { deagle: 3 }, unlockEffects: { mentality: 1 } },
    { id: "map_lab", name: "地图实验室", requires: ["map_specialist", "lab_rat"], desc: "针对训练额外提升地图熟练度。", matchBonus: 1, trainingBonus: 2, unlockEffects: { mapStrong: 2 } },
    { id: "no_reset", name: "永不重置", requires: ["reset_proof", "comeback"], desc: "失利和经济重置不再显著影响后续状态。", matchBonus: 1.7, unlockEffects: { fitness: 1 } },
    { id: "lan_king", name: "线下之王", requires: ["lan_animal", "big_stage"], desc: "最高规格舞台会进一步放大个人表现。", matchBonus: 1.2, majorBonus: 2.2, unlockEffects: { fame: 220 } }
  ];

  const TEAMS = [
    { id: "tyloo", name: "TYLOO", short: "TYL", country: "中国", region: "亚洲", rep: 58, salary: 5200, identity: "亚洲老牌劲旅" },
    { id: "lynn", name: "Lynn Vision", short: "LVG", country: "中国", region: "亚洲", rep: 48, salary: 3900, identity: "快速成长阵容" },
    { id: "rare_atom", name: "Rare Atom", short: "RA", country: "中国", region: "亚洲", rep: 53, salary: 4300, identity: "地区赛有力竞争者" },
    { id: "jijiehao", name: "JiJieHao", short: "JJH", country: "中国", region: "亚洲", rep: 50, salary: 3800, identity: "国际化新秀阵容" },
    { id: "mongolz", name: "The MongolZ", short: "MGL", country: "蒙古", region: "亚洲", rep: 76, salary: 11500, identity: "顶尖亚洲强队" },
    { id: "atox", name: "ATOX Esports", short: "ATOX", country: "蒙古", region: "亚洲", rep: 52, salary: 4200, identity: "蒙古新生力量" },
    { id: "astralis", name: "Astralis", short: "AST", country: "丹麦", region: "欧洲", rep: 83, salary: 19000, identity: "丹麦豪门体系" },
    { id: "heroic", name: "HEROIC", short: "HRC", country: "丹麦", region: "欧洲", rep: 74, salary: 13200, identity: "高强度团队 CS" },
    { id: "ecstatic", name: "ECSTATIC", short: "ECS", country: "丹麦", region: "欧洲", rep: 57, salary: 5400, identity: "丹麦新秀跳板" },
    { id: "spirit", name: "Team Spirit", short: "TS", country: "俄罗斯", region: "欧洲", rep: 94, salary: 31000, identity: "冠军级明星阵容" },
    { id: "aurora", name: "Aurora Gaming", short: "AUR", country: "塞尔维亚", region: "欧洲", rep: 68, salary: 9800, identity: "冲击顶级舞台" },
    { id: "9pandas", name: "9 Pandas", short: "9P", country: "俄罗斯", region: "欧洲", rep: 62, salary: 6800, identity: "东欧二线劲旅" },
    { id: "betboom", name: "BetBoom Team", short: "BB", country: "俄罗斯", region: "欧洲", rep: 73, salary: 12800, identity: "经验与火力兼备" },
    { id: "navi", name: "Natus Vincere", short: "NAVI", country: "乌克兰", region: "欧洲", rep: 94, salary: 32000, identity: "国际冠军豪门" },
    { id: "b8", name: "B8", short: "B8", country: "乌克兰", region: "欧洲", rep: 61, salary: 7000, identity: "青年才俊跳板" },
    { id: "passionua", name: "Passion UA", short: "PUA", country: "乌克兰", region: "欧洲", rep: 63, salary: 7200, identity: "快速上升的新军" },
    { id: "vitality", name: "Team Vitality", short: "VIT", country: "法国", region: "欧洲", rep: 96, salary: 35000, identity: "世界冠军热门" },
    { id: "3dmax", name: "3DMAX", short: "3DM", country: "法国", region: "欧洲", rep: 70, salary: 10500, identity: "法国核心班底" },
    { id: "genone", name: "GenOne", short: "G1", country: "法国", region: "欧洲", rep: 47, salary: 3400, identity: "法国青训项目" },
    { id: "furia", name: "FURIA", short: "FUR", country: "巴西", region: "美洲", rep: 86, salary: 22500, identity: "巴西头号旗帜" },
    { id: "pain", name: "paiN Gaming", short: "PNG", country: "巴西", region: "美洲", rep: 69, salary: 9900, identity: "美洲稳定强队" },
    { id: "legacy", name: "Legacy", short: "LEG", country: "巴西", region: "美洲", rep: 64, salary: 7300, identity: "巴西潜力阵容" },
    { id: "imperial", name: "Imperial Esports", short: "IMP", country: "巴西", region: "美洲", rep: 71, salary: 11200, identity: "老将带领的新军" },
    { id: "mibr", name: "MIBR", short: "MIBR", country: "巴西", region: "美洲", rep: 74, salary: 13500, identity: "巴西传统品牌" },
    { id: "nip", name: "Ninjas in Pyjamas", short: "NIP", country: "瑞典", region: "欧洲", rep: 78, salary: 15500, identity: "瑞典传奇俱乐部" },
    { id: "eyeballers", name: "EYEBALLERS", short: "EYE", country: "瑞典", region: "欧洲", rep: 47, salary: 3700, identity: "本土重建计划" },
    { id: "alliance", name: "Alliance", short: "ALL", country: "瑞典", region: "欧洲", rep: 54, salary: 4800, identity: "瑞典本土新阵容" },
    { id: "mouz", name: "MOUZ", short: "MOUZ", country: "德国", region: "欧洲", rep: 91, salary: 27500, identity: "青年体系标杆" },
    { id: "g2", name: "G2 Esports", short: "G2", country: "德国", region: "欧洲", rep: 92, salary: 30000, identity: "国际明星战队" },
    { id: "faze", name: "FaZe Clan", short: "FAZE", country: "美国", region: "欧洲", rep: 89, salary: 27000, identity: "经验丰富的国际纵队" },
    { id: "liquid", name: "Team Liquid", short: "TL", country: "美国", region: "美洲", rep: 84, salary: 22000, identity: "北美传统豪门" },
    { id: "complexity", name: "Complexity", short: "COL", country: "美国", region: "美洲", rep: 73, salary: 13800, identity: "北美竞争者" },
    { id: "big", name: "BIG", short: "BIG", country: "德国", region: "欧洲", rep: 72, salary: 12500, identity: "严谨战术体系" },
    { id: "gamerlegion", name: "GamerLegion", short: "GL", country: "德国", region: "欧洲", rep: 67, salary: 9000, identity: "新星孵化平台" },
    { id: "ence", name: "ENCE", short: "ENCE", country: "芬兰", region: "欧洲", rep: 69, salary: 10200, identity: "欧洲重建阵容" },
    { id: "saw", name: "SAW", short: "SAW", country: "葡萄牙", region: "欧洲", rep: 68, salary: 9200, identity: "葡萄牙核心班底" },
    { id: "parivision", name: "PARIVISION", short: "PARI", country: "塞尔维亚", region: "欧洲", rep: 71, salary: 11800, identity: "东欧上升力量" },
    { id: "nexus", name: "Nexus Gaming", short: "NXS", country: "罗马尼亚", region: "欧洲", rep: 50, salary: 3600, identity: "地区赛事常客" },
    { id: "sinners", name: "SINNERS Esports", short: "SIN", country: "捷克", region: "欧洲", rep: 59, salary: 5900, identity: "捷克本土劲旅" },
    { id: "m80", name: "M80", short: "M80", country: "美国", region: "美洲", rep: 66, salary: 8600, identity: "北美新生竞争者" },
    { id: "wildcard", name: "Wildcard", short: "WC", country: "美国", region: "美洲", rep: 63, salary: 7100, identity: "国际化北美阵容" },
    { id: "9z", name: "9z Team", short: "9Z", country: "阿根廷", region: "美洲", rep: 67, salary: 8900, identity: "南美联合阵容" },
    { id: "flyquest", name: "FlyQuest", short: "FLY", country: "澳大利亚", region: "亚洲", rep: 70, salary: 10400, identity: "大洋洲代表队伍" },
    { id: "rooster", name: "Rooster", short: "RST", country: "澳大利亚", region: "亚洲", rep: 51, salary: 3900, identity: "大洋洲地区新军" },
    { id: "falcons", name: "Team Falcons", short: "FLC", country: "沙特阿拉伯", region: "欧洲", rep: 95, salary: 34000, identity: "国际明星阵容" },
    { id: "fut", name: "FUT Esports", short: "FUT", country: "土耳其", region: "欧洲", rep: 74, salary: 13200, identity: "欧洲上升力量" },
    { id: "nrg", name: "NRG", short: "NRG", country: "美国", region: "美洲", rep: 69, salary: 9800, identity: "北美老牌俱乐部" },
    { id: "bestia", name: "BESTIA", short: "BST", country: "阿根廷", region: "美洲", rep: 62, salary: 7000, identity: "南美地区劲旅" },
    { id: "fluxo", name: "Fluxo", short: "FLX", country: "巴西", region: "美洲", rep: 64, salary: 7900, identity: "巴西新生竞争者" },
    { id: "nuclear", name: "Nuclear TigeRES", short: "NTR", country: "蒙古", region: "亚洲", rep: 60, salary: 6500, identity: "蒙古新锐阵容" },
    { id: "huns", name: "The Huns", short: "HUN", country: "蒙古", region: "亚洲", rep: 55, salary: 4800, identity: "亚洲地区赛常客" },
    { id: "chinggis", name: "Chinggis Warriors", short: "CW", country: "蒙古", region: "亚洲", rep: 52, salary: 4200, identity: "蒙古二线队伍" },
    { id: "fengda", name: "FengDa Gaming", short: "FD", country: "中国", region: "亚洲", rep: 49, salary: 3600, identity: "中国地区新军" },
    { id: "ctg", name: "Change The Game", short: "CTG", country: "中国", region: "亚洲", rep: 48, salary: 3500, identity: "中国新秀阵容" },
    { id: "eruption", name: "Eruption", short: "ERU", country: "蒙古", region: "亚洲", rep: 50, salary: 3800, identity: "蒙古地区赛常客" },
    { id: "alterego", name: "Alter Ego", short: "AE", country: "印度尼西亚", region: "亚洲", rep: 50, salary: 3900, identity: "东南亚竞争者" },
    { id: "mindfreak", name: "Mindfreak", short: "MFR", country: "澳大利亚", region: "亚洲", rep: 49, salary: 3700, identity: "大洋洲二线队伍" },
    { id: "sharks", name: "Sharks Esports", short: "SHK", country: "巴西", region: "美洲", rep: 58, salary: 5600, identity: "巴西地区劲旅" },
    { id: "red_canids", name: "RED Canids", short: "RED", country: "巴西", region: "美洲", rep: 56, salary: 5200, identity: "巴西传统阵容" },
    { id: "boss", name: "BOSS", short: "BOSS", country: "美国", region: "美洲", rep: 52, salary: 4700, identity: "北美地区竞争者" },
    { id: "nouns", name: "Nouns Esports", short: "NOUN", country: "美国", region: "美洲", rep: 57, salary: 5800, identity: "北美二线劲旅" }
  ];

  const VRS_SNAPSHOT_DATE = "2026-08-03";
  const VRS_SOURCE_URL = "https://github.com/ValveSoftware/counter-strike_regional_standings";
  const MAJOR_RULES_URL = "https://github.com/ValveSoftware/counter-strike_rules_and_regs/blob/main/major-supplemental-rulebook.md";
  const MAJOR_REGION_SLOTS = {
    label: "Valve 官方规则文件最近列示 · Winter 2025",
    Europe: { stage1: 6, stage2: 5, stage3: 5 },
    Americas: { stage1: 6, stage2: 2, stage3: 2 },
    Asia: { stage1: 4, stage2: 1, stage3: 1 }
  };
  const REGION_KEY = { "欧洲": "Europe", "美洲": "Americas", "亚洲": "Asia" };
  const INITIAL_VRS = {
    spirit: [2011, 1, 1], falcons: [1950, 2, 2], mouz: [1873, 3, 3], "9z": [1847, 4, 1], vitality: [1836, 5, 4],
    navi: [1802, 6, 5], legacy: [1773, 7, 2], furia: [1771, 8, 3], betboom: [1742, 9, 6], aurora: [1690, 10, 7],
    g2: [1688, 11, 8], parivision: [1685, 12, 9], faze: [1677, 13, 10], fut: [1663, 14, 11], mongolz: [1637, 15, 1],
    mibr: [1611, 16, 4], alliance: [1583, 17, 12], tyloo: [1565, 18, 2], astralis: [1555, 19, 13], b8: [1550, 20, 14],
    big: [1516, 21, 15], gamerlegion: [1504, 22, 16], pain: [1446, 26, 5], nip: [1444, 27, 20], lynn: [1431, 29, 3],
    heroic: [1427, 30, 21], "3dmax": [1410, 31, 22], liquid: [1397, 32, 7], eyeballers: [1385, 33, 23], m80: [1361, 36, 8],
    wildcard: [1352, 38, 9], flyquest: [1295, 41, 4], nuclear: [1259, 47, 5], nrg: [1228, 49, 11], sinners: [1196, 53, 39],
    bestia: [1177, 56, 14], fluxo: [1159, 57, 15], jijiehao: [1159, 58, 7], imperial: [1150, 59, 13], genone: [1095, 68, 50],
    huns: [1024, 87, 9], passionua: [1002, 94, 66], nexus: [913, 128, 91], ence: [898, 133, 95], ecstatic: [870, 144, 103],
    rare_atom: [854, 153, 13], rooster: [809, 171, 17]
  };

  const TOURNAMENTS = [
    { id: "cct_europe", name: "CCT Europe Series", code: "CCT EU", location: "欧洲 · 线上", difficulty: 61, prize: 50000, major: false, tier: "A", region: "欧洲", teamCount: 16, format: "swiss", directInvites: 8, qualifierWins: 2, vrsWeight: 0.55, image: "assets/events/cct-europe.svg", formatLabel: "16 队瑞士制 → 8 队单败淘汰", length: "正赛 3–8 场；预选最多另加 2 场" },
    { id: "cct_asia", name: "CCT Asia Series", code: "CCT AS", location: "亚洲 · 线上", difficulty: 58, prize: 50000, major: false, tier: "A", region: "亚洲", teamCount: 16, format: "swiss", directInvites: 8, qualifierWins: 2, vrsWeight: 0.52, image: "assets/events/cct-asia.svg", formatLabel: "16 队瑞士制 → 8 队单败淘汰", length: "正赛 3–8 场；预选最多另加 2 场" },
    { id: "cct_americas", name: "CCT South America Series", code: "CCT SA", location: "南美洲 · 线上", difficulty: 60, prize: 50000, major: false, tier: "A", region: "美洲", teamCount: 16, format: "swiss", directInvites: 8, qualifierWins: 2, vrsWeight: 0.52, image: "assets/events/cct-americas.svg", formatLabel: "16 队瑞士制 → 8 队单败淘汰", length: "正赛 3–8 场；预选最多另加 2 场" },
    { id: "challenger", name: "ESL Challenger League", code: "ECL", location: "地区联赛 · 线上", difficulty: 67, prize: 100000, major: false, tier: "A", region: null, teamCount: 16, format: "groups", directInvites: 8, qualifierWins: 2, vrsWeight: 0.65, image: "assets/events/esl-challenger.svg", formatLabel: "双败小组 → 6 队单败淘汰", length: "正赛 2–6 场；预选最多另加 2 场" },
    { id: "chengdu", name: "IEM Chengdu", code: "IEM CD", location: "中国 · 成都", difficulty: 78, prize: 300000, major: false, tier: "S", region: null, teamCount: 16, format: "groups", directInvites: 12, qualifierWins: 2, vrsWeight: 0.92, image: "assets/events/iem-chengdu.svg", formatLabel: "双败小组 → 6 队单败淘汰", length: "正赛 2–6 场；预选最多另加 2 场" },
    { id: "cologne", name: "IEM Cologne", code: "IEM CGN", location: "德国 · 科隆", difficulty: 91, prize: 1000000, major: false, tier: "S", region: null, teamCount: 24, format: "groups", directInvites: 16, qualifierWins: 2, vrsWeight: 1.2, image: "assets/events/iem-cologne.svg", formatLabel: "Play-in → 双败小组 → 6 队淘汰赛", length: "正赛 2–6 场；Play-in 最多另加 2 场" },
    { id: "epl", name: "ESL Pro League Katowice", code: "EPL", location: "波兰 · 卡托维兹", difficulty: 82, prize: 750000, major: false, tier: "S", region: null, teamCount: 24, format: "swiss", directInvites: 16, qualifierWins: 2, vrsWeight: 1.0, image: "assets/events/esl-pro-league.svg", formatLabel: "24 队分组赛 → 8 队单败淘汰", length: "正赛 3–8 场；预选最多另加 2 场" },
    { id: "blast", name: "BLAST Premier Open Porto", code: "BLAST", location: "葡萄牙 · 波尔图", difficulty: 84, prize: 400000, major: false, tier: "S", region: null, teamCount: 16, format: "groups", directInvites: 12, qualifierWins: 2, vrsWeight: 1.0, image: "assets/events/blast-open.svg", formatLabel: "双败小组 → 6 队单败淘汰", length: "正赛 2–6 场；预选最多另加 2 场" },
    { id: "blast_rivals", name: "BLAST Rivals Hong Kong", code: "RIVALS", location: "中国香港", difficulty: 90, prize: 1000000, major: false, tier: "S", region: null, teamCount: 8, format: "groups", directInvites: 8, qualifierWins: 2, vrsWeight: 1.16, image: "assets/events/blast-rivals.svg", formatLabel: "8 支世界强队 · 双败小组 → 6 队淘汰赛", length: "正赛 2–6 场 · 高密度强强对抗" },
    { id: "iem_dallas", name: "IEM Dallas", code: "IEM DAL", location: "美国 · 达拉斯", difficulty: 86, prize: 300000, major: false, tier: "S", region: null, teamCount: 16, format: "groups", directInvites: 12, qualifierWins: 2, vrsWeight: 1.02, image: "assets/events/iem-dallas.svg", formatLabel: "双败小组 → 6 队单败淘汰", length: "正赛 2–6 场；预选最多另加 2 场" },
    { id: "iem_rio", name: "IEM Rio", code: "IEM RIO", location: "巴西 · 里约热内卢", difficulty: 85, prize: 300000, major: false, tier: "S", region: null, teamCount: 16, format: "groups", directInvites: 12, qualifierWins: 2, vrsWeight: 1.0, image: "assets/events/iem-rio.svg", formatLabel: "双败小组 → 6 队单败淘汰", length: "正赛 2–6 场；预选最多另加 2 场" },
    { id: "iem_melbourne", name: "IEM Melbourne", code: "IEM MEL", location: "澳大利亚 · 墨尔本", difficulty: 82, prize: 250000, major: false, tier: "S", region: null, teamCount: 16, format: "groups", directInvites: 10, qualifierWins: 2, vrsWeight: 0.94, image: "assets/events/iem-melbourne.svg", formatLabel: "双败小组 → 6 队单败淘汰", length: "正赛 2–6 场；预选最多另加 2 场" },
    { id: "iem_krakow", name: "IEM Kraków", code: "IEM KRK", location: "波兰 · 克拉科夫", difficulty: 91, prize: 1000000, major: false, tier: "S", region: null, teamCount: 24, format: "groups", directInvites: 16, qualifierWins: 2, vrsWeight: 1.2, image: "assets/events/iem-krakow.svg", formatLabel: "Play-in → 双败小组 → 6 队淘汰赛", length: "正赛 2–6 场；Play-in 最多另加 2 场" },
    { id: "fissure", name: "FISSURE Playground", code: "FISSURE", location: "塞尔维亚 · 贝尔格莱德", difficulty: 82, prize: 1000000, major: false, tier: "S", region: null, teamCount: 16, format: "groups", directInvites: 10, qualifierWins: 2, vrsWeight: 0.98, image: "assets/events/fissure-playground.svg", formatLabel: "16 队小组赛 → 6 队淘汰赛", length: "正赛 2–6 场；预选最多另加 2 场" },
    { id: "ewc", name: "Esports World Cup 2026", code: "EWC", location: "法国 · 巴黎", difficulty: 89, prize: 1250000, major: false, tier: "S", region: null, teamCount: 16, format: "single", directInvites: 12, qualifierWins: 2, vrsWeight: 1.12, image: "assets/events/esports-world-cup.svg", formatLabel: "16 队单败淘汰 · 全程 BO3", length: "正赛 1–4 场；预选最多另加 2 场" },
    { id: "pgl", name: "PGL Major Singapore 2026", code: "MAJOR", location: "新加坡", difficulty: 94, prize: 1250000, major: true, tier: "M", region: null, teamCount: 32, format: "major", directInvites: 32, qualifierWins: 2, vrsWeight: 1.55, image: "assets/events/pgl-major.svg", formatLabel: "32 队 · 三阶段瑞士制 → 8 队单败淘汰", length: "按邀请阶段共 6–18 场；各瑞士阶段 3 胜晋级 / 3 负淘汰" },
    { id: "starladder", name: "StarLadder Budapest Major", code: "MAJOR", location: "匈牙利 · 布达佩斯", difficulty: 94, prize: 1250000, major: true, tier: "M", region: null, teamCount: 32, format: "major", directInvites: 32, qualifierWins: 2, vrsWeight: 1.55, image: "assets/events/starladder-budapest.svg", formatLabel: "32 队 · 三阶段瑞士制 → 8 队单败淘汰", length: "按邀请阶段共 6–18 场；各瑞士阶段 3 胜晋级 / 3 负淘汰" }
  ];

  const CCT_POSTER = {
    image: "assets/events/posters/cct-tour.webp",
    source: { publisher: "CCT", credit: "Champion of Champions Tour", url: "https://cctour.gg/" }
  };
  const EVENT_POSTERS = {
    cct_europe: CCT_POSTER,
    cct_asia: CCT_POSTER,
    cct_americas: CCT_POSTER,
    challenger: { image: "assets/events/posters/esl-challenger.webp", source: { publisher: "ESL", credit: "ESL Challenger League", url: "https://pro.eslgaming.com/csgo/ecl/" } },
    chengdu: { image: "assets/events/posters/iem-chengdu.webp", source: { publisher: "ESL", credit: "ESL / Helena Kristiansson", url: "https://pro.eslgaming.com/tour/cs/chengdu/" } },
    cologne: { image: "assets/events/posters/iem-cologne.webp", source: { publisher: "ESL", credit: "ESL / Adela Sznajder", url: "https://pro.eslgaming.com/tour/cs/cologne/" } },
    epl: { image: "assets/events/posters/esl-pro-league.webp", source: { publisher: "ESL", credit: "ESL Pro League", url: "https://pro.eslgaming.com/csgo/proleague/" } },
    blast: { image: "assets/events/posters/blast-open.webp", source: { publisher: "BLAST", credit: "BLAST Premier Open Porto 2026", url: "https://blast.tv/cs/tournaments/open-2026-season-2" } },
    ewc: { image: "assets/events/posters/esports-world-cup.webp", source: { publisher: "EWC", credit: "Esports World Cup 2026", url: "https://www.esportsworldcup.com/en/competitions/2026/cs2" } },
    pgl: { image: "assets/events/posters/pgl-major.webp", source: { publisher: "PGL", credit: "PGL Major Singapore 2026", url: "https://www.pglesports.com/cs2/pgl-major-singapore-2026/" } },
    starladder: { image: "assets/events/posters/starladder-budapest.webp", source: { publisher: "StarLadder", credit: "StarLadder Budapest Major 2025", url: "https://starladder.com/en/news/all-you-need-to-know-about-starladder-budapest-major-2025-playoffs" } }
  };
  TOURNAMENTS.forEach((tournament) => {
    const poster = EVENT_POSTERS[tournament.id];
    if (!poster) return;
    tournament.fallbackImage = tournament.image;
    tournament.image = poster.image;
    tournament.posterSource = poster.source;
  });

  const MAJOR_HOSTS = [
    { id: "jonkoping", city: "延雪平", country: "瑞典", code: "JÖN", history: "DreamHack Winter 2013" },
    { id: "katowice", city: "卡托维兹", country: "波兰", code: "KTW", history: "EMS One / IEM Katowice" },
    { id: "cologne", city: "科隆", country: "德国", code: "CGN", history: "ESL One Cologne 2014–2016" },
    { id: "cluj", city: "克卢日-纳波卡", country: "罗马尼亚", code: "CLJ", history: "DreamHack Cluj-Napoca 2015" },
    { id: "columbus", city: "哥伦布", country: "美国", code: "CMH", history: "MLG Columbus 2016" },
    { id: "atlanta", city: "亚特兰大", country: "美国", code: "ATL", history: "ELEAGUE Atlanta 2017" },
    { id: "krakow", city: "克拉科夫", country: "波兰", code: "KRK", history: "PGL Kraków 2017" },
    { id: "boston", city: "波士顿", country: "美国", code: "BOS", history: "ELEAGUE Boston 2018" },
    { id: "london", city: "伦敦", country: "英国", code: "LON", history: "FACEIT London 2018" },
    { id: "berlin", city: "柏林", country: "德国", code: "BER", history: "StarLadder Berlin 2019" },
    { id: "stockholm", city: "斯德哥尔摩", country: "瑞典", code: "STO", history: "PGL Stockholm 2021" },
    { id: "antwerp", city: "安特卫普", country: "比利时", code: "ANR", history: "PGL Antwerp 2022" },
    { id: "rio", city: "里约热内卢", country: "巴西", code: "RIO", history: "IEM Rio 2022" },
    { id: "paris", city: "巴黎", country: "法国", code: "PAR", history: "BLAST.tv Paris 2023" },
    { id: "copenhagen", city: "哥本哈根", country: "丹麦", code: "CPH", history: "PGL Copenhagen 2024" },
    { id: "shanghai", city: "上海", country: "中国", code: "SHA", history: "Perfect World Shanghai 2024" },
    { id: "austin", city: "奥斯汀", country: "美国", code: "AUS", history: "BLAST.tv Austin 2025" },
    { id: "budapest", city: "布达佩斯", country: "匈牙利", code: "BUD", history: "StarLadder Budapest 2025" },
    { id: "singapore", city: "新加坡", country: "新加坡", code: "SIN", history: "PGL Singapore 2026" }
  ];

  const AWARD_RIVALS = [
    { id: "zywoo", nickname: "ZywOo", country: "法国", role: "AWP", debut: 2018, primeStart: 2019, primeEnd: 2030, retire: 2034, peak: 110 },
    { id: "donk", nickname: "donk", country: "俄罗斯", role: "突破手", debut: 2023, primeStart: 2024, primeEnd: 2033, retire: 2038, peak: 111 },
    { id: "monesy", nickname: "m0NESY", country: "俄罗斯", role: "AWP", debut: 2022, primeStart: 2024, primeEnd: 2034, retire: 2039, peak: 109 },
    { id: "sh1ro", nickname: "sh1ro", country: "俄罗斯", role: "AWP", debut: 2019, primeStart: 2021, primeEnd: 2030, retire: 2035, peak: 105 },
    { id: "ropz", nickname: "ropz", country: "爱沙尼亚", role: "自由人", debut: 2015, primeStart: 2018, primeEnd: 2028, retire: 2033, peak: 104 },
    { id: "niko", nickname: "NiKo", country: "波黑", role: "步枪手", debut: 2013, primeStart: 2017, primeEnd: 2027, retire: 2031, peak: 104 },
    { id: "xantares", nickname: "XANTARES", country: "土耳其", role: "步枪手", debut: 2012, primeStart: 2018, primeEnd: 2027, retire: 2032, peak: 101 },
    { id: "frozen", nickname: "frozen", country: "斯洛伐克", role: "步枪手", debut: 2016, primeStart: 2020, primeEnd: 2030, retire: 2035, peak: 103 },
    { id: "b1t", nickname: "b1t", country: "乌克兰", role: "步枪手", debut: 2020, primeStart: 2021, primeEnd: 2031, retire: 2036, peak: 102 },
    { id: "flamez", nickname: "flameZ", country: "以色列", role: "突破手", debut: 2020, primeStart: 2023, primeEnd: 2031, retire: 2036, peak: 101 },
    { id: "xertion", nickname: "xertioN", country: "以色列", role: "突破手", debut: 2022, primeStart: 2024, primeEnd: 2032, retire: 2037, peak: 102 },
    { id: "torzsi", nickname: "torzsi", country: "匈牙利", role: "AWP", debut: 2021, primeStart: 2023, primeEnd: 2032, retire: 2037, peak: 100 },
    { id: "jimpphat", nickname: "Jimpphat", country: "芬兰", role: "自由人", debut: 2022, primeStart: 2025, primeEnd: 2033, retire: 2038, peak: 101 },
    { id: "senzu", nickname: "Senzu", country: "蒙古", role: "步枪手", debut: 2022, primeStart: 2025, primeEnd: 2034, retire: 2039, peak: 102 },
    { id: "kyousuke", nickname: "kyousuke", country: "俄罗斯", role: "步枪手", debut: 2025, primeStart: 2027, primeEnd: 2036, retire: 2041, peak: 107 },
    { id: "w0nderful", nickname: "w0nderful", country: "乌克兰", role: "AWP", debut: 2020, primeStart: 2024, primeEnd: 2032, retire: 2037, peak: 101 },
    { id: "heavygod", nickname: "HeavyGod", country: "以色列", role: "步枪手", debut: 2020, primeStart: 2024, primeEnd: 2033, retire: 2038, peak: 100 },
    { id: "malbsmd", nickname: "malbsMd", country: "危地马拉", role: "步枪手", debut: 2020, primeStart: 2024, primeEnd: 2032, retire: 2037, peak: 101 },
    { id: "makazze", nickname: "makazze", country: "科索沃", role: "步枪手", debut: 2023, primeStart: 2026, primeEnd: 2035, retire: 2040, peak: 102 },
    { id: "pr", nickname: "PR", country: "捷克", role: "步枪手", debut: 2024, primeStart: 2026, primeEnd: 2035, retire: 2040, peak: 101 },
    { id: "zweih", nickname: "zweih", country: "俄罗斯", role: "步枪手", debut: 2024, primeStart: 2027, primeEnd: 2036, retire: 2041, peak: 103 },
    { id: "tn1r", nickname: "tN1R", country: "白俄罗斯", role: "步枪手", debut: 2021, primeStart: 2025, primeEnd: 2034, retire: 2039, peak: 101 },
    { id: "molodoy", nickname: "molodoy", country: "哈萨克斯坦", role: "AWP", debut: 2022, primeStart: 2025, primeEnd: 2035, retire: 2040, peak: 102 },
    { id: "aster", nickname: "Aster", country: "中国", role: "AWP", debut: 2028, primeStart: 2030, primeEnd: 2038, retire: 2043, peak: 104, future: true },
    { id: "kairo", nickname: "Kairo", country: "丹麦", role: "指挥", debut: 2029, primeStart: 2031, primeEnd: 2039, retire: 2044, peak: 103, future: true },
    { id: "riven", nickname: "riven", country: "巴西", role: "突破手", debut: 2030, primeStart: 2032, primeEnd: 2040, retire: 2045, peak: 106, future: true },
    { id: "vex", nickname: "Vex", country: "美国", role: "步枪手", debut: 2031, primeStart: 2033, primeEnd: 2041, retire: 2046, peak: 104, future: true },
    { id: "lumen", nickname: "Lumen", country: "法国", role: "自由人", debut: 2032, primeStart: 2034, primeEnd: 2042, retire: 2047, peak: 105, future: true },
    { id: "nox", nickname: "nox", country: "蒙古", role: "步枪手", debut: 2033, primeStart: 2035, primeEnd: 2043, retire: 2048, peak: 107, future: true },
    { id: "mako", nickname: "Mako", country: "瑞典", role: "AWP", debut: 2034, primeStart: 2036, primeEnd: 2044, retire: 2049, peak: 105, future: true },
    { id: "sol", nickname: "Sol", country: "乌克兰", role: "步枪手", debut: 2035, primeStart: 2037, primeEnd: 2045, retire: 2050, peak: 106, future: true },
    { id: "nyx", nickname: "Nyx", country: "德国", role: "指挥", debut: 2036, primeStart: 2038, primeEnd: 2046, retire: 2051, peak: 104, future: true },
    { id: "reizu", nickname: "reizu", country: "日本", role: "突破手", debut: 2037, primeStart: 2039, primeEnd: 2047, retire: 2052, peak: 106, future: true },
    { id: "caelum", nickname: "Caelum", country: "加拿大", role: "AWP", debut: 2028, primeStart: 2031, primeEnd: 2040, retire: 2046, peak: 104, future: true },
    { id: "rook", nickname: "Rook", country: "英国", role: "自由人", debut: 2029, primeStart: 2032, primeEnd: 2041, retire: 2047, peak: 102, future: true },
    { id: "ibis", nickname: "Ibis", country: "埃及", role: "步枪手", debut: 2030, primeStart: 2033, primeEnd: 2042, retire: 2048, peak: 103, future: true },
    { id: "sable", nickname: "sable", country: "波兰", role: "突破手", debut: 2031, primeStart: 2034, primeEnd: 2043, retire: 2049, peak: 105, future: true },
    { id: "taiga", nickname: "taiga", country: "哈萨克斯坦", role: "AWP", debut: 2032, primeStart: 2035, primeEnd: 2044, retire: 2050, peak: 106, future: true },
    { id: "echo", nickname: "Echo", country: "印度尼西亚", role: "指挥", debut: 2033, primeStart: 2036, primeEnd: 2045, retire: 2051, peak: 103, future: true },
    { id: "flare", nickname: "flare", country: "美国", role: "步枪手", debut: 2034, primeStart: 2037, primeEnd: 2046, retire: 2052, peak: 105, future: true },
    { id: "yoru", nickname: "yoru", country: "日本", role: "自由人", debut: 2035, primeStart: 2038, primeEnd: 2047, retire: 2053, peak: 104, future: true },
    { id: "orbit", nickname: "Orbit", country: "南非", role: "AWP", debut: 2036, primeStart: 2039, primeEnd: 2048, retire: 2054, peak: 105, future: true },
    { id: "cinder", nickname: "cinder", country: "澳大利亚", role: "突破手", debut: 2037, primeStart: 2040, primeEnd: 2049, retire: 2055, peak: 106, future: true },
    { id: "vale", nickname: "Vale", country: "葡萄牙", role: "步枪手", debut: 2038, primeStart: 2041, primeEnd: 2050, retire: 2056, peak: 104, future: true },
    { id: "prism", nickname: "Prism", country: "新加坡", role: "指挥", debut: 2039, primeStart: 2042, primeEnd: 2051, retire: 2057, peak: 105, future: true }
  ];

  const CAREER_EVENTS = [
    {
      id: "late_practice", tag: "队内训练", title: "训练赛之后，服务器还亮着",
      desc: "教练认为你的最近状态有些停滞。今晚没有强制安排，你可以决定如何使用这段时间。",
      options: [
        { label: "加练两小时定位", hint: "稳健提升枪法，但消耗状态", risk: "稳定", effects: { mechanics: 2, fitness: -2 }, outcome: "准星移动变得更加干净。教练注意到了你的投入。" },
        { label: "复盘今天的全部回合", hint: "提升比赛阅读与战术理解", risk: "成长", effects: { gameSense: 2, teamwork: 1 }, outcome: "几个被忽略的回合细节，逐渐连成了一张完整地图。" },
        { label: "关机休息，恢复节奏", hint: "恢复身体与心理状态", risk: "恢复", effects: { fitness: 3, mentality: 1 }, outcome: "一夜完整的睡眠，让你在第二天重新找回节奏。" }
      ]
    },
    {
      id: "tactical_conflict", tag: "战术会议", title: "队内出现了两种声音",
      desc: "指挥希望放慢默认节奏，明星选手则坚持提高对抗频率。会议室陷入沉默，教练看向了你。",
      options: [
        { label: "支持指挥的体系", hint: "团队更稳定，可能压缩个人空间", risk: "体系", effects: { teamwork: 2, mechanics: -1, cohesion: 4 }, outcome: "团队很快统一了执行标准，训练赛的沟通明显清晰了。" },
        { label: "提出一套折中方案", hint: "考验比赛理解，有机会说服所有人", risk: "判断", effects: { gameSense: 2, mentality: 1, cohesion: 2 }, outcome: "你的中期转速方案通过了测试，双方都愿意继续尝试。" },
        { label: "避免站队，专注个人任务", hint: "保护个人状态，但队内关系降温", risk: "保守", effects: { mechanics: 1, cohesion: -3 }, outcome: "争论最终由教练结束，但有人记住了你的沉默。" }
      ]
    },
    {
      id: "viral_clutch", tag: "社交媒体", title: "一段 1v4 开始疯狂传播",
      desc: "你在训练平台打出的残局登上热门。品牌经理建议立刻直播回应，教练却担心注意力偏离比赛。",
      options: [
        { label: "开启直播，抓住热度", hint: "大幅增加关注，也会挤占训练时间", risk: "曝光", effects: { fame: 650, mechanics: -1, money: 3500 }, outcome: "直播观看人数创下你的新纪录，个人赞助也找上了门。" },
        { label: "发布片段后继续训练", hint: "平衡关注与竞技状态", risk: "均衡", effects: { fame: 260, mentality: 1 }, outcome: "片段保持着热度，而你没有打乱自己的训练计划。" },
        { label: "完全忽略社交媒体", hint: "专注比赛，错过流量窗口", risk: "专注", effects: { mechanics: 2, fame: -80 }, outcome: "热门很快过去，但下一场训练赛里你的手感依旧滚烫。" }
      ]
    },
    {
      id: "wrist", tag: "健康管理", title: "手腕传来不该有的酸痛",
      desc: "队医建议减少一周训练量。下一项赛事就在眼前，任何选择都会影响备战。",
      options: [
        { label: "接受完整康复方案", hint: "牺牲短期手感，保护职业寿命", risk: "长期", effects: { fitness: 6, mechanics: -2 }, outcome: "恢复过程令人焦躁，但疼痛彻底消失了。" },
        { label: "降低强度，边练边恢复", hint: "折中处理，结果相对可控", risk: "均衡", effects: { fitness: 2, mentality: -1 }, outcome: "你小心控制着训练量，最终赶上了赛前合练。" },
        { label: "打封闭，坚持原训练量", hint: "保持手感，但存在明显伤病风险", risk: "高风险", effects: { mechanics: 2, fitness: -7, mentality: -2 }, outcome: "你完成了训练，却在离开基地时再次感到刺痛。" }
      ]
    },
    {
      id: "rookie", tag: "阵容变化", title: "青训小将抢走了训练赛焦点",
      desc: "俱乐部刚提拔的年轻人连续打出亮眼数据。媒体开始猜测首发位置是否会发生变化。",
      options: [
        { label: "主动帮助他融入体系", hint: "增强团队关系，也展示领导力", risk: "团队", effects: { teamwork: 3, cohesion: 5, fame: 120 }, outcome: "年轻人公开感谢了你的帮助，队内竞争变得健康而直接。" },
        { label: "用加练捍卫自己的位置", hint: "提高个人能力，增加身体负荷", risk: "竞争", effects: { mechanics: 3, fitness: -3 }, outcome: "下一周的数据榜上，你重新回到了熟悉的位置。" },
        { label: "向经理人询问其他机会", hint: "提前试探转会市场，影响队内信任", risk: "激进", effects: { fame: 180, cohesion: -6, mentality: 1 }, outcome: "消息没有完全保密，更衣室里的气氛微妙了起来。" }
      ]
    },
    {
      id: "media", tag: "赛前采访", title: "记者把话筒递到了你面前",
      desc: "对手刚刚公开表示会轻松击败你们。直播仍在继续，所有人都在等你的回答。",
      options: [
        { label: "“服务器里见。”", hint: "简短回应，保持专注", risk: "冷静", effects: { mentality: 2, fame: 100 }, outcome: "这句回答迅速成了赛前预告片的结尾。" },
        { label: "正面回击对方", hint: "制造话题，同时增加比赛压力", risk: "火药味", effects: { fame: 400, mentality: -1 }, outcome: "对决热度被推到顶点，你必须在服务器里兑现这句话。" },
        { label: "称赞对手并谈论团队", hint: "体现职业态度，提高队内凝聚力", risk: "稳妥", effects: { teamwork: 2, cohesion: 3 }, outcome: "教练对你的处理非常满意，队友也放松了下来。" }
      ]
    },
    {
      id: "visa", tag: "突发状况", title: "签证审批卡在了最后一步",
      desc: "队伍可能要推迟启程。经理给出三个方案，而你是唯一需要作出个人取舍的选手。",
      options: [
        { label: "立刻转机前往第三国面签", hint: "花费高昂，但最大概率赶上赛事", risk: "成本", effects: { money: -4200, mentality: 1, cohesion: 3 }, outcome: "经历两次转机后，你终于拿到了签证，队友在登机口等着你。" },
        { label: "相信俱乐部继续协调", hint: "保留精力，但存在不确定性", risk: "未知", effects: { fitness: 2, mentality: -2 }, outcome: "审批在截止日前通过，只是等待消耗了不少情绪。" },
        { label: "建议启用替补，专注下一站", hint: "保护团队赛程，个人曝光受损", risk: "牺牲", effects: { teamwork: 3, fame: -160, cohesion: 4 }, outcome: "俱乐部公开称赞了你的职业态度，但你只能在基地观看比赛。" }
      ]
    },
    {
      id: "demo", tag: "对手研究", title: "分析师发现了一个细小习惯",
      desc: "下一场对手的主防选手在压力下会固定提前交烟。这个信息或许能被利用。",
      options: [
        { label: "围绕习惯设计整套假打", hint: "提升战术执行与团队理解", risk: "战术", effects: { gameSense: 3, teamwork: 1 }, outcome: "新战术在训练中屡屡奏效，分析师把它列为秘密武器。" },
        { label: "记住细节，临场自行判断", hint: "强化个人阅读，保留战术弹性", risk: "个人", effects: { gameSense: 2, mentality: 1 }, outcome: "你把这个细节牢牢记住，等待最合适的回合。" },
        { label: "不依赖单一倾向", hint: "维持原有体系与稳定性", risk: "稳定", effects: { cohesion: 2, fitness: 1 }, outcome: "队伍沿用成熟打法，把更多精力留给基本功。" }
      ]
    },
    {
      id: "language_bootcamp", tag: "海外生活", title: "战术板上写着另一种语言", foreignOnly: true,
      desc: "队友的报点越来越快，暂停时间里的战术讨论也不会刻意等你。语言教练给出了一份强化方案。",
      options: [
        { label: "参加密集语言课程", hint: "快速提高队内语言，短期训练时间减少", risk: "融入", effects: { language: 14, mechanics: -1, cohesion: 4 }, outcome: "几个星期后，你第一次不依赖翻译完整说完了残局思路。" },
        { label: "让队友陪你做报点训练", hint: "同步改善沟通与更衣室关系", risk: "团队", effects: { language: 8, teamwork: 2, cohesion: 6 }, outcome: "从地图报点到日常玩笑，你开始真正成为这支队伍的一员。" },
        { label: "只记住必要的战术词汇", hint: "保留个人训练量，但复杂沟通仍受限制", risk: "速成", effects: { language: 4, mechanics: 1, cohesion: -2 }, outcome: "基础执行不再出错，但战术变化太快时你仍会迟疑半拍。" }
      ]
    },
    {
      id: "scrim_day", tag: "日常训练赛", title: "今天安排了三场高强度训练赛",
      desc: "分析师希望从训练赛里解决图池问题。你可以把注意力放在弱图、招牌图，或与队友磨合新战术。",
      options: [
        { label: "主动要求练习最弱地图", hint: "弱图熟练度明显提高，短期数据可能难看", risk: "补短板", effects: { mapWeak: 4, mentality: 1, scrim: 3 }, outcome: "训练赛输得并不好看，但你终于理解了几个一直逃避的枪位。" },
        { label: "在招牌图保持比赛手感", hint: "强化个人优势并增加教练信任", risk: "强项", effects: { mapStrong: 2, mechanics: 2, scrim: 3 }, outcome: "你在最熟悉的地图连续拿下多杀，首发位置更加稳固。" },
        { label: "完全服从新战术角色", hint: "牺牲数据换取阵容默契和战术深度", risk: "体系", effects: { teamwork: 3, cohesion: 5, scrim: 3 }, outcome: "新战术第一次顺畅运转，教练把录像保存进了正式比赛方案。" }
      ]
    },
    {
      id: "media_day", tag: "媒体活动", title: "俱乐部为你安排了一整天媒体行程",
      desc: "赞助商拍摄、长篇采访和正常训练在时间上发生冲突。经纪人提醒你，商业价值同样会影响下一份合同。",
      options: [
        { label: "完成赞助商广告拍摄", hint: "获得直接商业收入和影响力，消耗竞技状态", risk: "商业", effects: { sponsor: 6500, influence: 7, fame: 420, fitness: -2 }, outcome: "广告上线后反响很好，你的个人合作报价开始增加。" },
        { label: "接受深度人物采访", hint: "提高公众认知与粉丝黏性", risk: "形象", effects: { influence: 5, fame: 700, mentality: 1 }, outcome: "采访让观众第一次看见赛场之外的你，社交平台关注快速增长。" },
        { label: "取消活动，留在训练室", hint: "保护竞技表现，但会影响商务关系", risk: "专注", effects: { mechanics: 2, influence: -2, cohesion: -1 }, outcome: "品牌方略感失望，但教练认可你对下一场比赛的投入。" }
      ]
    }
  ];

  const EASTER_EGGS = [
    {
      id: "cs3", tag: "世界级彩蛋", title: "CS3 发布",
      desc: "没有测试服、没有预告片，CS3 在凌晨突然替换了正式客户端。全世界必须重新学习移动、枪械与信息判断。所有超过 80 的枪法和意识都会先被压回 80。",
      minSeason: 3, weight: 0.35,
      options: [
        { label: "立刻开始新引擎魔鬼训练", hint: "在数值重置后抢先重新建立枪感", risk: "重学游戏", effects: { mechanics: 3, gameSense: 1, fitness: -4 }, special: "cs3_grind", outcome: "你几乎住进了新版本服务器。旧肌肉记忆消失了，但新的射击节奏开始成形。" },
        { label: "研究物理、声音和新烟雾", hint: "优先恢复意识与地图理解", risk: "版本理解", effects: { gameSense: 3, mapWeak: 4, teamwork: 1 }, special: "cs3_lab", outcome: "当其他人还在抱怨手感时，你已经整理出第一份新版本战术笔记。" },
        { label: "先观察顶级队伍如何适应", hint: "保护身体和心态，但竞技恢复较慢", risk: "谨慎", effects: { fitness: 5, mentality: 2 }, special: "cs3_wait", outcome: "你没有成为最早的实验者，却避开了大量错误训练形成的坏习惯。" }
      ]
    },
    {
      id: "magic_prodigy", tag: "世界级彩蛋", title: "魔童降世",
      desc: "俄罗斯不知道怎么又跳出一个天才枪男。没有人知道他从哪里来，只知道训练赛结束后，所有职业选手都开始偷偷下载他的录像。",
      minSeason: 2, weight: 0.45,
      options: [
        { label: "逐帧研究魔童的第一视角", hint: "提升意识，并看清新时代对枪方式", risk: "学习", effects: { gameSense: 3, mentality: 1 }, special: "study_magic", outcome: "那些看似不讲道理的击杀背后，逐渐显露出可以学习的准星与节奏逻辑。" },
        { label: "主动约一场高强度对练", hint: "可能被打碎，也可能突破枪法瓶颈", risk: "正面对抗", effects: { mechanics: 3, fitness: -2, mentality: -1 }, special: "duel_magic", outcome: "比分非常难看，但你第一次真实感受到了下一代选手的对抗速度。" },
        { label: "不追逐天才，继续完善体系", hint: "强化团队能力，不与纯枪法赛跑", risk: "体系", effects: { teamwork: 3, cohesion: 3 }, special: "ignore_magic", outcome: "个人天赋可以摧毁一个回合，完整体系仍然可以赢下一场系列赛。" }
      ]
    },
    {
      id: "snake_brothers", tag: "世界级彩蛋", title: "蛇鼠兄弟",
      desc: "队友一边在镜头前承诺共同进退，一边暗中接触其他俱乐部。阵容计划和战术资料全部泄露，队伍 VRS 积分减半，隐藏实力也会长期受损。",
      minSeason: 2, weight: 0.4,
      options: [
        { label: "公开证据，要求立即清理阵容", hint: "获得舆论支持，但赛季内关系彻底破裂", risk: "摊牌", effects: { influence: 6, mentality: -2, cohesion: -5 }, special: "expose_traitor", outcome: "俱乐部终止了涉事队员的比赛资格，公众站在你们一边，但阵容只剩一地碎片。" },
        { label: "让教练先维持剩余赛季", hint: "尝试恢复部分默契，接受短期不稳定", risk: "止损", effects: { teamwork: 2, cohesion: 10 }, special: "stabilize_roster", outcome: "没有人真正忘记背叛，但至少剩下的人愿意把这个赛季打完。" },
        { label: "让经纪人提前寻找下一站", hint: "下一次转会窗口更偏向本国或二线核心位置", risk: "离队准备", effects: { mentality: 2, cohesion: -3 }, special: "prepare_exit", outcome: "你继续参加比赛，同时把职业未来从这支队伍身上悄悄移开。" }
      ]
    },
    {
      id: "valve_time", tag: "版本彩蛋", title: "V 社时间",
      desc: "官方说更新下周发布，结果拖了三个月，最后在大赛前夜突然上线。接下来两场比赛的模型差距会被压缩，高意识选手拥有额外适应优势。",
      weight: 1,
      options: [
        { label: "通宵阅读全部更新细节", hint: "提高版本理解，牺牲身体恢复", risk: "抢版本", effects: { gameSense: 2, fitness: -3 }, special: "patch_study", outcome: "你的桌面上堆满了对比录像，至少新版本的第一场不会完全依赖猜测。" },
        { label: "用训练赛直接寻找答案", hint: "增加枪法与训练量，也会消耗状态", risk: "实战", effects: { mechanics: 2, scrim: 3, fitness: -2 }, special: "patch_scrim", outcome: "补丁说明没有写出的东西，在连续训练赛里暴露得更加清楚。" },
        { label: "保持原体系，只做必要调整", hint: "团队更稳定，版本上限较低", risk: "保守", effects: { teamwork: 2, cohesion: 3 }, special: "patch_safe", outcome: "你们没有发明新战术，却避免了因为过度反应而把原体系全部推翻。" }
      ]
    },
    {
      id: "smoke_person", tag: "版本彩蛋", title: "烟里真有人",
      desc: "更新后的烟雾偶尔会露出奇怪的人形轮廓。全世界开始研究混烟、光影与提前枪，下一阶段的地图准备将真实影响比赛胜率。",
      weight: 1,
      options: [
        { label: "建立烟雾实验室", hint: "本赛季获得持续的赛前准备加成", risk: "研究", effects: { gameSense: 2, mapStrong: 2 }, special: "smoke_lab", outcome: "你们记录了上百种光照与烟雾组合，混烟不再只是运气。" },
        { label: "专练穿烟后的第二枪", hint: "强化枪法，但没有团队级准备收益", risk: "个人", effects: { mechanics: 3, mentality: 1 }, special: "smoke_aim", outcome: "第一枪暴露位置之后，你的第二枪仍然快得让人无法还手。" },
        { label: "要求赛事方等待修复", hint: "保护心态，却错过版本窗口", risk: "抗议", effects: { influence: 3, mentality: 1 }, special: "smoke_protest", outcome: "问题最终被记录进赛事报告，但其他队伍仍然在服务器里继续研究。" }
      ]
    },
    {
      id: "coach_play", tag: "阵容彩蛋", title: "教练，我想打 CS",
      desc: "一名队员临时无法参赛，教练只能亲自注册成为替补。下一场比赛将带着教练上阵，你必须决定怎样围绕这个特殊第五人比赛。",
      weight: 1,
      options: [
        { label: "我来承担全部主力输出", hint: "下一场个人影响显著增加，压力也更高", risk: "强行 Carry", effects: { mechanics: 1, mentality: -1 }, special: "coach_carry", outcome: "战术被压缩到最简单的版本：把资源交给你，然后尽可能活到回合结束。" },
        { label: "用一周帮教练恢复枪感", hint: "提高团队与教练潜力，获得稳定比赛加成", risk: "共同准备", effects: { teamwork: 3, fitness: -2 }, special: "coach_training", outcome: "教练的准星依旧不像职业选手，但至少每颗道具和补枪路线都经过了排练。" },
        { label: "改成极端道具保护体系", hint: "依靠比赛阅读减少正面对枪", risk: "战术保护", effects: { gameSense: 2, cohesion: 2 }, special: "coach_system", outcome: "教练几乎没有被要求主动对枪，整套体系都在延迟并交换资源。" }
      ]
    },
    {
      id: "internet_cafe", tag: "新秀彩蛋", title: "网吧里有高人",
      desc: "训练赛被一个没有职业资料的年轻替补打出 35 杀。这个选择会决定他以怎样的姿态进入职业圈，并在未来年度榜单中与你竞争。",
      weight: 0.85,
      options: [
        { label: "推荐俱乐部立刻签下他", hint: "获得影响力，新秀会在较健康的环境成长", risk: "伯乐", effects: { influence: 5, teamwork: 2 }, special: "cafe_recommend", outcome: "俱乐部给了他第一份试训合同，采访里他始终记得是谁打开了那扇门。" },
        { label: "约一场公开单挑", hint: "提升关注和枪法，新秀也会因此迅速成名", risk: "对决", effects: { mechanics: 2, fame: 500 }, special: "cafe_duel", outcome: "比赛片段迅速传播。无论比分如何，职业圈都记住了这个陌生 ID。" },
        { label: "认为只是训练赛偶然发挥", hint: "没有即时成本，但他可能带着更高峰值回来", risk: "错过", effects: { mentality: 1 }, special: "cafe_dismiss", outcome: "几个月后，同一个 ID 开始出现在越来越多顶级选手的天梯记录里。" }
      ]
    },
    {
      id: "last_dance", tag: "老将彩蛋", title: "最后一舞",
      desc: "几名淡出一线的老将组建本国阵容，公开宣布再冲一次 Major。你收到了一条没有高薪承诺、只有首发位置和完整话语权的邀请。",
      minAge: 29, weight: 1.2,
      options: [
        { label: "把下一份合同留给最后一舞", hint: "转会市场优先本国与二线队，获得老将核心位置", risk: "生涯路线", effects: { mentality: 3, influence: 4 }, special: "join_last_dance", outcome: "你答应在下一个窗口认真考虑这支阵容。奖杯不是承诺，属于老将的最后舞台才是。" },
        { label: "为他们提供战术与训练帮助", hint: "提高教练潜力和影响力，不改变当前合同路线", risk: "幕后支持", effects: { gameSense: 2, teamwork: 2 }, special: "support_last_dance", outcome: "几次训练之后，他们开始把你视为未来可以站在教练席的人。" },
        { label: "祝福他们，继续留在一线竞争", hint: "保持当前路线并强化竞技心态", risk: "继续争冠", effects: { mentality: 3, mechanics: 1 }, special: "decline_last_dance", outcome: "你还没有准备把自己的名字写进怀旧名单。至少这个赛季不是。" }
      ]
    },
    {
      id: "reverse_superteam", tag: "转会彩蛋", title: "反向银河战舰",
      desc: "一支由明星堆成的豪门因为角色冲突突然解体。该队 VRS 与隐藏实力会大幅下跌，未来两个转会窗则会放宽高水平俱乐部的市场门槛。",
      minSeason: 2, weight: 0.8,
      options: [
        { label: "让经纪人追踪全部自由人", hint: "提高未来转会市场上限", risk: "市场机会", effects: { influence: 2 }, special: "track_free_agents", outcome: "经纪人整理出一张复杂的人员流动图，很多原本不可能的阵容突然有了空间。" },
        { label: "趁乱强化自己在队内的位置", hint: "增加团队与阵容默契", risk: "稳定", effects: { teamwork: 2, cohesion: 5 }, special: "superteam_stability", outcome: "外界都在追逐明星，你们反而利用稳定阵容完成了一轮完整训练。" },
        { label: "公开表示明星阵容也需要体系", hint: "增加影响力，可能得罪部分选手", risk: "发言", effects: { influence: 5, fame: 250 }, special: "superteam_comment", outcome: "这句话登上了头条，也成为之后每次豪门输比赛时都会被引用的句子。" }
      ]
    },
    {
      id: "sticker_money", tag: "商业彩蛋", title: "贴纸比奖金还贵",
      desc: "你的 Major 签名因为写得太怪、印刷偏色或者长得像某种动物突然爆火。市场价格开始脱离比赛成绩。",
      weight: 1,
      options: [
        { label: "趁热推出完整个人周边", hint: "获得大量商业收入和粉丝", risk: "变现", effects: { sponsor: 18000, fame: 900, influence: 5 }, special: "sticker_brand", outcome: "贴纸、鼠标垫和卫衣在一周内售罄，你第一次感到商业收入真的可以超过奖金。" },
        { label: "把版税投入青训和本国社区", hint: "收入较少，大幅提升本国影响力", risk: "回馈", effects: { sponsor: 7000, influence: 10, teamwork: 2 }, special: "sticker_academy", outcome: "新的训练室开张时，墙上贴着那张所有人都认识的奇怪签名。" },
        { label: "拒绝炒作，专注下一场比赛", hint: "保护竞技状态，但错过商业窗口", risk: "竞技优先", effects: { mentality: 2, mechanics: 1 }, special: "sticker_focus", outcome: "贴纸价格最终回落，而你没有让它改变自己的训练计划。" }
      ]
    },
    {
      id: "six_languages", tag: "沟通彩蛋", title: "五个人说六种语言",
      desc: "翻译把“守 B”听成了“冲 A”，训练赛里五个人执行了六套战术。阵容默契会先下降，语言能力和选择决定能恢复多少。",
      weight: 1,
      options: [
        { label: "建立统一的英语短指令表", hint: "提升英语与长期沟通，完整恢复默契", risk: "标准化", effects: { english: 8, teamwork: 2, cohesion: 8 }, special: "language_protocol", outcome: "所有复杂信息被压缩成几十条明确短句，至少不会再有人把 B 听成 A。" },
        { label: "由我承担队内实时翻译", hint: "提高影响力和团队，但增加比赛负担", risk: "多线程", effects: { language: 8, teamwork: 3, fitness: -2, cohesion: 5 }, special: "language_captain", outcome: "你的麦克风从此比其他人更忙，但混乱终于开始变成可以控制的信息流。" },
        { label: "减少沟通，使用固定战术", hint: "短期稳定，体系深度下降", risk: "简化", effects: { cohesion: 3, gameSense: -1, mentality: 1 }, special: "language_simple", outcome: "战术选择变少了，至少每个人终于出现在同一个包点。" }
      ]
    },
    {
      id: "lost_playbook", tag: "战术彩蛋", title: "战术本落在出租车上了",
      desc: "教练把包含全部战术的平板遗失在举办城市。下一场比赛默认承受战术泄露惩罚，选择可以改变惩罚幅度。",
      weight: 0.9,
      options: [
        { label: "连夜重做一套简化战术", hint: "清除大部分比赛惩罚，消耗身体状态", risk: "紧急重构", effects: { gameSense: 2, teamwork: 1, fitness: -4 }, special: "rebuild_playbook", outcome: "新战术不够华丽，但所有关键默认和残局规则都换了编号。" },
        { label: "临时更换重点地图", hint: "训练弱图并保留少量泄露惩罚", risk: "换图", effects: { mapWeak: 5, mentality: 1 }, special: "change_playbook_map", outcome: "对手拿到了旧战术，却发现你们把比赛带到了完全不同的地图区域。" },
        { label: "假装不知情，反向利用旧战术", hint: "结果存在波动，可能获得正向心理博弈", risk: "套中套", effects: { mentality: 2 }, special: "playbook_mindgame", outcome: "你们故意露出熟悉的开局，真正的答案藏在回合最后二十秒。" }
      ]
    },
    {
      id: "system_update", tag: "赛场彩蛋", title: "决赛前的系统更新",
      desc: "比赛电脑在热身时开始安装系统更新。下一场比赛的特殊加成将由你的处理方式直接写入公开胜率模型。",
      weight: 1,
      options: [
        { label: "借用陌生外设立刻热身", hint: "没有设备风险，但枪感略受影响", risk: "借设备", effects: { mentality: 1, mechanics: -1 }, special: "borrow_setup", outcome: "握感完全陌生，至少服务器里还有足够时间重新找一次准星。" },
        { label: "等待更新完成，坚持自己的设置", hint: "随机获得大幅正面或负面比赛加成", risk: "设备赌博", effects: { mentality: -1 }, special: "system_gamble", outcome: "进度条终于走完。现在只能相信所有设置真的和昨天一样。" },
        { label: "完全不热身直接上场", hint: "保留枪法数值，下一场慢热", risk: "冷启动", effects: { fitness: 2 }, special: "cold_start", outcome: "第一回合就是今天的第一颗子弹。手感会不会来，只能在比赛中回答。" }
      ]
    },
    {
      id: "chosen_server", tag: "新秀彩蛋", title: "服务器选中的人",
      desc: "天梯突然出现一个没有头像、没有战队、每天只打三场却从不失误的账号。他将成为未来年度竞争者，调查方式决定其出道速度与峰值。",
      minSeason: 2, weight: 0.75,
      options: [
        { label: "让分析师追踪他的全部录像", hint: "提前了解对手，并让新人正常成长", risk: "侦察", effects: { gameSense: 2 }, special: "trace_chosen", outcome: "分析师终于确认那不是外挂，而是一个训练方式完全不同的年轻选手。" },
        { label: "邀请他参加封闭训练赛", hint: "提高队伍训练质量，也会加速他的出道", risk: "邀请", effects: { scrim: 4, mechanics: 1, teamwork: 1 }, special: "scrim_chosen", outcome: "他第一次进入职业训练服务器，随后再也没有从球探名单上消失。" },
        { label: "公开质疑这个账号是否真实", hint: "获得关注，但新人将带着更强敌意登场", risk: "质疑", effects: { fame: 450, influence: -2 }, special: "question_chosen", outcome: "质疑让这个账号一夜成名。后来每一次击杀，都像是在回复你的那条动态。" }
      ]
    },
    {
      id: "everyone_calls", tag: "战术彩蛋", title: "全员指挥",
      desc: "指挥的麦克风在关键比赛前彻底损坏，剩下四个人同时开始报战术。下一场比赛会得到与枪法无关的临场指挥修正。",
      weight: 1,
      options: [
        { label: "由我接管全部临场指挥", hint: "加成取决于你的意识和团队能力", risk: "接管", effects: { gameSense: 1, mentality: 1 }, special: "take_calling", outcome: "频道终于安静下来。所有人都在等你说出回合开始后的第一条指令。" },
        { label: "指定队内第二指挥单独发言", hint: "获得稳定的小幅比赛加成", risk: "秩序", effects: { teamwork: 2, cohesion: 2 }, special: "appoint_caller", outcome: "不一定是最聪明的答案，但至少全队只执行一个答案。" },
        { label: "放弃复杂战术，见人就打", hint: "依靠枪法获得高风险比赛修正", risk: "火力解决", effects: { mechanics: 2, gameSense: -1 }, special: "all_aim", outcome: "地图上的箭头和道具表全部被关掉，剩下的计划只有赢下第一枪。" }
      ]
    },
    {
      id: "old_mouse", tag: "外设彩蛋", title: "祖传外设",
      desc: "你在仓库里找到一只十年前的旧鼠标，换上后训练赛突然手感爆炸。继续使用会在下一场产生已经确定但不可预知的设备结果。",
      weight: 1,
      options: [
        { label: "正式比赛继续使用旧鼠标", hint: "下一场可能手感爆炸，也可能中途失灵", risk: "赌博", effects: { mechanics: 2 }, special: "old_mouse_gamble", outcome: "设备经理把备用鼠标放在桌下。不到比赛结束，没人知道今天会是哪一种结局。" },
        { label: "复制设置到可靠的新鼠标", hint: "获得较小但稳定的枪法收益", risk: "稳妥", effects: { mechanics: 1, mentality: 1 }, special: "copy_mouse", outcome: "那种神奇手感没有完全复现，但至少不会因为一根老化线材输掉残局。" },
        { label: "把旧鼠标放进个人陈列柜", hint: "转化为商业与粉丝故事", risk: "收藏", effects: { fame: 350, influence: 3 }, special: "retire_mouse", outcome: "它没有再连接比赛电脑，却成了每次媒体参观都会拍摄的展品。" }
      ]
    },
    {
      id: "lucky_seats", tag: "玄学彩蛋", title: "玄学座位",
      desc: "队伍发现只要保持某个座位顺序就从没输过。你们必须决定把它当成心理工具，还是在迷信形成前主动打破。",
      weight: 1,
      options: [
        { label: "以后严格保持幸运座位", hint: "提高心态和下一场稳定性", risk: "相信玄学", effects: { mentality: 3, cohesion: 2 }, special: "keep_lucky_seats", outcome: "设备经理开始提前在每张桌子上贴名字，没人愿意成为主动打破连胜的人。" },
        { label: "训练赛随机换座，消除依赖", hint: "短期不适，长期团队更加稳定", risk: "破除迷信", effects: { teamwork: 2, mentality: 1, cohesion: -1 }, special: "break_lucky_seats", outcome: "第一天所有人都觉得不对劲，几场训练后，注意力终于重新回到比赛本身。" },
        { label: "让赞助商把玄学做成节目", hint: "获得收入和关注，不影响竞技模型", risk: "节目效果", effects: { sponsor: 6000, fame: 500 }, special: "sell_lucky_seats", outcome: "观众开始在每场比赛前讨论座位，而俱乐部得到了一条新的商业内容。" }
      ]
    },
    {
      id: "public_review", tag: "战术彩蛋", title: "公开处刑式复盘",
      desc: "教练误把内部复盘直播到了公开频道，整套战术被观众和对手看完。下一场比赛先承受严重准备惩罚，再由选择决定能否追回。",
      weight: 0.85,
      options: [
        { label: "立即删除录像并更换全部暗号", hint: "大幅降低泄露惩罚，消耗训练与身体", risk: "紧急处理", effects: { teamwork: 2, fitness: -3 }, special: "delete_review", outcome: "录像已经有人保存，但至少所有临场暗号和默认顺序都已被替换。" },
        { label: "将事故包装成公开战术课", hint: "获得大量影响力，保留中等比赛惩罚", risk: "顺势而为", effects: { influence: 8, fame: 650 }, special: "monetize_review", outcome: "原本的事故成了热门教学内容，代价是每个对手都认真做完了这节课。" },
        { label: "故意继续使用被公开的开局", hint: "进行高风险心理博弈", risk: "反向针对", effects: { mentality: 2 }, special: "fake_public_review", outcome: "对手确信自己知道答案，而你们把真正的变化藏在最熟悉的开局之后。" }
      ]
    },
    {
      id: "comment_mvp", tag: "社区彩蛋", title: "HLTV 评论区 MVP",
      desc: "你整届赛事数据平平，却因为一张表情包、离谱采访或赛后动作成为评论区唯一话题。不会获得正式 MVP，但热度会真实进入商业与转会模型。",
      weight: 1,
      options: [
        { label: "亲自下场回复评论区", hint: "大幅增加粉丝与影响力，略微影响训练", risk: "冲浪", effects: { fame: 850, influence: 6, mechanics: -1 }, special: "reply_comments", outcome: "你的每条回复都被截图转发，经纪人的商务邮箱开始不停刷新。" },
        { label: "把表情包印成限量周边", hint: "获得商业收入和稳定关注", risk: "周边", effects: { sponsor: 9000, fame: 450, influence: 3 }, special: "comment_merch", outcome: "比赛数据很快会被忘记，那张表情却出现在了无数观众的头像里。" },
        { label: "关闭社交媒体继续训练", hint: "错过流量，保护竞技状态", risk: "断网", effects: { mechanics: 2, mentality: 1, fame: -100 }, special: "ignore_comments", outcome: "热度在几周后过去，而你的下一场比赛明显比评论区记得更久。" }
      ]
    },
    {
      id: "split_schedule", tag: "赛程彩蛋", title: "赛程发生了裂变",
      desc: "两个重要赛事被安排在同一时间。你可以替换下一站、追逐奖金，或者让俱乐部拆分阵容并在本赛季增加一项真实可比赛的赛事。",
      minSeason: 2, weight: 0.7,
      options: [
        { label: "优先参加 VRS 权重更高的赛事", hint: "下一项赛事替换为 BLAST Rivals", risk: "排名", effects: { mentality: 1 }, special: "schedule_vrs", outcome: "俱乐部放弃另一张邀请函，把全部准备时间押在世界强队最集中的舞台。" },
        { label: "选择奖金更高的裂变天地", hint: "下一项赛事替换为 FISSURE Playground", risk: "奖金", effects: { influence: 2 }, special: "schedule_money", outcome: "奖金池和出场机会最终说服了管理层，赛程被重新指向贝尔格莱德。" },
        { label: "主力与替补拆开，两边都打", hint: "本赛季增加一项完整赛事，同时降低默契与状态", risk: "超载", effects: { cohesion: -5, fitness: -3 }, special: "schedule_both", outcome: "俱乐部同时接受两张邀请函。航班、替补和训练计划从这一刻开始全部重叠。" }
      ]
    }
  ];

  const el = (id) => document.getElementById(id);
  const root = el("game-root");
  const toastEl = el("toast");
  const restartButton = el("restart-button");
  let toastTimer = null;
  let gameRuntime = null;
  let state = createDefaultState();

  function createDefaultState() {
    return {
      version: 4,
      phase: "welcome",
      profile: { nickname: "", country: null, role: null },
      stats: { mechanics: 50, gameSense: 50, teamwork: 50, mentality: 50, fitness: 54 },
      languages: {},
      mapSkills: {},
      fame: 0,
      abilities: [],
      unlockedCombos: [],
      preferences: { vetoMode: "manual", pace: "balanced" },
      development: { points: 2, potential: {}, completed: [], seasonStartStats: {} },
      draftRound: 0,
      draftChoices: [],
      year: CURRENT_YEAR,
      age: 18,
      season: 1,
      teamId: null,
      contract: null,
      currentEvent: null,
      seasonQueue: [],
      vrs: null,
      teamForm: {},
      world: { teamStrengthEffects: [], prospects: [], cs3TransitionUntil: 0, marketShockUntil: 0 },
      career: {
        money: 0,
        earnings: 0,
        sponsorIncome: 0,
        influence: 0,
        scrims: 0,
        fans: 0,
        cohesion: 52,
        titles: [],
        awards: [],
        history: [],
        teamHistory: [],
        seasonHistory: [],
        maps: 0,
        bestRating: 0,
        peakOverall: 0,
        peakVrsRank: 999,
        peakVrsPoints: 0,
        injuryWarnings: 0,
        rehabCount: 0,
        awardHistory: [],
        majorVenueHistory: [],
        easterEggs: [],
        coachingPotential: 0,
        lateCareerPath: null,
        endRole: null,
        finalSeason: false
      },
      seasonData: null,
      retiredReason: null
    };
  }

  function clamp(value, min = 1, max = 99) { return Math.max(min, Math.min(max, Math.round(value))); }
  function randomBetween(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }
  function sample(items) { return items[Math.floor(Math.random() * items.length)]; }
  function shuffle(items) { return [...items].sort(() => Math.random() - 0.5); }
  function unique(items) { return [...new Set(items)]; }
  function esc(value) {
    return String(value ?? "").replace(/[&<>'"]/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }[char]));
  }
  function formatMoney(value) {
    const amount = Math.max(0, Math.round(value || 0));
    if (amount >= 1000000) return `$${(amount / 1000000).toFixed(2)}M`;
    if (amount >= 1000) return `$${Math.round(amount / 1000)}K`;
    return `$${amount}`;
  }
  function country() { return COUNTRIES.find((item) => item.id === state.profile.country); }
  function role() { return ROLES.find((item) => item.id === state.profile.role); }
  function team() { return TEAMS.find((item) => item.id === state.teamId); }
  function hasPerk(id) { return state.abilities.some((abilityId) => ABILITIES.find((a) => a.id === abilityId)?.perk === id); }

  function activeAbilityCombos() {
    const owned = new Set(state.abilities || []);
    return ABILITY_COMBOS.filter((combo) => combo.requires.every((id) => owned.has(id)));
  }

  function hasCombo(id) { return activeAbilityCombos().some((combo) => combo.id === id); }

  function abilityRoleLabel(ability) {
    if (!ability?.roles?.length) return "通用";
    const names = ability.roles.map((id) => ROLES.find((item) => item.id === id)?.name).filter(Boolean);
    return ability.roles.includes(state.profile.role) ? `${names.join(" / ")}适配` : `${names.join(" / ")}倾向`;
  }

  function abilityComboHints(ability) {
    const owned = new Set(state.abilities || []);
    return ABILITY_COMBOS.filter((combo) => combo.requires.includes(ability.id)
      && !combo.requires.every((id) => owned.has(id))
      && combo.requires.filter((id) => id !== ability.id).every((id) => owned.has(id)));
  }

  function comboScenarioBonus(type) {
    return activeAbilityCombos().reduce((sum, combo) => sum + (combo.scenario?.[type] || 0), 0);
  }

  function comboTrainingBonus() {
    return activeAbilityCombos().reduce((sum, combo) => sum + (combo.trainingBonus || 0), 0);
  }

  function comboMatchBonus(tournament, opponent) {
    const underdog = opponent && team() && hiddenTeamStrength(opponent) > hiddenTeamStrength(team());
    return activeAbilityCombos().reduce((sum, combo) => sum + (combo.matchBonus || 0)
      + (tournament?.major ? combo.majorBonus || 0 : 0)
      + (underdog ? combo.underdogBonus || 0 : 0), 0);
  }

  function unlockNewCombos(previousComboIds = []) {
    state.unlockedCombos ??= [];
    const known = new Set([...previousComboIds, ...state.unlockedCombos]);
    const unlocked = activeAbilityCombos().filter((combo) => !known.has(combo.id));
    unlocked.forEach((combo) => {
      applyEffects(combo.unlockEffects || {}, false);
      state.unlockedCombos.push(combo.id);
    });
    state.unlockedCombos = unique(state.unlockedCombos);
    return unlocked;
  }

  function fallbackVrsPoints(candidate) {
    return Math.round(430 + candidate.rep * 6.9 + (stableHash(`${candidate.id}-vrs`) % 71 - 35));
  }

  function createInitialVrs() {
    const teams = {};
    TEAMS.forEach((candidate) => {
      const official = INITIAL_VRS[candidate.id];
      teams[candidate.id] = {
        points: official?.[0] || fallbackVrsPoints(candidate),
        startPoints: official?.[0] || fallbackVrsPoints(candidate),
        official: Boolean(official),
        startGlobalRank: official?.[1] || null,
        startRegionRank: official?.[2] || null,
        lastDelta: 0,
        lastStrengthDelta: 0,
        history: []
      };
    });
    return { snapshot: VRS_SNAPSHOT_DATE, teams };
  }

  function ensureVrsState() {
    if (!state.vrs?.teams) state.vrs = createInitialVrs();
    TEAMS.forEach((candidate) => {
      if (!state.vrs.teams[candidate.id]) {
        const official = INITIAL_VRS[candidate.id];
        state.vrs.teams[candidate.id] = {
          points: official?.[0] || fallbackVrsPoints(candidate), startPoints: official?.[0] || fallbackVrsPoints(candidate), official: Boolean(official),
          startGlobalRank: official?.[1] || null, startRegionRank: official?.[2] || null, lastDelta: 0,
          lastStrengthDelta: 0, history: []
        };
      }
      state.vrs.teams[candidate.id].startPoints ??= INITIAL_VRS[candidate.id]?.[0] || state.vrs.teams[candidate.id].points;
      state.vrs.teams[candidate.id].lastStrengthDelta ??= 0;
      state.vrs.teams[candidate.id].history ??= [];
      state.teamForm ??= {};
      if (state.teamForm[candidate.id] == null) state.teamForm[candidate.id] = (stableHash(`${candidate.id}-form`) % 9) - 4;
    });
  }

  function vrsTable(region = null) {
    ensureVrsState();
    return TEAMS.filter((candidate) => !region || candidate.region === region)
      .map((candidate) => ({ team: candidate, ...state.vrs.teams[candidate.id] }))
      .sort((a, b) => b.points - a.points || a.team.name.localeCompare(b.team.name));
  }

  function vrsEntry(teamId) {
    ensureVrsState();
    const candidate = TEAMS.find((item) => item.id === teamId);
    if (!candidate) return { points: 0, globalRank: 999, regionRank: 999, official: false, lastDelta: 0 };
    const base = state.vrs.teams[teamId];
    // 名次直接由实时积分榜的排序位置派生：积分不同则名次不同，同分时按队伍名稳定排序（与 vrsTable 一致）
    const globalRank = vrsTable().findIndex((entry) => entry.team.id === teamId);
    const regionRank = vrsTable(candidate.region).findIndex((entry) => entry.team.id === teamId);
    return {
      ...base,
      globalRank: globalRank >= 0 ? globalRank + 1 : 999,
      regionRank: regionRank >= 0 ? regionRank + 1 : 999
    };
  }

  function strengthTrendLabel(delta) {
    if (delta >= 1.4) return "实力明显升温";
    if (delta >= 0.35) return "竞技状态上扬";
    if (delta <= -1.4) return "实力明显下滑";
    if (delta <= -0.35) return "竞技状态走低";
    return "阵容强度稳定";
  }

  function ensureWorldState() {
    state.world ??= {};
    state.world.teamStrengthEffects ??= [];
    state.world.prospects ??= [];
    state.world.cs3TransitionUntil ??= 0;
    state.world.marketShockUntil ??= 0;
  }

  function activeTeamStrengthModifier(teamId) {
    ensureWorldState();
    return state.world.teamStrengthEffects
      .filter((effect) => effect.teamId === teamId && effect.expiresYear >= state.year)
      .reduce((sum, effect) => sum + effect.delta, 0);
  }

  function addTeamStrengthEffect(teamId, delta, seasons, label) {
    ensureWorldState();
    state.world.teamStrengthEffects.push({ id: `${teamId}-${state.year}-${stableHash(label)}`, teamId, delta, label, expiresYear: state.year + Math.max(0, seasons - 1) });
    state.world.teamStrengthEffects = state.world.teamStrengthEffects.slice(-24);
  }

  function hiddenTeamStrength(candidate) {
    if (!candidate) return 50;
    const points = state.vrs?.teams?.[candidate.id]?.points || INITIAL_VRS[candidate.id]?.[0] || fallbackVrsPoints(candidate);
    const vrsPower = 48 + (points - 650) * 0.034;
    const stability = (stableHash(`${candidate.id}-stability`) % 11) - 5;
    const form = state.teamForm?.[candidate.id] || 0;
    let strength = vrsPower * 0.82 + candidate.rep * 0.18 + stability * 0.18 + form;
    if ((state.world?.cs3TransitionUntil || 0) >= state.year && strength > 80) strength = 80 + (strength - 80) * 0.2;
    strength += activeTeamStrengthModifier(candidate.id);
    return Math.max(42, Math.min(98, strength));
  }

  function vrsSourceLabel(entry) {
    return entry?.official ? `Valve ${VRS_SNAPSHOT_DATE}` : "未列入快照 · 模拟基线";
  }
  function overall() {
    const s = state.stats;
    const weights = {
      awper: [0.39, 0.23, 0.10, 0.18, 0.10], entry: [0.38, 0.13, 0.14, 0.19, 0.16],
      igl: [0.14, 0.34, 0.27, 0.18, 0.07], support: [0.19, 0.27, 0.28, 0.16, 0.10],
      rifler: [0.32, 0.22, 0.19, 0.17, 0.10]
    }[state.profile.role] || [0.28, 0.24, 0.2, 0.18, 0.1];
    return clamp(s.mechanics * weights[0] + s.gameSense * weights[1] + s.teamwork * weights[2] + s.mentality * weights[3] + s.fitness * weights[4]);
  }

  function abilityCardMatchBonus() {
    const rarityBonus = { "普通": 0.4, "稀有": 0.65, "史诗": 0.95 };
    return (state.abilities || []).reduce((sum, abilityId) => {
      const ability = ABILITIES.find((item) => item.id === abilityId);
      if (!ability) return sum;
      const roleFit = ability.roles?.includes(state.profile.role) ? 0.25 : 0;
      return sum + (rarityBonus[ability.rarity] || 0.35) + roleFit;
    }, 0);
  }

  function matchPowerBreakdown(event = state.currentEvent) {
    const tournament = TOURNAMENTS.find((item) => item.id === event?.tournamentId);
    const currentTeam = team();
    const opponent = tournamentOpponent(event);
    const scenario = event?.trainingScore;
    const playedMaps = event?.veto?.selected || [];
    const mapEdge = playedMaps.length ? playedMaps.reduce((sum, entry) => {
      return sum + (teamMapRate(currentTeam, entry.mapId) - teamMapRate(opponent, entry.mapId)) * 0.1 + (mapSkill(entry.mapId) - 50) * 0.12;
    }, 0) / playedMaps.length : 0;
    const playerOverall = overall();
    const playerImpact = Math.max(-4.5, Math.min(12, (playerOverall - 58) * 0.38));
    const abilityBonus = abilityCardMatchBonus();
    const comboBonus = comboMatchBonus(tournament, opponent);
    let perkBonus = 0;
    if (hasPerk("clutch")) perkBonus += isKeyTournamentMatch(event) ? 1.8 : 0.7;
    if (hasPerk("midround")) perkBonus += 1.1;
    if (hasPerk("bigStage") && tournament?.major) perkBonus += 3.5;
    if (hasPerk("lanAnimal") && !tournament?.location.includes("线上")) perkBonus += 1.6;
    if (hasPerk("resilient") && hiddenTeamStrength(opponent) > hiddenTeamStrength(currentTeam)) perkBonus += 1;
    const cohesionBonus = (state.career.cohesion - 50) * 0.045 + (hasPerk("chemistry") ? 0.8 : 0);
    const languageBonus = (languageCompatibility(currentTeam) - 60) * 0.035;
    const scenarioBonus = (scenario?.bonus || 0) * 0.8;
    const trainingBonus = event?.mapBonus || 0;
    const specialBonus = state.seasonData?.specialMatchBonus?.matches > 0 ? state.seasonData.specialMatchBonus.value : 0;
    const preparationPenalty = state.seasonData?.preparationPenalty?.matches > 0 ? state.seasonData.preparationPenalty.value : 0;
    const fitnessPenalty = state.stats.fitness < 45 ? (45 - state.stats.fitness) * 0.16 : 0;
    const matchLoad = state.seasonData?.matchLoad || 0;
    const fatiguePenalty = Math.min(2.5, Math.max(0, (matchLoad - 8) * 0.12));
    const teamBase = hiddenTeamStrength(currentTeam);
    const opponentBase = hiddenTeamStrength(opponent);
    // P0-3：赛事难度进入公式——高级别赛事的对手实际更难打，地区赛则略宽松
    const eventPressure = tournament ? (tournament.difficulty - 75) * 0.2 : 0;
    const opponentPower = opponentBase + eventPressure;
    // P0-2：个人加成与备战加成的软上限——超出部分减半，阻止多维线性叠加爆炸
    const rawPlayerTotal = playerImpact + abilityBonus + comboBonus + perkBonus;
    const playerTotal = rawPlayerTotal > 8 ? 8 + (rawPlayerTotal - 8) * 0.5 : rawPlayerTotal;
    const rawPreparationTotal = scenarioBonus + trainingBonus + mapEdge + specialBonus - preparationPenalty;
    const preparationTotal = rawPreparationTotal > 6 ? 6 + (rawPreparationTotal - 6) * 0.5 : rawPreparationTotal;
    const teamContextTotal = cohesionBonus + languageBonus;
    const conditionTotal = -fitnessPenalty - fatiguePenalty;
    const total = teamBase + playerTotal + preparationTotal + teamContextTotal + conditionTotal;
    // P0-1：放缓胜率曲线（除数 18→26），压低天花板（BO3 0.88 / BO1 0.82）、抬高地板（0.10），消灭必赢局
    const bestOf = currentMatchBestOf(event);
    const winCeiling = bestOf === 1 ? 0.82 : 0.88;
    let winChance = Math.max(0.1, Math.min(winCeiling, 1 / (1 + Math.pow(10, (opponentPower - total) / 26))));
    const patchChaos = (state.seasonData?.patchChaosMatches || 0) > 0;
    if (patchChaos) winChance = Math.max(0.1, Math.min(winCeiling, 0.5 + (winChance - 0.5) * 0.52 + (state.stats.gameSense >= 80 ? 0.04 : 0)));
    return {
      teamBase, opponentPower, opponentBase, eventPressure, playerOverall, playerImpact, abilityBonus, comboBonus, perkBonus,
      cohesionBonus, languageBonus, scenarioBonus, trainingBonus, specialBonus, preparationPenalty, patchChaos, mapEdge, fitnessPenalty, fatiguePenalty,
      playerTotal, rawPlayerTotal, preparationTotal, rawPreparationTotal,
      teamContextTotal, conditionTotal,
      total, winChance
    };
  }

  function initializeLanguages() {
    const origin = country();
    const native = origin?.language || "中文";
    state.languages = { [native]: 100 };
    state.languages["英语"] = native === "英语" ? 100 : (origin?.english || 35);
    Object.entries(origin?.extraLanguages || {}).forEach(([language, level]) => { state.languages[language] = level; });
  }

  function teamLanguage(candidate) {
    if (!candidate) return "英语";
    if (ENGLISH_TEAMS.has(candidate.id)) return "英语";
    return COUNTRY_LANGUAGES[candidate.country] || "英语";
  }

  function languageLevel(language) {
    const base = state.languages?.[language] || 0;
    return hasPerk("polyglot") ? Math.max(base, 82) : base;
  }

  function languageCompatibility(candidate) {
    return clamp(languageLevel(teamLanguage(candidate)), 0, 100);
  }

  function profileRegion() {
    return country()?.majorRegion || "欧洲";
  }

  function roleDemand(candidate) {
    const hash = [...candidate.id].reduce((sum, char) => sum + char.charCodeAt(0), 0);
    const primary = ROLES[hash % ROLES.length].id;
    const secondary = ROLES[(hash + 2) % ROLES.length].id;
    if (state.profile.role === primary) return { score: 100, label: "高 · 正在补强此位置" };
    if (state.profile.role === secondary) return { score: 68, label: "中 · 可进入轮换" };
    return { score: 38, label: "低 · 需要竞争位置" };
  }

  function stableHash(text) {
    return [...String(text)].reduce((hash, char) => ((hash * 31 + char.charCodeAt(0)) >>> 0), 2166136261);
  }

  function mapById(id) { return MAPS.find((map) => map.id === id); }

  function initializeMapSkills(deterministic = false) {
    const roleFavored = {
      awper: ["dust2", "cache"], entry: ["mirage", "ancient"], igl: ["nuke", "anubis"],
      support: ["inferno", "nuke"], rifler: ["mirage", "cache"]
    }[state.profile.role] || [];
    state.mapSkills = {};
    MAPS.forEach((map, index) => {
      const roll = deterministic ? 46 + stableHash(`${state.profile.nickname}-${map.id}`) % 13 : randomBetween(46, 58);
      const roleBonus = roleFavored.includes(map.id) ? 5 : 0;
      const naturalWeakness = index === stableHash(`${state.profile.country}-${state.profile.role}`) % MAPS.length ? -6 : 0;
      state.mapSkills[map.id] = clamp(roll + roleBonus + naturalWeakness);
    });
  }

  function mapSkill(mapId) { return state.mapSkills?.[mapId] || 50; }

  function playerMapTraits() {
    const ordered = MAPS.map((map) => ({ ...map, value: mapSkill(map.id) })).sort((a, b) => b.value - a.value);
    return { strong: ordered.slice(0, 2), weak: ordered.slice(-2).reverse() };
  }

  function teamMapProfile(candidate) {
    const banIndex = stableHash(`${candidate.id}-ban`) % MAPS.length;
    let pickIndex = stableHash(`${candidate.id}-pick`) % MAPS.length;
    if (pickIndex === banIndex) pickIndex = (pickIndex + 2) % MAPS.length;
    return { permaban: MAPS[banIndex].id, firstPick: MAPS[pickIndex].id };
  }

  function teamMapRate(candidate, mapId) {
    const profile = teamMapProfile(candidate);
    const variance = stableHash(`${candidate.id}-${mapId}`) % 23 - 11;
    let rate = 34 + hiddenTeamStrength(candidate) * 0.27 + variance;
    if (profile.firstPick === mapId) rate += 10;
    if (profile.permaban === mapId) rate -= 22;
    return clamp(rate, 18, 78);
  }

  function eventRanking(candidate, tournament) {
    const entry = vrsEntry(candidate.id);
    return tournament.region ? entry.regionRank : entry.globalRank;
  }

  function buildTournamentField(tournament) {
    const current = team();
    let pool = TEAMS.filter((candidate) => !tournament.region || candidate.region === tournament.region);
    if (tournament.major) {
      const invited = [];
      ["欧洲", "美洲", "亚洲"].forEach((region) => {
        const slots = MAJOR_REGION_SLOTS[REGION_KEY[region]];
        invited.push(...vrsTable(region).slice(0, slots.stage1 + slots.stage2 + slots.stage3).map((entry) => entry.team));
      });
      pool = unique(invited.map((candidate) => candidate.id)).map((id) => TEAMS.find((candidate) => candidate.id === id));
      if (pool.length < tournament.teamCount) {
        vrsTable().forEach((entry) => { if (pool.length < tournament.teamCount && !pool.some((candidate) => candidate.id === entry.team.id)) pool.push(entry.team); });
      }
    } else if (tournament.tier === "S") {
      pool = pool.sort((a, b) => vrsEntry(a.id).globalRank - vrsEntry(b.id).globalRank);
    } else {
      pool = pool.sort((a, b) => Math.abs(hiddenTeamStrength(a) - tournament.difficulty) - Math.abs(hiddenTeamStrength(b) - tournament.difficulty));
    }
    let field = pool.slice(0, Math.min(tournament.teamCount, pool.length));
    if (field.length < tournament.teamCount) {
      vrsTable().forEach((entry) => {
        if (field.length < tournament.teamCount && !field.some((candidate) => candidate.id === entry.team.id)) field.push(entry.team);
      });
    }
    if (current && !field.some((candidate) => candidate.id === current.id)) {
      if (field.length >= tournament.teamCount) field[field.length - 1] = current;
      else field.push(current);
    }
    return unique(field.map((candidate) => candidate.id));
  }

  function majorInviteRoute(candidate) {
    const key = REGION_KEY[candidate.region];
    const slots = MAJOR_REGION_SLOTS[key];
    const rank = vrsEntry(candidate.id).regionRank;
    if (rank <= slots.stage3) return { code: "stage3", label: "VRS 地区榜直邀 Stage 3", detail: `${candidate.region} #${rank} · Stage 3 名额 ${slots.stage3}` };
    if (rank <= slots.stage3 + slots.stage2) return { code: "stage2", label: "VRS 地区榜直邀 Stage 2", detail: `${candidate.region} #${rank} · 前 ${slots.stage3} 支从 Stage 3 开始` };
    if (rank <= slots.stage3 + slots.stage2 + slots.stage1) return { code: "stage1", label: "VRS 地区榜直邀 Stage 1", detail: `${candidate.region} #${rank} · Stage 1 名额 ${slots.stage1}` };
    return { code: "qualifier", label: "未获 VRS 直邀 · 地区最终资格赛", detail: `${candidate.region} #${rank} · 需要连胜 2 场进入 Stage 1` };
  }

  function tournamentInviteRoute(tournament, candidate) {
    if (tournament.major) return majorInviteRoute(candidate);
    const rank = eventRanking(candidate, tournament);
    if (rank <= tournament.directInvites) {
      return { code: "direct", label: "VRS 直邀正赛", detail: `${tournament.region ? `${candidate.region}榜` : "全球榜"} #${rank} · 直邀线 #${tournament.directInvites}` };
    }
    return { code: "qualifier", label: tournament.id === "cologne" ? "进入 Play-in" : "进入 VRS 资格赛", detail: `${tournament.region ? `${candidate.region}榜` : "全球榜"} #${rank} · 需连胜 ${tournament.qualifierWins} 场` };
  }

  function firstMainPhase(tournament) {
    if (tournament.major) return null;
    if (tournament.format === "swiss") return "swiss";
    if (tournament.format === "groups") return "group";
    return "r16";
  }

  function phaseLabel(phase) {
    return {
      qualifier: "地区 / Play-in 资格赛", swiss: "瑞士制正赛", group: "双败小组赛",
      stage1: "Major Stage 1", stage2: "Major Stage 2", stage3: "Major Stage 3",
      r16: "十六强", qf: "四分之一决赛", sf: "半决赛", final: "决赛"
    }[phase] || phase;
  }

  function chooseMajorEdition(tournament) {
    const recent = new Set((state.career.majorVenueHistory || []).slice(-4).map((entry) => entry.hostId));
    const available = MAJOR_HOSTS.filter((host) => !recent.has(host.id));
    const pool = available.length ? available : MAJOR_HOSTS;
    const seed = stableHash(`${state.year}-${state.season}-${tournament.id}-${state.teamId || "free"}-major-host`);
    const host = pool[seed % pool.length];
    const organizer = tournament.id === "starladder" ? "StarLadder" : "PGL";
    return {
      hostId: host.id,
      name: `${organizer} ${host.city} Major ${state.year}`,
      location: `${host.country} · ${host.city}`,
      code: host.code,
      historic: host.history,
      image: "assets/events/pgl-major.svg"
    };
  }

  function tournamentPresentation(tournament, event = state.currentEvent) {
    const edition = tournament?.major ? event?.majorEdition : null;
    return {
      name: edition?.name || tournament?.name || "赛事",
      location: edition?.location || tournament?.location || "国际举办地",
      code: edition?.code || tournament?.code || "EVENT",
      image: edition?.image || tournament?.image,
      fallbackImage: tournament?.fallbackImage || tournament?.image,
      posterSource: edition ? null : tournament?.posterSource,
      historic: edition?.historic || null
    };
  }

  function recordMajorEdition(event) {
    if (!event?.majorEdition) return;
    state.career.majorVenueHistory ??= [];
    const duplicate = state.career.majorVenueHistory.some((entry) => entry.year === state.year && entry.season === state.season && entry.tournamentId === event.tournamentId);
    if (duplicate) return;
    state.career.majorVenueHistory.push({
      year: state.year, season: state.season, tournamentId: event.tournamentId,
      hostId: event.majorEdition.hostId, name: event.majorEdition.name, location: event.majorEdition.location
    });
    state.career.majorVenueHistory = state.career.majorVenueHistory.slice(-24);
  }

  function makeTournamentEvent(tournamentId) {
    const tournament = TOURNAMENTS.find((item) => item.id === tournamentId) || TOURNAMENTS.find((item) => !item.major);
    ensureVrsState();
    const current = team();
    if (!current) return { type: "tournament", tournamentId: tournament.id, resolved: true, result: null };
    const route = tournamentInviteRoute(tournament, current);
    const phase = route.code === "qualifier" ? "qualifier" : tournament.major ? route.code : firstMainPhase(tournament);
    const currentEntry = vrsEntry(current.id);
    const event = {
      type: "tournament", tournamentId: tournament.id, opponentId: null, resolved: false, stage: "briefing",
      majorEdition: tournament.major ? chooseMajorEdition(tournament) : null,
      veto: null, trainingMapId: null, scenarioType: null, minigame: null, trainingScore: null,
      competition: {
        route, phase, wins: 0, losses: 0, qualifierWins: tournament.qualifierWins || 2,
        matches: [], faced: [], field: buildTournamentField(tournament), started: false,
        vrsBefore: currentEntry.points, globalRankBefore: currentEntry.globalRank, regionRankBefore: currentEntry.regionRank,
        stageHistory: [], complete: false, interactionsUsed: 0, trainingUsed: false
      }
    };
    return event;
  }

  function activateTournamentEvent(event) {
    if (!event?.competition || event.competition.started) return;
    const tournament = TOURNAMENTS.find((item) => item.id === event.tournamentId);
    if (tournament.major && !event.majorEdition) event.majorEdition = chooseMajorEdition(tournament);
    if (tournament.major) recordMajorEdition(event);
    const current = team();
    const currentEntry = vrsEntry(current.id);
    const route = tournamentInviteRoute(tournament, current);
    event.competition.route = route;
    event.competition.phase = route.code === "qualifier" ? "qualifier" : tournament.major ? route.code : firstMainPhase(tournament);
    event.competition.field = buildTournamentField(tournament);
    event.competition.vrsBefore = currentEntry.points;
    event.competition.globalRankBefore = currentEntry.globalRank;
    event.competition.regionRankBefore = currentEntry.regionRank;
    event.competition.strengthBefore = hiddenTeamStrength(current);
    initializeTournamentSimulation(event);
    prepareTournamentMatch(event, false);
    event.stage = "briefing";
  }

  function simulationRandom(simulation) {
    simulation.rng = (Math.imul(simulation.rng || 1, 1664525) + 1013904223) >>> 0;
    return simulation.rng / 4294967296;
  }

  function simulationTeam(teamId) { return TEAMS.find((candidate) => candidate.id === teamId); }

  function recordSimulationMatch(event, phase, teamA, teamB, winner, score = null) {
    const simulation = event.competition.simulation;
    simulation.ledger.push({
      number: simulation.ledger.length + 1, phase, teamA, teamB, winner,
      loser: winner === teamA ? teamB : teamA, score: score || "2-1"
    });
  }

  function simulateAiSeries(event, teamA, teamB, phase) {
    const simulation = event.competition.simulation;
    const a = simulationTeam(teamA);
    const b = simulationTeam(teamB);
    const aPower = hiddenTeamStrength(a) + (state.teamForm?.[teamA] || 0) * 0.25;
    const bPower = hiddenTeamStrength(b) + (state.teamForm?.[teamB] || 0) * 0.25;
    const chance = Math.max(0.1, Math.min(0.9, 1 / (1 + Math.pow(10, (bPower - aPower) / 22))));
    const winner = simulationRandom(simulation) < chance ? teamA : teamB;
    const clean = simulationRandom(simulation) < Math.min(0.7, 0.32 + Math.abs(aPower - bPower) / 40);
    recordSimulationMatch(event, phase, teamA, teamB, winner, `2-${clean ? 0 : 1}`);
    return winner;
  }

  function markSimulationEliminated(event, teamId, phase, detail = {}) {
    if (!teamId || event.competition.simulation.eliminations.some((entry) => entry.teamId === teamId)) return;
    event.competition.simulation.eliminations.push({ teamId, phase, order: event.competition.simulation.eliminations.length, ...detail });
  }

  function createStageState(phase, pool, slots) {
    const target = phase === "group" ? 2 : 3;
    const records = {};
    unique(pool).forEach((teamId) => { records[teamId] = { wins: 0, losses: 0, opponents: [], qualified: false, eliminated: false }; });
    return { phase, pool: unique(pool), slots, targetWins: target, targetLosses: target, round: 0, records, qualifiers: [], pendingPlayer: null };
  }

  function stageActiveTeams(stage) {
    return stage.pool.filter((teamId) => !stage.records[teamId]?.qualified && !stage.records[teamId]?.eliminated);
  }

  function recordStageSeries(event, stage, winner, loser, logMatch = true) {
    const winnerRecord = stage.records[winner];
    const loserRecord = stage.records[loser];
    if (!winnerRecord || !loserRecord) return;
    winnerRecord.wins += 1;
    loserRecord.losses += 1;
    winnerRecord.opponents.push(loser);
    loserRecord.opponents.push(winner);
    if (winnerRecord.wins >= stage.targetWins) {
      winnerRecord.qualified = true;
      if (!stage.qualifiers.includes(winner)) stage.qualifiers.push(winner);
    }
    if (loserRecord.losses >= stage.targetLosses) {
      loserRecord.eliminated = true;
      markSimulationEliminated(event, loser, stage.phase, { wins: loserRecord.wins, losses: loserRecord.losses });
    }
    if (logMatch) recordSimulationMatch(event, stage.phase, winner, loser, winner);
  }

  function orderStageTeams(event, stage, ids) {
    const simulation = event.competition.simulation;
    return [...ids].sort((a, b) => {
      const ar = stage.records[a];
      const br = stage.records[b];
      return br.wins - ar.wins || ar.losses - br.losses || vrsEntry(a).globalRank - vrsEntry(b).globalRank || simulationRandom(simulation) - 0.5;
    });
  }

  function simulateClosedStage(event, phase, pool, slots) {
    const stage = createStageState(phase, pool, slots);
    let safety = 0;
    while (stageActiveTeams(stage).length > 1 && safety < 10) {
      safety += 1;
      stage.round += 1;
      const active = orderStageTeams(event, stage, stageActiveTeams(stage));
      for (let index = 0; index + 1 < active.length; index += 2) {
        const teamA = active[index];
        const teamB = active[index + 1];
        const winner = simulateAiSeries(event, teamA, teamB, phase);
        recordStageSeries(event, stage, winner, winner === teamA ? teamB : teamA, false);
      }
    }
    return { stage, advancers: selectStageAdvancers(event, stage) };
  }

  function selectStageAdvancers(event, stage) {
    const currentId = team()?.id;
    const ordered = orderStageTeams(event, stage, stage.qualifiers.length ? stage.qualifiers : stage.pool);
    let advancers = unique(ordered).slice(0, stage.slots);
    // 简化双败小组在 8 队池等规模下达标出线数可能少于名额（如 BLAST Rivals 仅 4 队 2 胜达标），
    // 按战绩补足名额并撤销其淘汰标记，保证下游淘汰赛对阵规模与赛制一致
    if (advancers.length < stage.slots) {
      const rest = orderStageTeams(event, stage, stage.pool.filter((id) => !advancers.includes(id) && id !== currentId));
      const topUp = rest.slice(0, stage.slots - advancers.length);
      if (topUp.length) {
        const topUpSet = new Set(topUp);
        advancers = unique([...advancers, ...topUp]);
        event.competition.simulation.eliminations = event.competition.simulation.eliminations
          .filter((entry) => !(topUpSet.has(entry.teamId) && entry.phase === stage.phase));
        topUp.forEach((id) => { if (stage.records[id]) stage.records[id].eliminated = false; });
      }
    }
    if (stage.records[currentId]?.qualified && !advancers.includes(currentId)) advancers[advancers.length - 1] = currentId;
    stage.pool.filter((teamId) => !advancers.includes(teamId)).forEach((teamId) => {
      const record = stage.records[teamId] || {};
      markSimulationEliminated(event, teamId, stage.phase, { wins: record.wins || 0, losses: record.losses || 0 });
    });
    return unique(advancers);
  }

  function completeInteractiveStage(event) {
    const stage = event.competition.simulation.currentStage;
    let safety = 0;
    while (stageActiveTeams(stage).length > 1 && safety < 10) {
      safety += 1;
      stage.round += 1;
      const active = orderStageTeams(event, stage, stageActiveTeams(stage));
      for (let index = 0; index + 1 < active.length; index += 2) {
        const teamA = active[index];
        const teamB = active[index + 1];
        const winner = simulateAiSeries(event, teamA, teamB, stage.phase);
        recordStageSeries(event, stage, winner, winner === teamA ? teamB : teamA, false);
      }
    }
    return selectStageAdvancers(event, stage);
  }

  function initializeInteractiveStage(event, phase, pool, slots) {
    const competition = event.competition;
    const stage = createStageState(phase, pool, slots);
    if (competition.matches.length && competition.phase === phase) {
      const playerRecord = stage.records[team().id];
      if (playerRecord) {
        playerRecord.wins = competition.wins || 0;
        playerRecord.losses = competition.losses || 0;
        playerRecord.opponents = [...(competition.faced || [])];
      }
    }
    competition.simulation.currentStage = stage;
    competition.phase = phase;
    competition.wins = stage.records[team().id]?.wins || 0;
    competition.losses = stage.records[team().id]?.losses || 0;
  }

  function majorStageBuckets(field) {
    const buckets = { stage1: [], stage2: [], stage3: [] };
    ["欧洲", "美洲", "亚洲"].forEach((region) => {
      const regionTeams = field.map(simulationTeam).filter((candidate) => candidate?.region === region).sort((a, b) => vrsEntry(a.id).regionRank - vrsEntry(b.id).regionRank);
      const slots = MAJOR_REGION_SLOTS[REGION_KEY[region]];
      buckets.stage3.push(...regionTeams.slice(0, slots.stage3).map((candidate) => candidate.id));
      buckets.stage2.push(...regionTeams.slice(slots.stage3, slots.stage3 + slots.stage2).map((candidate) => candidate.id));
      buckets.stage1.push(...regionTeams.slice(slots.stage3 + slots.stage2, slots.stage3 + slots.stage2 + slots.stage1).map((candidate) => candidate.id));
    });
    const assigned = new Set([...buckets.stage1, ...buckets.stage2, ...buckets.stage3]);
    field.filter((id) => !assigned.has(id)).forEach((id) => buckets.stage1.push(id));
    return buckets;
  }

  function nextKnockoutPhase(phase) { return ({ r16: "qf", qf: "sf", sf: "final" })[phase] || null; }

  function seedKnockoutTeams(ids) {
    return unique(ids).sort((a, b) => vrsEntry(a).globalRank - vrsEntry(b).globalRank);
  }

  function initializeKnockout(event, ids, sixTeam = false) {
    let seeded = seedKnockoutTeams(ids);
    const desired = sixTeam ? 6 : seeded.length >= 16 ? 16 : 8;
    seeded = seeded.slice(0, desired);
    if (ids.includes(team().id) && !seeded.includes(team().id)) seeded[seeded.length - 1] = team().id;
    event.competition.simulation.knockout = { active: seeded, phase: desired >= 16 ? "r16" : "qf", round: null, sixTeam: desired === 6 };
    event.competition.phase = desired >= 16 ? "r16" : "qf";
    event.competition.wins = 0;
    event.competition.losses = 0;
  }

  function knockoutPairs(active, sixTeam, phase) {
    if (sixTeam && phase === "qf" && active.length === 6) return [[active[2], active[5]], [active[3], active[4]]];
    if (phase === "r16" || phase === "qf") {
      const pairs = [];
      for (let index = 0; index < active.length / 2; index += 1) pairs.push([active[index], active[active.length - 1 - index]]);
      return pairs;
    }
    const pairs = [];
    for (let index = 0; index + 1 < active.length; index += 2) pairs.push([active[index], active[index + 1]]);
    return pairs;
  }

  function knockoutNextActive(knockout) {
    const winners = knockout.round.results.map((result) => result.winner);
    if (knockout.sixTeam && knockout.phase === "qf") return [knockout.active[0], winners[1], knockout.active[1], winners[0]];
    return winners;
  }

  function prepareKnockoutPairing(event) {
    const competition = event.competition;
    const knockout = competition.simulation.knockout;
    if (!knockout) return null;
    if (!knockout.round) {
      const pairs = knockoutPairs(knockout.active, knockout.sixTeam, knockout.phase);
      knockout.round = { phase: knockout.phase, results: pairs.map(([teamA, teamB]) => ({ teamA, teamB, winner: null, loser: null })) };
      knockout.round.results.forEach((result) => {
        if ([result.teamA, result.teamB].includes(team().id)) return;
        result.winner = simulateAiSeries(event, result.teamA, result.teamB, knockout.phase);
        result.loser = result.winner === result.teamA ? result.teamB : result.teamA;
        markSimulationEliminated(event, result.loser, knockout.phase);
      });
    }
    const playerPair = knockout.round.results.find((result) => !result.winner && [result.teamA, result.teamB].includes(team().id));
    if (playerPair) return playerPair.teamA === team().id ? playerPair.teamB : playerPair.teamA;
    if (knockout.round.results.every((result) => result.winner)) {
      const next = knockoutNextActive(knockout);
      const nextPhase = nextKnockoutPhase(knockout.phase);
      knockout.active = next;
      knockout.phase = nextPhase;
      knockout.round = null;
      competition.phase = nextPhase;
      return prepareKnockoutPairing(event);
    }
    return null;
  }

  function prepareStagePairing(event) {
    const stage = event.competition.simulation.currentStage;
    if (!stage) return null;
    if (stage.pendingPlayer) return stage.pendingPlayer.opponentId;
    stage.round += 1;
    const currentId = team().id;
    const active = stageActiveTeams(stage);
    const playerRecord = stage.records[currentId];
    const opponents = active.filter((id) => id !== currentId).sort((a, b) => {
      const ar = stage.records[a];
      const br = stage.records[b];
      const aRematch = playerRecord.opponents.includes(a) ? 20 : 0;
      const bRematch = playerRecord.opponents.includes(b) ? 20 : 0;
      return (Math.abs(ar.wins - playerRecord.wins) + Math.abs(ar.losses - playerRecord.losses)) - (Math.abs(br.wins - playerRecord.wins) + Math.abs(br.losses - playerRecord.losses)) + aRematch - bRematch;
    });
    const opponentId = opponents[0];
    if (!opponentId) return null;
    stage.pendingPlayer = { opponentId, round: stage.round };
    const remaining = orderStageTeams(event, stage, active.filter((id) => id !== currentId && id !== opponentId));
    for (let index = 0; index + 1 < remaining.length; index += 2) {
      const teamA = remaining[index];
      const teamB = remaining[index + 1];
      const winner = simulateAiSeries(event, teamA, teamB, stage.phase);
      recordStageSeries(event, stage, winner, winner === teamA ? teamB : teamA, false);
    }
    return opponentId;
  }

  function initializeTournamentSimulation(event) {
    const competition = event.competition;
    if (competition.simulation?.initialized) return competition.simulation;
    const tournament = TOURNAMENTS.find((item) => item.id === event.tournamentId);
    const simulation = competition.simulation = {
      initialized: true, rng: stableHash(`${event.tournamentId}-${state.year}-${team().id}-${competition.vrsBefore}`),
      ledger: [], eliminations: [], currentStage: null, knockout: null, championId: null, runnerUpId: null,
      majorBuckets: tournament.major ? majorStageBuckets(competition.field) : null
    };
    if (competition.phase === "qualifier") return simulation;
    if (tournament.major) {
      const buckets = simulation.majorBuckets;
      let stage1Advancers;
      let stage2Advancers;
      if (competition.phase === "stage1") initializeInteractiveStage(event, "stage1", buckets.stage1, 8);
      if (["stage2", "stage3"].includes(competition.phase)) {
        stage1Advancers = simulateClosedStage(event, "stage1", buckets.stage1, 8).advancers;
        if (competition.phase === "stage2") initializeInteractiveStage(event, "stage2", [...stage1Advancers, ...buckets.stage2], 8);
      }
      if (competition.phase === "stage3") {
        stage2Advancers = simulateClosedStage(event, "stage2", [...stage1Advancers, ...buckets.stage2], 8).advancers;
        initializeInteractiveStage(event, "stage3", [...stage2Advancers, ...buckets.stage3], 8);
      }
    } else if (tournament.format === "single") {
      initializeKnockout(event, competition.field, false);
    } else {
      initializeInteractiveStage(event, firstMainPhase(tournament), competition.field, tournament.format === "groups" ? 6 : 8);
    }
    return simulation;
  }

  function simulatedOpponentId(event) {
    initializeTournamentSimulation(event);
    const competition = event.competition;
    if (competition.phase === "qualifier") return null;
    if (["swiss", "group", "stage1", "stage2", "stage3"].includes(competition.phase)) return prepareStagePairing(event);
    if (["r16", "qf", "sf", "final"].includes(competition.phase)) return prepareKnockoutPairing(event);
    return null;
  }

  function chooseOpponent(tournament, event = state.currentEvent) {
    const current = team();
    const comp = event?.competition;
    const authoritativeId = comp && comp.phase !== "qualifier" ? simulatedOpponentId(event) : null;
    if (authoritativeId) return simulationTeam(authoritativeId);
    let candidates = TEAMS.filter((candidate) => candidate.id !== current.id);
    if (comp?.phase === "qualifier") {
      const invited = new Set(comp.field || []);
      const regional = candidates.filter((candidate) => candidate.region === current.region && !invited.has(candidate.id));
      candidates = regional.length ? regional : candidates.filter((candidate) => !invited.has(candidate.id));
    } else if (comp?.field?.length) {
      candidates = comp.field.map((id) => TEAMS.find((candidate) => candidate.id === id)).filter(Boolean).filter((candidate) => candidate.id !== current.id);
    }
    const fresh = candidates.filter((candidate) => !comp?.faced?.includes(candidate.id));
    if (fresh.length) candidates = fresh;
    const stageLift = ["qf", "sf", "final", "stage3"].includes(comp?.phase) ? 5 : 0;
    const target = hiddenTeamStrength(current) + ((comp?.wins || 0) - (comp?.losses || 0)) * 2.4 + stageLift;
    candidates.sort((a, b) => (Math.abs(hiddenTeamStrength(a) - target) + Math.random() * 8) - (Math.abs(hiddenTeamStrength(b) - target) + Math.random() * 8));
    return candidates[0] || TEAMS.find((candidate) => candidate.id !== current.id);
  }

  function currentMatchBestOf(event = state.currentEvent) {
    const comp = event?.competition;
    const tournament = TOURNAMENTS.find((item) => item.id === event?.tournamentId);
    if (tournament?.major && ["stage1", "stage2", "stage3"].includes(comp?.phase)) {
      return comp.wins === 2 || comp.losses === 2 ? 3 : 1;
    }
    return 3;
  }

  function currentMatchLabel(event = state.currentEvent) {
    const comp = event?.competition;
    if (!comp) return "赛事对局";
    if (comp.phase === "qualifier") return `资格赛第 ${comp.wins + comp.losses + 1} 场`;
    if (["swiss", "group", "stage1", "stage2", "stage3"].includes(comp.phase)) return `${phaseLabel(comp.phase)} · ${comp.wins}-${comp.losses} 组`;
    return phaseLabel(comp.phase);
  }

  function prepareTournamentMatch(event, resetStage = true) {
    const tournament = TOURNAMENTS.find((item) => item.id === event.tournamentId);
    const opponent = chooseOpponent(tournament, event);
    event.opponentId = opponent.id;
    event.veto = null;
    event.trainingMapId = null;
    event.scenarioType = null;
    event.minigame = null;
    event.trainingScore = null;
    event.roundContext = null;
    event.mapBonus = 0;
    event.matchResult = null;
    event.competition.started = true;
    if (resetStage) event.stage = "briefing";
  }

  function saveGame() {
    try {
      localStorage.setItem(SAVE_KEY, JSON.stringify(state));
      el("save-status").textContent = `已保存 · ${new Date().toLocaleTimeString("zh-CN", { hour: "2-digit", minute: "2-digit" })}`;
    } catch (_) {
      el("save-status").textContent = "浏览器存档不可用";
    }
  }

  function loadGame() {
    try {
      const data = JSON.parse(localStorage.getItem(SAVE_KEY));
      if (!data || ![1, 2, 3, 4].includes(data.version)) return false;
      state = data;
      state.version = 4;
      state.abilities ??= [];
      state.unlockedCombos = unique(state.unlockedCombos || activeAbilityCombos().map((combo) => combo.id));
      state.preferences = { vetoMode: "manual", pace: "balanced", ...(state.preferences || {}) };
      state.development ??= { points: 2, potential: {}, completed: [], seasonStartStats: {} };
      state.development.points ??= 2;
      state.development.completed ??= [];
      state.development.seasonStartStats ??= {};
      state.career.sponsorIncome ??= 0;
      state.career.influence ??= 0;
      state.career.scrims ??= 0;
      state.career.peakVrsRank ??= 999;
      state.career.peakVrsPoints ??= 0;
      state.career.injuryWarnings ??= 0;
      state.career.rehabCount ??= 0;
      state.career.awardHistory ??= [];
      state.career.majorVenueHistory ??= [];
      state.career.easterEggs ??= [];
      state.career.coachingPotential ??= 0;
      state.career.lateCareerPath ??= null;
      state.career.endRole ??= null;
      state.career.finalSeason ??= false;
      ensureWorldState();
      if (!state.languages || !Object.keys(state.languages).length) initializeLanguages();
      if (!state.mapSkills || !Object.keys(state.mapSkills).length) initializeMapSkills(true);
      else {
        MAPS.forEach((map) => {
          if (state.mapSkills[map.id] == null) state.mapSkills[map.id] = clamp(46 + stableHash(`${state.profile.nickname}-${map.id}`) % 13);
        });
        delete state.mapSkills.train;
        delete state.mapSkills.overpass;
      }
      ensureDevelopmentState();
      ensureVrsState();
      if (state.currentEvent?.type === "easter") {
        state.currentEvent = hydrateEasterEggEvent(state.currentEvent);
        activateEasterEgg(state.currentEvent);
      }
      if (state.currentEvent?.type === "tournament" && !state.currentEvent.resolved) {
        const currentTournament = TOURNAMENTS.find((item) => item.id === state.currentEvent.tournamentId);
        if (currentTournament?.major && !state.currentEvent.majorEdition) state.currentEvent.majorEdition = chooseMajorEdition(currentTournament);
        if (currentTournament?.major && state.currentEvent.competition?.started) recordMajorEdition(state.currentEvent);
      }
      if (state.currentEvent?.type === "tournament" && !state.currentEvent.resolved && !state.currentEvent.competition) {
        state.currentEvent = makeTournamentEvent(state.currentEvent.tournamentId);
      }
      if (state.currentEvent?.type === "tournament" && !state.currentEvent.resolved && !state.currentEvent.competition.started) {
        activateTournamentEvent(state.currentEvent);
      }
      if (state.currentEvent?.type === "tournament" && !state.currentEvent.resolved && state.currentEvent.competition.started && !state.currentEvent.competition.simulation) {
        initializeTournamentSimulation(state.currentEvent);
        prepareTournamentMatch(state.currentEvent, false);
        state.currentEvent.stage = "briefing";
      }
      state.seasonQueue = (state.seasonQueue || []).map((event) => {
        if (event?.type === "easter") return hydrateEasterEggEvent(event);
        if (event?.type !== "tournament") return event;
        if (!event.competition || !event.competition.matches?.length) return makeTournamentEvent(event.tournamentId);
        return event;
      });
      return true;
    } catch (_) { return false; }
  }

  function hasSave() {
    try { return Boolean(localStorage.getItem(SAVE_KEY)); } catch (_) { return false; }
  }

  function notify(message) {
    clearTimeout(toastTimer);
    toastEl.textContent = message;
    toastEl.classList.add("show");
    toastTimer = setTimeout(() => toastEl.classList.remove("show"), 2600);
  }

  function render() {
    restartButton.classList.toggle("hidden", state.phase === "welcome");
    if (state.phase === "welcome") renderWelcome();
    if (state.phase === "setup") renderSetup();
    if (state.phase === "draft") renderDraft();
    if (state.phase === "career") renderCareer();
    if (state.phase === "retired") renderRetirement();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function renderWelcome() {
    const continueButton = hasSave() ? `
      <button class="button" data-action="continue-game">继续上次生涯 <span class="button-arrow">→</span></button>` : "";
    root.innerHTML = `
      <section class="hero">
        <div class="hero-number" aria-hidden="true">2</div>
        <div class="hero-crosshair" aria-hidden="true"></div>
        <div class="hero-content">
          <p class="eyebrow">CS PROFESSIONAL CAREER SIMULATOR</p>
          <h1 class="display-title">FROM<br><span class="outline">UNKNOWN</span><br>TO LEGEND</h1>
          <p class="lead">从无名新人到 Major 冠军，或在残酷的转会市场中悄然离场。选择出身与定位，抽取你的天赋，然后亲手写下这段职业生涯。</p>
          <div class="hero-actions">
            <button class="button button-primary" data-action="new-game">创建选手 <span class="button-arrow">→</span></button>
            ${continueButton}
          </div>
          <div class="feature-strip" aria-label="游戏特点">
            <div class="feature-item"><b>36 天赋 · 15 组合</b><span>位置加权抽卡塑造生涯方向</span></div>
            <div class="feature-item"><b>60+ 真实俱乐部</b><span>从地区队伍走向国际豪门</span></div>
            <div class="feature-item"><b>赛季动态事件</b><span>训练、舆论、健康与队内关系</span></div>
            <div class="feature-item"><b>完整退役总结</b><span>记录冠军、收入与效力轨迹</span></div>
          </div>
        </div>
      </section>`;
  }

  function renderSetup() {
    const selectedCountry = country();
    const countryGroups = [
      { id: "asia", label: "亚洲 / 大洋洲 / 中东 / 非洲（亚洲赛区）" },
      { id: "europe", label: "欧洲赛区" },
      { id: "americas", label: "美洲赛区" }
    ];
    root.innerHTML = `
      <section class="page">
        <div class="page-head">
          <div>
            <p class="eyebrow">CREATE YOUR PROSPECT</p>
            <h1>建立选手档案</h1>
            <p>出身影响初始倾向与本土俱乐部机会，角色决定能力评分权重。</p>
          </div>
          <div class="step-indicator" aria-label="第 1 阶段，共 2 阶段"><span class="active"></span><span></span></div>
        </div>

        <div class="setup-section">
          <p class="section-label"><span class="index">01</span> 选手 ID</p>
          <label class="sr-only" for="nickname">选手昵称</label>
          <input class="text-field" id="nickname" maxlength="16" autocomplete="off" placeholder="输入你的选手昵称，例如：Nova" value="${esc(state.profile.nickname)}">
        </div>

        <div class="setup-section">
          <p class="section-label"><span class="index">02</span> 出身国家 / 地区</p>
          <div class="country-picker ${selectedCountry ? "has-selection" : ""}">
            <label for="country-select">选择国籍</label>
            <div class="country-select-shell">
              <select id="country-select" aria-describedby="country-picker-note">
                <option value="">展开并选择国家 / 地区</option>
                ${countryGroups.map((group) => `<optgroup label="${group.label}">${COUNTRIES.filter((item) => item.group === group.id).map((item) => `<option value="${item.id}" ${state.profile.country === item.id ? "selected" : ""}>${item.flag} ${item.name}</option>`).join("")}</optgroup>`).join("")}
              </select>
              <span aria-hidden="true">⌄</span>
            </div>
            <div class="country-selection-preview">
              <span class="flag">${selectedCountry?.flag || "◎"}</span>
              <div><strong>${selectedCountry?.name || "尚未选择国籍"}</strong><small>${selectedCountry ? `${selectedCountry.region} · ${selectedCountry.trait} · 母语 ${selectedCountry.language}` : `收录 ${COUNTRIES.length} 个拥有 CS 职业选手履历的国家与地区`}</small></div>
            </div>
            <small id="country-picker-note">展开列表后可滚动浏览；桌面端也可以输入国家名称的首字快速定位。</small>
          </div>
        </div>

        <div class="setup-section">
          <p class="section-label"><span class="index">03</span> 场上定位</p>
          <div class="choice-grid">
            ${ROLES.map((item) => `
              <button class="select-card ${state.profile.role === item.id ? "selected" : ""}" data-action="select-role" data-id="${item.id}" aria-pressed="${state.profile.role === item.id}">
                <span class="role-icon">${item.code}</span><strong>${item.name}</strong><small>${item.desc}</small>
              </button>`).join("")}
          </div>
        </div>

        <div class="setup-footer">
          <p>下一步：进行 4 轮能力抽取，每轮三选一。</p>
          <button class="button button-primary" data-action="start-draft" ${(!state.profile.nickname.trim() || !state.profile.country || !state.profile.role) ? "disabled" : ""}>进入能力抽取 <span class="button-arrow">→</span></button>
        </div>
      </section>`;
  }

  function initializeProspect() {
    const base = () => randomBetween(45, 52);
    state.stats = { mechanics: base(), gameSense: base(), teamwork: base(), mentality: base(), fitness: randomBetween(51, 58) };
    initializeLanguages();
    initializeMapSkills();
    state.fame = 0;
    const modifiers = [country()?.mods || {}, role()?.mods || {}];
    modifiers.forEach((mods) => applyEffects(mods, false));
    state.development = { points: 2, potential: {}, completed: [], seasonStartStats: {} };
    ensureDevelopmentState(true);
    state.career.fans = state.fame;
    state.career.peakOverall = overall();
  }

  function ensureDevelopmentState(reset = false) {
    state.development ??= { points: 2, potential: {}, completed: [], seasonStartStats: {} };
    state.development.potential ??= {};
    state.development.completed ??= [];
    state.development.points ??= 2;
    const rolePriorities = {
      awper: { mechanics: 6, mentality: 4 }, entry: { mechanics: 6, fitness: 5 },
      rifler: { mechanics: 5, gameSense: 3 }, igl: { gameSense: 7, teamwork: 5 },
      support: { teamwork: 6, gameSense: 5 }
    }[state.profile.role] || {};
    STAT_META.forEach(([key]) => {
      if (reset || state.development.potential[key] == null) {
        const base = 80 + stableHash(`${state.profile.nickname}-${state.profile.role}-${key}-potential`) % 10 + (rolePriorities[key] || 0);
        state.development.potential[key] = Math.min(99, Math.max(state.stats[key] + 8, base));
      } else {
        state.development.potential[key] = Math.max(state.stats[key], Math.min(99, state.development.potential[key]));
      }
    });
  }

  function addDevelopmentPoints(points, reason = "比赛经验") {
    ensureDevelopmentState();
    const gain = Math.max(0, Math.round(points || 0));
    state.development.points += gain;
    if (gain) addHistory("成长", `${reason} · 发展点 +${gain}`, `当前可用 ${state.development.points} 点`);
    return gain;
  }

  function applyDevelopmentEffects(effects = {}, potentialEffects = {}) {
    ensureDevelopmentState();
    Object.entries(potentialEffects).forEach(([key, value]) => {
      if (state.development.potential[key] != null) state.development.potential[key] = clamp(state.development.potential[key] + value, state.stats[key], 99);
    });
    const remainder = {};
    Object.entries(effects).forEach(([key, value]) => {
      if (state.stats[key] != null && value > 0) {
        state.stats[key] = Math.min(state.development.potential[key] || 99, clamp(state.stats[key] + value));
      } else remainder[key] = value;
    });
    applyEffects(remainder);
    state.career.peakOverall = Math.max(state.career.peakOverall, overall());
  }

  function generateDraftChoices() {
    const available = ABILITIES.filter((ability) => !state.abilities.includes(ability.id));
    const chosen = [];
    const add = (ability) => {
      if (ability && !chosen.some((item) => item.id === ability.id)) chosen.push(ability);
    };
    const weightedPick = (pool) => {
      if (!pool.length) return null;
      const weighted = pool.map((ability) => {
        const roleWeight = ability.roles?.includes(state.profile.role) ? 5 : ability.roles?.length ? 0.7 : 2.2;
        const rarityWeight = ability.rarity === "史诗" ? 0.72 : ability.rarity === "稀有" ? 1.2 : 1.5;
        return { ability, weight: roleWeight * rarityWeight };
      });
      let roll = Math.random() * weighted.reduce((sum, item) => sum + item.weight, 0);
      return weighted.find((item) => (roll -= item.weight) <= 0)?.ability || weighted[weighted.length - 1].ability;
    };
    if (state.draftRound === 3) add(weightedPick(available.filter((ability) => ability.rarity === "史诗")));
    const completers = available.filter((ability) => abilityComboHints(ability).length);
    add(weightedPick(completers));
    add(weightedPick(available.filter((ability) => ability.roles?.includes(state.profile.role))));
    while (chosen.length < 3) add(weightedPick(available.filter((ability) => !chosen.some((item) => item.id === ability.id))));
    state.draftChoices = shuffle(chosen).map((item) => item.id);
  }

  function renderDraft() {
    const picked = state.abilities.map((id) => ABILITIES.find((item) => item.id === id)).filter(Boolean);
    const choices = state.draftChoices.map((id) => ABILITIES.find((item) => item.id === id)).filter(Boolean);
    root.innerHTML = `
      <section class="page">
        <div class="page-head">
          <div>
            <p class="eyebrow">ABILITY DRAFT</p>
            <h1>发现你的天赋</h1>
            <p>每轮只能带走一项能力。选择会立即写入你的选手档案。</p>
          </div>
          <div class="step-indicator" aria-label="第 2 阶段，共 2 阶段"><span class="active"></span><span class="active"></span></div>
        </div>
        <div class="draft-layout">
          <aside class="draft-sidebar">
            <div>
              <div class="prospect-id">
                <div class="prospect-avatar">${esc(state.profile.nickname.slice(0, 2).toUpperCase())}</div>
                <h3>${esc(state.profile.nickname)}</h3>
                <p>${country()?.flag} ${country()?.name} · ${role()?.name} · 18 岁</p>
              </div>
              ${renderStatList()}
            </div>
            <div class="picked-slots">
              ${[0,1,2,3].map((index) => {
                const ability = picked[index];
                return `<div class="picked-slot ${ability ? "filled" : ""}"><span class="slot-index">${index + 1}</span><span>${ability ? ability.name : "等待选择"}</span></div>`;
              }).join("")}
            </div>
            <div class="draft-combos">
              <span>已激活组合</span>
              ${activeAbilityCombos().length ? activeAbilityCombos().map((combo) => `<b>${combo.name}</b>`).join("") : `<small>选择互相呼应的能力即可激活</small>`}
            </div>
          </aside>
          <div class="draft-main">
            <div class="draw-status">
              <h2>选择一项能力</h2>
              <div class="round-counter"><b>${state.draftRound + 1}</b> / 4 ROUND</div>
            </div>
            <div class="ability-grid">
              ${choices.map((ability) => `
                <button class="ability-card ${ability.rarity === "史诗" ? "epic" : ""}" data-action="pick-ability" data-id="${ability.id}" data-code="${ability.code}">
                  <span class="ability-rarity">◆ ${ability.rarity}能力 · ${abilityRoleLabel(ability)}</span>
                  <h3>${ability.name}</h3>
                  <p>${ability.desc}</p>
                  ${abilityComboHints(ability).map((combo) => `<span class="combo-hint">可激活：${combo.name}</span>`).join("")}
                  <span class="ability-effects">${effectsToChips(ability.effects)}</span>
                  <span class="ability-pick">选择这项能力</span>
                </button>`).join("")}
            </div>
          </div>
        </div>
      </section>`;
  }

  function renderStatList() {
    return `<div class="stat-list">${STAT_META.map(([key, label]) => `
      <div class="stat-row"><div class="stat-row-head"><span>${label}</span><b>${state.stats[key]}</b></div><div class="stat-track"><div class="stat-fill" style="width:${state.stats[key]}%"></div></div></div>`).join("")}</div>`;
  }

  function effectsToChips(effects) {
    const labels = { mechanics: "枪法", gameSense: "意识", teamwork: "团队", mentality: "心态", fitness: "状态", fame: "关注", money: "资金", cohesion: "默契", english: "英语", language: "队内语言", influence: "影响力", sponsor: "商业收入", mapWeak: "弱图", mapStrong: "强图", scrim: "训练赛" };
    return Object.entries(effects).map(([key, value]) => `<span class="effect-chip">${labels[key] || key} ${value > 0 ? "+" : ""}${value >= 1000 ? `${Math.round(value/100)/10}K` : value}</span>`).join("");
  }

  function applyEffects(effects, track = true) {
    Object.entries(effects || {}).forEach(([key, value]) => {
      if (Object.prototype.hasOwnProperty.call(state.stats, key)) {
        let change = value;
        if (track && change > 0 && hasPerk("fastGrowth")) change *= 1.2;
        if (track && key === "fitness" && change < 0 && hasPerk("resilient")) change *= 0.65;
        if (change > 0) {
          const potentialCap = state.development?.potential?.[key] ?? 99;
          state.stats[key] = Math.min(potentialCap, clamp(state.stats[key] + change));
        } else {
          state.stats[key] = clamp(state.stats[key] + change);
        }
      } else if (key === "fame") {
        state.fame = Math.max(0, state.fame + value);
        state.career.fans = Math.max(0, state.career.fans + value);
        state.career.influence = clamp(state.career.influence + value / 120, 0, 100);
      } else if (key === "money") {
        state.career.money = Math.max(0, state.career.money + value);
      } else if (key === "cohesion") {
        state.career.cohesion = clamp(state.career.cohesion + value);
      } else if (key === "english") {
        state.languages["英语"] = clamp((state.languages["英语"] || 0) + value, 0, 100);
      } else if (key === "language") {
        const requiredLanguage = teamLanguage(team());
        state.languages[requiredLanguage] = clamp((state.languages[requiredLanguage] || 0) + value, 0, 100);
      } else if (key === "influence") {
        state.career.influence = clamp(state.career.influence + value, 0, 100);
      } else if (key === "sponsor") {
        state.career.money += value;
        state.career.earnings += value;
        state.career.sponsorIncome += value;
      } else if (key === "mapWeak" || key === "mapStrong") {
        const ordered = MAPS.map((map) => ({ id: map.id, value: mapSkill(map.id) })).sort((a,b) => a.value - b.value);
        const target = key === "mapWeak" ? ordered[0] : ordered[ordered.length - 1];
        state.mapSkills[target.id] = clamp(target.value + value);
      } else if (key === "scrim") {
        state.career.scrims += value;
      }
    });
    state.career.peakOverall = Math.max(state.career.peakOverall, overall());
  }

  function startCareer() {
    state.phase = "career";
    state.year = CURRENT_YEAR;
    state.age = 18;
    state.season = 1;
    state.currentEvent = createContractEvent(true);
    saveGame();
    render();
    notify("球探报告已进入俱乐部数据库");
  }

  function createContractEvent(initial = false) {
    const offers = generateOffers(initial);
    const pathLabel = { domestic: "本国回归路线", tier2: "二线核心路线", last_dance: "最后一舞路线" }[state.career.lateCareerPath];
    return {
      type: "contracts",
      initial,
      title: initial ? "第一批合同送到了经纪人手中" : "转会窗口已经开启",
      desc: initial
        ? "你的地区赛表现吸引了几家俱乐部。第一份职业合同将决定生涯起点，但不会决定终点。"
        : `${state.contract?.yearsLeft > 0 ? "现有合同仍然有效，但市场上出现了新的兴趣。" : "合约已经到期。俱乐部与竞争者都在等待你的决定。"}${pathLabel ? ` 经纪人正在执行“${pathLabel}”，对应俱乐部会优先出现。` : ""}`,
      offers
    };
  }

  function lateCareerOfferBias(candidate) {
    const path = state.career.lateCareerPath;
    if (!path) return 0;
    const localIds = country()?.locals || [];
    if (path === "domestic") {
      if (localIds.includes(candidate.id)) return -34;
      if (candidate.country === country()?.name) return -28;
      if (candidate.region === profileRegion()) return -10;
      return 12;
    }
    if (path === "tier2") return hiddenTeamStrength(candidate) <= 72 ? -24 : hiddenTeamStrength(candidate) >= 82 ? 18 : 0;
    if (path === "last_dance") return (localIds.includes(candidate.id) || hiddenTeamStrength(candidate) <= 68) ? -28 : 10;
    return 0;
  }

  function generateOffers(initial) {
    const ov = overall();
    const current = team();
    const localIds = country()?.locals || [];
    let eligible = TEAMS.filter((candidate) => candidate.id !== state.teamId);
    const currentVrsBonus = current ? Math.max(0, 45 - vrsEntry(current.id).globalRank) / 4 : 0;
    const recentRating = state.career.seasonHistory.at(-1)?.rating || 1;
    const agePenalty = initial ? 0 : Math.max(0, state.age - 30) * 1.35 - Math.max(0, recentRating - 1.02) * 18;
    const marketShockBonus = (state.world?.marketShockUntil || 0) >= state.year ? 8 : 0;
    const maxRep = initial ? Math.min(68, ov + 13) : Math.min(98, ov + 15 + Math.floor(state.fame / 1600) + Math.floor(state.career.influence / 14) + currentVrsBonus + marketShockBonus - agePenalty);
    const minRep = initial ? 43 : state.career.lateCareerPath ? 42 : Math.max(42, ov - 16);
    eligible = eligible.filter((candidate) => hiddenTeamStrength(candidate) <= maxRep && hiddenTeamStrength(candidate) >= minRep);
    if (eligible.length < 5) eligible = TEAMS.filter((candidate) => candidate.id !== state.teamId && hiddenTeamStrength(candidate) <= (initial ? 70 : maxRep + 10));
    eligible.sort((a, b) => {
      const aLocal = localIds.includes(a.id) ? 18 : 0;
      const bLocal = localIds.includes(b.id) ? 18 : 0;
      const aLanguage = (100 - languageCompatibility(a)) * 0.2;
      const bLanguage = (100 - languageCompatibility(b)) * 0.2;
      const aRegion = a.region === profileRegion() ? 0 : 6;
      const bRegion = b.region === profileRegion() ? 0 : 6;
      const aNeed = (100 - roleDemand(a).score) * 0.07;
      const bNeed = (100 - roleDemand(b).score) * 0.07;
      return (Math.abs(hiddenTeamStrength(a) - ov) - aLocal + aLanguage + aRegion + aNeed + lateCareerOfferBias(a) + Math.random() * 8)
        - (Math.abs(hiddenTeamStrength(b) - ov) - bLocal + bLanguage + bRegion + bNeed + lateCareerOfferBias(b) + Math.random() * 8);
    });

    const offerTeams = eligible.slice(0, initial ? 3 : 2);
    const offers = offerTeams.map((candidate) => makeOffer(candidate, false, initial));
    if (!initial && current) {
      const stayTeam = { ...current };
      offers.unshift(makeOffer(stayTeam, true, false));
    }
    return offers.slice(0, 3);
  }

  function makeOffer(candidate, stay, initial) {
    const communication = languageCompatibility(candidate);
    const demand = roleDemand(candidate);
    const languageFactor = 0.86 + communication * 0.0014;
    const vrsMarket = team() ? Math.max(-0.04, Math.min(0.16, (55 - vrsEntry(team().id).globalRank) / 260)) : 0;
    const performanceFactor = (0.82 + overall() / 170 + state.fame / 50000 + state.career.influence / 1000 + vrsMarket) * languageFactor;
    const veteranSalaryFactor = state.age <= 29 ? 1 : Math.max(0.62, 1 - (state.age - 29) * 0.055);
    const salary = Math.round(candidate.salary * performanceFactor * veteranSalaryFactor / 100) * 100;
    const years = initial ? randomBetween(1, 2) : state.career.finalSeason || state.age >= 34 ? 1 : state.age >= 31 ? randomBetween(1, 2) : randomBetween(1, 3);
    const clubStrength = hiddenTeamStrength(candidate);
    const goal = clubStrength >= 90 ? "争夺冠军" : clubStrength >= 76 ? "打进淘汰赛" : clubStrength >= 60 ? "稳定世界排名" : "突破地区赛";
    const veteranCore = state.age >= 31 && clubStrength <= 74;
    const squadRole = stay ? (state.age >= 32 ? "老将轮换 / 场上导师" : "保留现有位置") : veteranCore ? "老将核心 / 场上导师" : communication < 42 ? "试训 / 轮换" : demand.score >= 90 && overall() >= clubStrength - 5 ? "首发核心" : demand.score >= 60 ? "轮换竞争" : "位置竞争";
    return {
      teamId: candidate.id, stay, salary: Math.max(2200, salary), years,
      bonus: stay ? 0 : Math.round(candidate.salary * randomBetween(1, 4) / 100) * 100,
      goal, role: squadRole, language: teamLanguage(candidate), communication, demand: demand.label,
      path: state.age >= 29 ? (lateCareerOfferBias(candidate) < -15 ? "符合生涯路线" : "开放市场报价") : null
    };
  }

  function acceptOffer(index) {
    const offer = state.currentEvent.offers[index];
    if (!offer) return;
    const previous = team();
    const nextTeam = TEAMS.find((item) => item.id === offer.teamId);
    const changed = previous?.id !== nextTeam.id;
    state.teamId = nextTeam.id;
    state.contract = { salary: offer.salary, yearsLeft: offer.years, goal: offer.goal, role: offer.role };
    state.career.money += offer.bonus;
    if (changed || !previous) {
      state.career.teamHistory.push({ year: state.year, teamId: nextTeam.id, from: previous?.name || "青训 / 地区赛" });
      addHistory("转会", `加盟 ${nextTeam.name}`, `${offer.years} 年合同 · ${offer.role}`);
      state.career.cohesion = clamp(43 + Math.round(languageCompatibility(nextTeam) / 7) + (hasPerk("polyglot") ? 5 : 0) + (localTeam(nextTeam) ? 5 : 0));
    } else {
      addHistory("续约", `与 ${nextTeam.name} 继续合作`, `${offer.years} 年新约`);
      state.career.cohesion = clamp(state.career.cohesion + 4);
    }
    startSeason();
    notify(changed || !previous ? `已签约 ${nextTeam.name}` : `已与 ${nextTeam.name} 续约`);
  }

  function localTeam(candidate) { return (country()?.locals || []).includes(candidate.id); }

  function teamTier(candidate) {
    const strength = hiddenTeamStrength(candidate);
    if (strength >= 88) return "S 级 · 冠军争夺者";
    if (strength >= 74) return "A 级 · 国际一线";
    if (strength >= 62) return "B 级 · 二线劲旅";
    return "C 级 · 地区 / 新秀队";
  }

  function createGrowthOpportunity() {
    ensureDevelopmentState();
    const roleGrowth = {
      awper: ["mechanics", "mentality", "大狙导师"], entry: ["mechanics", "fitness", "突破专项教练"],
      rifler: ["mechanics", "gameSense", "步枪技术教练"], igl: ["gameSense", "teamwork", "战术导师"],
      support: ["teamwork", "gameSense", "体系与道具教练"]
    }[state.profile.role] || ["mechanics", "gameSense", "专项教练"];
    const lastResult = state.seasonData?.results?.[state.seasonData.results.length - 1];
    const breakout = lastResult?.rating >= 1.15;
    const eliteResources = hiddenTeamStrength(team()) >= 78;
    return {
      type: "growth", tag: breakout ? "突破机遇" : "成长节点",
      title: breakout ? "一场出色的赛事让教练组重新评估了你的上限" : eliteResources ? "俱乐部为你开放了一期精英训练计划" : "休赛周出现了一段难得的专项提升窗口",
      desc: `你拥有 ${state.development.points} 个发展点。选择会形成永久能力成长，但潜力、身体负荷和队内角色会限制收益。`,
      options: [
        { label: `跟随${roleGrowth[2]}训练`, cost: 3, hint: "强化位置核心能力并小幅提高潜力", effects: { [roleGrowth[0]]: 3, [roleGrowth[1]]: 1 }, potential: { [roleGrowth[0]]: 1 }, outcome: `连续数周的一对一训练让你对${role()?.name}的理解进入了新阶段。` },
        { label: "参加高强度技术集训", cost: 2, hint: "提升枪法与弱图，消耗身体状态", effects: { mechanics: 2, mapWeak: 3, fitness: -2 }, potential: {}, outcome: "密集训练很累，但过去回避的对枪和地图位置开始变得自然。" },
        { label: breakout ? "把高光转化为稳定打法" : "学习更完整的团队体系", cost: 2, hint: "提高意识、团队能力与阵容默契", effects: { gameSense: 2, teamwork: 2, cohesion: 2 }, potential: { mentality: 1 }, outcome: "你的进步不再只体现在数据上，队友开始主动询问你的判断。" },
        { label: "制定长期个人计划", cost: 1, hint: "即时提升较少，但拓宽角色核心潜力", effects: { mentality: 1 }, potential: { [roleGrowth[0]]: 2 }, outcome: "教练没有承诺立刻见效，但为你重新规划了未来两个赛季的发展路线。" }
      ]
    };
  }

  function chooseGrowthOpportunity(index) {
    const event = state.currentEvent;
    const option = event?.options?.[index];
    if (!option || event.type !== "growth") return;
    ensureDevelopmentState();
    if (state.development.points < option.cost) {
      notify(`发展点不足：需要 ${option.cost} 点`);
      return;
    }
    const before = Object.fromEntries(STAT_META.map(([key]) => [key, state.stats[key]]));
    state.development.points -= option.cost;
    applyDevelopmentEffects(option.effects, option.potential);
    state.development.completed.push({ year: state.year, title: option.label });
    const changes = STAT_META.map(([key, label]) => state.stats[key] !== before[key] ? `${label} ${before[key]}→${state.stats[key]}` : null).filter(Boolean).join(" · ");
    addHistory("成长机遇", option.label, changes || "潜力上限得到提升");
    state.currentEvent = { type: "outcome", tag: event.tag, title: option.label, desc: option.outcome, effects: option.effects };
    saveGame();
    render();
  }

  function hydrateEasterEggEvent(event) {
    const template = EASTER_EGGS.find((item) => item.id === (event?.eggId || event?.id));
    if (!template) return event;
    const cloned = JSON.parse(JSON.stringify(template));
    return { type: "easter", eggId: template.id, ...cloned, ...event, options: event?.options?.length ? event.options : cloned.options };
  }

  function createRandomEasterEgg(forceId = null) {
    const used = new Set((state.career.easterEggs || []).map((entry) => entry.id));
    const eligible = EASTER_EGGS.filter((egg) => (!forceId || egg.id === forceId) && !used.has(egg.id)
      && state.age >= (egg.minAge || 18) && state.season >= (egg.minSeason || 1));
    if (!eligible.length) return null;
    const total = eligible.reduce((sum, egg) => sum + (egg.weight || 1), 0);
    let roll = Math.random() * total;
    const selected = eligible.find((egg) => (roll -= egg.weight || 1) <= 0) || eligible[eligible.length - 1];
    return hydrateEasterEggEvent({ type: "easter", eggId: selected.id });
  }

  function addWorldProspect({ id, nickname, country: prospectCountry, role: prospectRole, peak, debut = state.year + 1 }) {
    ensureWorldState();
    if (awardRivals().some((rival) => rival.id === id)) return;
    state.world.prospects.push({
      id, nickname, country: prospectCountry, role: prospectRole, debut,
      primeStart: debut + 1, primeEnd: debut + 8, retire: debut + 14, peak, future: true, easterEgg: true
    });
  }

  function setSpecialMatchBonus(value, matches, label) {
    state.seasonData ??= {};
    state.seasonData.specialMatchBonus = { value, matches, label };
  }

  function setPreparationPenalty(value, matches, label) {
    state.seasonData ??= {};
    state.seasonData.preparationPenalty = { value, matches, label };
  }

  function strongestTeam(filter = () => true) {
    return [...TEAMS].filter(filter).sort((a, b) => hiddenTeamStrength(b) - hiddenTeamStrength(a))[0] || null;
  }

  function activateEasterEgg(event) {
    if (!event || event.type !== "easter" || event.triggered) return;
    ensureWorldState();
    event.triggered = true;
    event.impactNotes = event.impactNotes || [];
    if (!state.career.easterEggs.some((entry) => entry.id === event.eggId)) state.career.easterEggs.push({ id: event.eggId, year: state.year, title: event.title });
    if (event.eggId === "cs3") {
      const beforeMechanics = state.stats.mechanics;
      const beforeSense = state.stats.gameSense;
      state.stats.mechanics = Math.min(80, state.stats.mechanics);
      state.stats.gameSense = Math.min(80, state.stats.gameSense);
      state.world.cs3TransitionUntil = state.year + 1;
      Object.keys(state.teamForm || {}).forEach((teamId) => { state.teamForm[teamId] = Math.round(state.teamForm[teamId] * 0.35); });
      event.impactNotes.push(`个人枪法 ${beforeMechanics}→${state.stats.mechanics}，意识 ${beforeSense}→${state.stats.gameSense}`);
      event.impactNotes.push(`所有高强度队伍在 ${state.year}–${state.year + 1} 赛季被压缩实力差距`);
    }
    if (event.eggId === "magic_prodigy") {
      const boosted = strongestTeam((candidate) => candidate.country === "俄罗斯" || ["spirit", "betboom", "aurora"].includes(candidate.id));
      addWorldProspect({ id: `malysh-${state.year}`, nickname: "malysh", country: "俄罗斯", role: "步枪手", peak: 114, debut: state.year });
      if (boosted) {
        const entry = state.vrs.teams[boosted.id];
        entry.points = Math.min(2500, entry.points + 180);
        entry.lastDelta = 180;
        addTeamStrengthEffect(boosted.id, 7, 3, "魔童加入阵容");
        event.impactNotes.push(`${boosted.name} 获得魔童：VRS +180，隐藏实力 +7，持续 3 个赛季`);
      }
      event.impactNotes.push("malysh 已加入模拟 HLTV 年度竞争者池");
    }
    if (event.eggId === "snake_brothers") {
      const entry = state.vrs.teams[team().id];
      const before = entry.points;
      entry.points = Math.max(350, Math.floor(entry.points / 2));
      entry.lastDelta = entry.points - before;
      state.teamForm[team().id] = -8;
      state.career.cohesion = clamp(state.career.cohesion - 25);
      addTeamStrengthEffect(team().id, -7, 2, "阵容背刺与战术泄露");
      event.impactNotes.push(`${team().name} VRS ${before}→${entry.points}，阵容默契 -25`);
      event.impactNotes.push("隐藏实力 -7，持续 2 个赛季，之后仍需通过赛事重新积累 VRS");
    }
    if (event.eggId === "valve_time") {
      state.seasonData.patchChaosMatches = 2;
      event.impactNotes.push("接下来 2 场比赛的模型胜率向 50% 压缩；80+ 意识可获得适应补偿");
    }
    if (event.eggId === "reverse_superteam") {
      const collapsed = strongestTeam((candidate) => candidate.id !== team().id && candidate.rep >= 84);
      if (collapsed) {
        const entry = state.vrs.teams[collapsed.id];
        const before = entry.points;
        entry.points = Math.max(500, Math.round(entry.points * 0.72));
        entry.lastDelta = entry.points - before;
        state.teamForm[collapsed.id] = -8;
        addTeamStrengthEffect(collapsed.id, -7, 2, "银河战舰解体");
        state.world.marketShockUntil = state.year + 2;
        event.impactNotes.push(`${collapsed.name} VRS ${before}→${entry.points}，隐藏实力 -7`);
        event.impactNotes.push(`高水平俱乐部报价门槛放宽至 ${state.year + 2} 转会窗`);
      }
    }
    if (event.eggId === "six_languages") {
      state.career.cohesion = clamp(state.career.cohesion - 10);
      event.impactNotes.push("阵容默契先行 -10，选择将决定恢复幅度");
    }
    if (event.eggId === "lost_playbook") {
      setPreparationPenalty(4, 1, "战术本泄露");
      event.impactNotes.push("下一场公开胜率模型先承受 -4.0 准备修正");
    }
    if (event.eggId === "public_review") {
      setPreparationPenalty(6, 1, "公开复盘泄露");
      event.impactNotes.push("下一场公开胜率模型先承受 -6.0 准备修正");
    }
    addHistory("随机彩蛋", event.title, event.impactNotes.join(" · ") || "彩蛋进入本赛季");
  }

  function replaceNextTournament(tournamentId) {
    const index = state.seasonQueue.findIndex((event) => event.type === "tournament");
    if (index < 0) return false;
    state.seasonQueue[index] = makeTournamentEvent(tournamentId);
    return true;
  }

  function applyEasterSpecial(code, event) {
    let note = "";
    if (["coach_training", "coach_system", "support_last_dance"].includes(code)) state.career.coachingPotential = clamp(state.career.coachingPotential + (code === "support_last_dance" ? 8 : 4), 0, 100);
    if (code === "coach_carry") { setSpecialMatchBonus(3.5, 1, "教练替补 · 主力 Carry"); note = "下一场公开模型获得 +3.5 特殊修正。"; }
    if (code === "coach_training") { setSpecialMatchBonus(2, 1, "教练替补 · 共同准备"); note = "下一场公开模型获得 +2.0，教练潜力 +4。"; }
    if (code === "coach_system") { setSpecialMatchBonus(1.5, 1, "教练替补 · 保护体系"); note = "下一场公开模型获得 +1.5，教练潜力 +4。"; }
    if (code === "smoke_lab") { setSpecialMatchBonus(2.5, 3, "烟雾实验室"); note = "未来 3 场比赛获得 +2.5 准备修正。"; }
    if (code === "cafe_recommend" || code === "cafe_duel" || code === "cafe_dismiss") {
      const peak = code === "cafe_dismiss" ? 108 : code === "cafe_duel" ? 106 : 104;
      addWorldProspect({ id: `cafe-${state.year}`, nickname: "LANkid", country: country()?.name || "未知", role: sample(["步枪手", "AWP", "突破手"]), peak });
      const local = (country()?.locals || []).map((id) => TEAMS.find((candidate) => candidate.id === id)).filter(Boolean)[0];
      if (local) addTeamStrengthEffect(local.id, code === "cafe_recommend" ? 3 : 2, 3, "网吧新秀加入青训");
      note = `LANkid 将于 ${state.year + 1} 年进入模拟年度竞争者池，峰值 ${peak}。`;
    }
    if (code === "join_last_dance") { state.career.lateCareerPath = "domestic"; note = "下一转会窗将强力优先本国与地区队伍。"; }
    if (code === "support_last_dance") note = "教练潜力 +8。";
    if (code === "prepare_exit") { state.career.lateCareerPath = "tier2"; note = "下一转会窗将优先二线核心位置。"; }
    if (code === "track_free_agents") { state.world.marketShockUntil = Math.max(state.world.marketShockUntil, state.year + 3); note = "高水平报价门槛额外延长 1 年。"; }
    if (code === "rebuild_playbook") { state.seasonData.preparationPenalty.value = 0; note = "下一场战术泄露修正已清除。"; }
    if (code === "change_playbook_map") { state.seasonData.preparationPenalty.value = 2; note = "下一场战术泄露修正降低为 -2.0。"; }
    if (code === "playbook_mindgame") {
      state.seasonData.preparationPenalty.value = Math.random() < 0.5 ? -2.5 : 4.5;
      note = state.seasonData.preparationPenalty.value < 0 ? "心理博弈成功：下一场变为 +2.5 准备修正。" : "对手没有上当：下一场承受 -4.5 准备修正。";
    }
    if (code === "system_gamble") {
      const bonus = Math.random() < 0.55 ? 4 : -4;
      setSpecialMatchBonus(bonus, 1, bonus > 0 ? "系统更新 · 设置完整保留" : "系统更新 · 设置异常");
      note = `设备结果已确定：下一场公开模型 ${bonus > 0 ? "+" : ""}${bonus.toFixed(1)}。`;
    }
    if (code === "borrow_setup") { setSpecialMatchBonus(-1, 1, "陌生外设"); note = "下一场公开模型 -1.0。"; }
    if (code === "cold_start") { setSpecialMatchBonus(-2.5, 1, "零热身冷启动"); note = "下一场公开模型 -2.5。"; }
    if (code === "trace_chosen" || code === "scrim_chosen" || code === "question_chosen") {
      const peak = code === "question_chosen" ? 109 : code === "scrim_chosen" ? 107 : 105;
      addWorldProspect({ id: `chosen-${state.year}`, nickname: "NullFace", country: "未知", role: "自由人", peak });
      note = `NullFace 将于 ${state.year + 1} 年出道，模拟峰值 ${peak}。`;
    }
    if (code === "take_calling") {
      const bonus = Math.max(-1, Math.min(4, (state.stats.gameSense + state.stats.teamwork - 120) / 18));
      setSpecialMatchBonus(bonus, 1, "临时接管指挥"); note = `下一场根据意识与团队能力获得 ${bonus >= 0 ? "+" : ""}${bonus.toFixed(1)}。`;
    }
    if (code === "appoint_caller") { setSpecialMatchBonus(1.5, 1, "第二指挥接管"); note = "下一场公开模型 +1.5。"; }
    if (code === "all_aim") {
      const bonus = Math.max(-2, Math.min(4, (state.stats.mechanics - 65) / 7));
      setSpecialMatchBonus(bonus, 1, "见人就打"); note = `下一场根据枪法获得 ${bonus >= 0 ? "+" : ""}${bonus.toFixed(1)}。`;
    }
    if (code === "old_mouse_gamble") {
      const bonus = Math.random() < 0.6 ? 4.5 : -5;
      setSpecialMatchBonus(bonus, 1, bonus > 0 ? "祖传外设 · 手感爆炸" : "祖传外设 · 中途失灵");
      note = `设备结局已确定：下一场公开模型 ${bonus > 0 ? "+" : ""}${bonus.toFixed(1)}。`;
    }
    if (code === "keep_lucky_seats") { setSpecialMatchBonus(2, 1, "幸运座位"); note = "下一场公开模型 +2.0。"; }
    if (code === "delete_review") { state.seasonData.preparationPenalty.value = 1; note = "下一场泄露惩罚降低为 -1.0。"; }
    if (code === "monetize_review") { state.seasonData.preparationPenalty.value = 3.5; note = "下一场保留 -3.5 泄露惩罚。"; }
    if (code === "fake_public_review") {
      state.seasonData.preparationPenalty.value = Math.random() < 0.45 ? -3 : 5;
      note = state.seasonData.preparationPenalty.value < 0 ? "反向针对成功：下一场 +3.0。" : "对手识破：下一场 -5.0。";
    }
    if (code === "schedule_vrs") { replaceNextTournament("blast_rivals"); note = "下一项赛事已替换为 BLAST Rivals。"; }
    if (code === "schedule_money") { replaceNextTournament("fissure"); note = "下一项赛事已替换为 FISSURE Playground。"; }
    if (code === "schedule_both") { state.seasonQueue.unshift(makeTournamentEvent("fissure")); note = "赛季队列新增一项完整 FISSURE Playground，比赛负荷将正常累计。"; }
    return note;
  }

  function chooseEasterEgg(index) {
    const event = state.currentEvent;
    const option = event?.options?.[index];
    if (!option || event.type !== "easter") return;
    applyEffects(option.effects || {});
    const specialNote = applyEasterSpecial(option.special, event);
    addHistory("彩蛋选择", option.label, `${option.outcome}${specialNote ? ` · ${specialNote}` : ""}`);
    state.currentEvent = {
      type: "outcome", tag: event.tag, title: option.label,
      desc: option.outcome, effects: option.effects || {}, impactNotes: [...(event.impactNotes || []), specialNote].filter(Boolean)
    };
    saveGame();
    render();
  }

  function startSeason() {
    ensureVrsState();
    const startEntry = vrsEntry(team().id);
    state.career.peakVrsRank = Math.min(state.career.peakVrsRank || 999, startEntry.globalRank);
    state.career.peakVrsPoints = Math.max(state.career.peakVrsPoints || 0, startEntry.points);
    ensureDevelopmentState();
    state.development.seasonStartStats = Object.fromEntries(STAT_META.map(([key]) => [key, state.stats[key]]));
    state.seasonData = { startOverall: overall(), startStats: { ...state.development.seasonStartStats }, results: [], matchLoad: 0, salary: state.contract.salary * 12, startMoney: state.career.money, startVrs: startEntry.points, startVrsRank: startEntry.globalRank };
    const regularEvents = CAREER_EVENTS.filter((event) => !event.foreignOnly);
    const foreignEvent = CAREER_EVENTS.find((event) => event.foreignOnly);
    const needsLanguageWork = languageCompatibility(team()) < 72;
    const featuredEvent = CAREER_EVENTS.find((event) => event.id === (state.season % 2 ? "scrim_day" : "media_day"));
    const remainingEvents = shuffle(regularEvents.filter((event) => event.id !== featuredEvent.id));
    const selectedEvents = needsLanguageWork && Math.random() < 0.8
      ? [foreignEvent, featuredEvent, remainingEvents[0]]
      : [featuredEvent, remainingEvents[0], remainingEvents[1]];
    const events = selectedEvents.map((event) => JSON.parse(JSON.stringify(event)));
    const regionalId = { "欧洲": "cct_europe", "美洲": "cct_americas", "亚洲": "cct_asia" }[team().region];
    const regionalEvent = TOURNAMENTS.find((t) => t.id === regionalId);
    const topPool = TOURNAMENTS.filter((t) => t.tier === "S");
    const developmentPool = TOURNAMENTS.filter((t) => t.tier === "A" && (!t.region || t.region === team().region));
    // VRS 名次为世界内 61 支队伍的实时派生口径：官方快照口径的「前 45 名」约等于世界内前 30 名
    const eliteRankCutoff = 30;
    let tournaments = startEntry.globalRank <= eliteRankCutoff
      ? shuffle(topPool).slice(0, 2)
      : unique([regionalEvent, sample(developmentPool)].filter(Boolean).map((t) => t.id)).map((id) => TOURNAMENTS.find((t) => t.id === id));
    while (tournaments.length < 2) {
      const extra = sample(startEntry.globalRank <= eliteRankCutoff ? topPool : developmentPool);
      if (extra && !tournaments.some((t) => t.id === extra.id)) tournaments.push(extra);
    }
    if (state.season % 2 === 0 || Math.random() > 0.62) tournaments[1] = sample(TOURNAMENTS.filter((t) => t.major));
    const easterEgg = Math.random() < (state.age >= 29 ? 0.48 : 0.4) ? createRandomEasterEgg() : null;
    state.seasonQueue = [
      { type: "decision", ...events[0] },
      ...(easterEgg ? [easterEgg] : []),
      makeTournamentEvent(tournaments[0].id),
      { type: "growth", pending: true },
      makeTournamentEvent(tournaments[1].id),
      { type: "decision", ...events[1] }
    ];
    nextSeasonEvent();
    saveGame();
  }

  function nextSeasonEvent() {
    if (state.seasonQueue.length) {
      state.currentEvent = state.seasonQueue.shift();
      if (state.currentEvent?.type === "growth" && state.currentEvent.pending) state.currentEvent = createGrowthOpportunity();
      if (state.currentEvent?.type === "easter") {
        state.currentEvent = hydrateEasterEggEvent(state.currentEvent);
        activateEasterEgg(state.currentEvent);
      }
      if (state.currentEvent?.type === "tournament") activateTournamentEvent(state.currentEvent);
    } else {
      finishSeason();
      return;
    }
    saveGame();
    render();
  }

  function tournamentOpponent(event = state.currentEvent) {
    let opponent = TEAMS.find((candidate) => candidate.id === event?.opponentId);
    if (!opponent && event?.tournamentId) {
      opponent = chooseOpponent(TOURNAMENTS.find((item) => item.id === event.tournamentId));
      event.opponentId = opponent.id;
    }
    return opponent;
  }

  function startVeto() {
    const event = state.currentEvent;
    event.veto = createVetoState(event);
    event.stage = "veto";
    if (state.preferences.vetoMode === "auto") {
      autoCompleteVeto(true);
      return;
    }
    saveGame();
    render();
  }

  function createVetoState(event) {
    const opponent = tournamentOpponent(event);
    const opponentProfile = teamMapProfile(opponent);
    const bestOf = currentMatchBestOf(event);
    return {
      stage: bestOf === 1 ? "bo1TeamBan" : "teamBan1",
      bestOf,
      available: MAPS.map((map) => map.id).filter((id) => id !== opponentProfile.permaban),
      selected: [],
      log: [{ team: opponent.name, action: "BAN", mapId: opponentProfile.permaban }]
    };
  }

  function bestMapFor(candidate, mapIds) {
    return [...mapIds].sort((a, b) => teamMapRate(candidate, b) - teamMapRate(candidate, a))[0];
  }

  function dangerMapFor(candidate, mapIds) {
    return [...mapIds].sort((a, b) => (teamMapRate(candidate, b) + mapSkill(b) * 0.25) - (teamMapRate(candidate, a) + mapSkill(a) * 0.25))[0];
  }

  function isKeyTournamentMatch(event = state.currentEvent) {
    const phase = event?.competition?.phase;
    const competition = event?.competition;
    if (["r16", "qf", "sf", "final"].includes(phase)) return true;
    if (phase === "qualifier") return competition.wins >= competition.qualifierWins - 1;
    const target = phase === "group" ? 2 : 3;
    return ["swiss", "group", "stage1", "stage2", "stage3"].includes(phase) && (competition.wins >= target - 1 || competition.losses >= target - 1);
  }

  function interactiveMomentLimit(event = state.currentEvent) {
    const tournament = TOURNAMENTS.find((item) => item.id === event?.tournamentId);
    if (state.preferences.pace === "fast") return 0;
    if (state.preferences.pace === "immersive") return tournament?.major ? 3 : 2;
    return tournament?.major ? 2 : 1;
  }

  function canPlayInteractiveMoment(event = state.currentEvent) {
    const used = event?.competition?.interactionsUsed || 0;
    const withinLimit = used < interactiveMomentLimit(event);
    return withinLimit && (state.preferences.pace === "immersive" || isKeyTournamentMatch(event));
  }

  function generateRoundContext(event = state.currentEvent) {
    const opponent = tournamentOpponent(event);
    const gap = hiddenTeamStrength(team()) - hiddenTeamStrength(opponent);
    const phase = event.competition.phase;
    const highStakes = ["qf", "sf", "final"].includes(phase) || isKeyTournamentMatch(event);
    const closeScores = highStakes ? [[10,10],[11,11],[11,12],[12,11],[9,12],[12,9]] : [[6,8],[8,7],[9,10],[10,8],[7,11],[11,7]];
    let [ourScore, theirScore] = sample(closeScores);
    if (gap >= 7 && ourScore < theirScore && Math.random() < 0.65) [ourScore, theirScore] = [theirScore, ourScore];
    if (gap <= -7 && ourScore > theirScore && Math.random() < 0.65) [ourScore, theirScore] = [theirScore, ourScore];
    const situation = ourScore === 12 ? "拿到赛点" : theirScore === 12 ? "挽救赛点" : ourScore < theirScore ? "追分关键局" : ourScore > theirScore ? "守住领先" : "打破僵局";
    return { ourScore, theirScore, round: ourScore + theirScore + 1, situation };
  }

  function continueAfterVeto(event = state.currentEvent) {
    if (!canPlayInteractiveMoment(event)) {
      event.trainingMapId = event.veto.selected[0]?.mapId || "mirage";
      event.trainingScore = { type: "managed", label: "教练组常规准备", score: 0, bonus: randomBetween(1, 3), comboBonus: 0, summary: "本场没有触发关键回合操作" };
      event.stage = "resolution";
      return;
    }
    if (!event.competition.trainingUsed) {
      event.stage = "training";
      return;
    }
    const selected = event.veto.selected.map((entry) => entry.mapId);
    event.trainingMapId = [...selected].sort((a, b) => mapSkill(a) - mapSkill(b))[0] || selected[0];
    event.scenarioType = chooseScenarioType(event.trainingMapId);
    event.roundContext = generateRoundContext(event);
    event.stage = "scenario";
  }

  function vetoMap(mapId, silent = false) {
    const event = state.currentEvent;
    const veto = event.veto;
    if (!veto?.available.includes(mapId)) return;
    const currentTeam = team();
    const opponent = tournamentOpponent(event);
    const remove = (id) => { veto.available = veto.available.filter((item) => item !== id); };

    if (veto.stage === "bo1TeamBan") {
      remove(mapId);
      veto.log.push({ team: currentTeam.name, action: "BAN", mapId });
      let opponentTurn = true;
      while (veto.available.length > 1) {
        const ban = opponentTurn
          ? dangerMapFor(currentTeam, veto.available)
          : [...veto.available].sort((a, b) => (teamMapRate(opponent, b) + mapSkill(b) * 0.18) - (teamMapRate(opponent, a) + mapSkill(a) * 0.18))[0];
        remove(ban);
        veto.log.push({ team: opponentTurn ? opponent.name : currentTeam.name, action: "BAN", mapId: ban });
        opponentTurn = !opponentTurn;
      }
      const decider = veto.available[0];
      veto.selected.push({ mapId: decider, pickedBy: "decider" });
      veto.log.push({ team: "赛事裁判", action: "DECIDER", mapId: decider });
      veto.stage = "complete";
      continueAfterVeto(event);
    } else if (veto.stage === "teamBan1") {
      remove(mapId);
      veto.log.push({ team: currentTeam.name, action: "BAN", mapId });
      const opponentPick = bestMapFor(opponent, veto.available);
      remove(opponentPick);
      veto.selected.push({ mapId: opponentPick, pickedBy: opponent.id });
      veto.log.push({ team: opponent.name, action: "PICK", mapId: opponentPick });
      veto.stage = "teamPick";
    } else if (veto.stage === "teamPick") {
      remove(mapId);
      veto.selected.push({ mapId, pickedBy: currentTeam.id });
      veto.log.push({ team: currentTeam.name, action: "PICK", mapId });
      const opponentSecondBan = dangerMapFor(currentTeam, veto.available);
      remove(opponentSecondBan);
      veto.log.push({ team: opponent.name, action: "BAN", mapId: opponentSecondBan });
      veto.stage = "teamBan2";
    } else if (veto.stage === "teamBan2") {
      remove(mapId);
      veto.log.push({ team: currentTeam.name, action: "BAN", mapId });
      const decider = veto.available[0];
      veto.selected.push({ mapId: decider, pickedBy: "decider" });
      veto.log.push({ team: "赛事裁判", action: "DECIDER", mapId: decider });
      veto.stage = "complete";
      continueAfterVeto(event);
    }
    if (!silent) {
      saveGame();
      render();
    }
  }

  function autoCompleteVeto(renderAfter = true) {
    const event = state.currentEvent;
    if (!event.veto) event.veto = createVetoState(event);
    let safety = 0;
    while (event.veto.stage !== "complete" && safety < 5) {
      safety += 1;
      const veto = event.veto;
      let choice;
      if (["bo1TeamBan", "teamBan1"].includes(veto.stage)) {
        const ownBan = teamMapProfile(team()).permaban;
        choice = veto.available.includes(ownBan) ? ownBan : [...veto.available].sort((a, b) => (teamMapRate(team(), a) + mapSkill(a) * 0.2) - (teamMapRate(team(), b) + mapSkill(b) * 0.2))[0];
      } else if (veto.stage === "teamPick") choice = bestMapFor(team(), veto.available);
      else choice = [...veto.available].sort((a, b) => (teamMapRate(team(), a) + mapSkill(a) * 0.2 - teamMapRate(tournamentOpponent(event), a)) - (teamMapRate(team(), b) + mapSkill(b) * 0.2 - teamMapRate(tournamentOpponent(event), b)))[0];
      vetoMap(choice, true);
    }
    if (renderAfter) {
      saveGame();
      render();
      notify("教练组已完成 Ban/Pick 托管");
    }
  }

  function targetedMapTraining(mapId) {
    const event = state.currentEvent;
    if (!event.veto?.selected.some((entry) => entry.mapId === mapId)) return;
    const before = mapSkill(mapId);
    const baseGain = before < 50 ? 4 : before < 65 ? 3 : 2;
    const trainingComboBonus = comboTrainingBonus();
    const gain = baseGain + trainingComboBonus;
    state.mapSkills[mapId] = clamp(before + gain);
    event.trainingMapId = mapId;
    event.mapBonus = before < 50 ? 4 : 2;
    event.scenarioType = chooseScenarioType(mapId);
    event.roundContext = generateRoundContext(event);
    event.competition.trainingUsed = true;
    event.stage = "scenario";
    addHistory("针对训练", `加练 ${mapById(mapId).name}`, `地图熟练度 ${before} → ${state.mapSkills[mapId]}${trainingComboBonus ? ` · 组合训练 +${trainingComboBonus}` : ""}`);
    saveGame();
    render();
  }

  function chooseScenarioType(mapId) {
    if (state.profile.role === "awper" && Math.random() < 0.62) return "reaction";
    if (["dust2", "cache"].includes(mapId) && Math.random() < 0.48) return "reaction";
    return sample(["aim", "spray", "deagle"]);
  }

  function enterKeyRound() {
    const event = state.currentEvent;
    event.minigame = { type: event.scenarioType || chooseScenarioType(event.trainingMapId) };
    event.stage = "keyRound";
    saveGame();
    render();
  }

  function clearGameRuntime() {
    if (!gameRuntime) return;
    [gameRuntime.timer, gameRuntime.waitTimer, gameRuntime.timeoutTimer, gameRuntime.enterTimer].forEach((timer) => {
      if (timer) clearTimeout(timer);
    });
    gameRuntime = null;
  }

  function selectMiniGame(type) {
    clearGameRuntime();
    state.currentEvent.minigame = { type };
    saveGame();
    render();
  }

  function beginMiniGame() {
    const type = state.currentEvent?.minigame?.type;
    if (!type || gameRuntime) return;
    const field = root.querySelector("[data-minigame-field]");
    const startButton = root.querySelector('[data-action="begin-minigame"]');
    if (!field) return;
    if (startButton) startButton.classList.add("hidden");
    root.querySelector(".minigame-actions")?.classList.add("hidden");
    field.classList.add("is-running");
    if (type === "aim") beginAimChallenge(field);
    if (type === "reaction") beginReactionChallenge(field);
    if (type === "spray") beginSprayChallenge(field);
    if (type === "deagle") beginDeagleChallenge(field);
  }

  function beginAimChallenge(field) {
    const duration = 8000;
    gameRuntime = { type: "aim", field, hits: 0, misses: 0, endAt: performance.now() + duration, timer: null };
    const message = el("game-message");
    if (message) message.textContent = "对手开始强攻，连续完成击杀！";
    spawnAimTarget();
    const tick = () => {
      if (!gameRuntime || gameRuntime.type !== "aim") return;
      const remaining = Math.max(0, gameRuntime.endAt - performance.now());
      const timeNode = el("game-time");
      if (timeNode) timeNode.textContent = `${(remaining / 1000).toFixed(1)}s`;
      if (remaining <= 0) { finishAimChallenge(); return; }
      gameRuntime.timer = setTimeout(tick, 50);
    };
    tick();
  }

  function spawnAimTarget() {
    if (!gameRuntime || gameRuntime.type !== "aim") return;
    const { field } = gameRuntime;
    field.querySelector(".aim-target")?.remove();
    const target = document.createElement("button");
    target.type = "button";
    target.className = "aim-target rifle-enemy";
    target.dataset.action = "hit-aim-target";
    target.setAttribute("aria-label", "步枪击倒出现的对手");
    const positions = [[13,60],[27,34],[43,61],[59,39],[74,58],[88,31]];
    const [x,y] = sample(positions);
    target.style.left = `${x}%`;
    target.style.top = `${y}%`;
    target.innerHTML = "<span class=\"enemy-head\"></span><span class=\"enemy-body\"></span>";
    field.appendChild(target);
  }

  function hitAimTarget() {
    if (!gameRuntime || gameRuntime.type !== "aim") return;
    gameRuntime.hits += 1;
    updateAimHud();
    spawnAimTarget();
  }

  function missAimTarget() {
    if (!gameRuntime || gameRuntime.type !== "aim") return;
    gameRuntime.misses += 1;
    updateAimHud();
  }

  function updateAimHud() {
    if (!gameRuntime) return;
    const hitsNode = el("game-hits");
    const accuracyNode = el("game-accuracy");
    const attempts = gameRuntime.hits + gameRuntime.misses;
    if (hitsNode) hitsNode.textContent = String(gameRuntime.hits);
    if (accuracyNode) accuracyNode.textContent = `${attempts ? Math.round(gameRuntime.hits / attempts * 100) : 100}%`;
  }

  function finishAimChallenge() {
    if (!gameRuntime || gameRuntime.type !== "aim") return;
    const { hits, misses } = gameRuntime;
    const accuracy = Math.round(hits / Math.max(1, hits + misses) * 100);
    const bonus = clamp(Math.floor(hits / 2 - misses * 0.2), 0, 8);
    const score = Math.max(0, hits * 100 - misses * 20);
    clearGameRuntime();
    finishMiniGame({ type: "aim", label: "步枪快速多杀", score, bonus, hits, accuracy, summary: `${hits} 次击杀 · ${accuracy}% 命中率` });
  }

  function beginSprayChallenge(field) {
    const duration = 7000;
    gameRuntime = { type: "spray", field, hits: 0, misses: 0, chain: 0, maxChain: 0, wave: 0, endAt: performance.now() + duration, timer: null };
    const message = el("game-message");
    if (message) message.textContent = "第一名对手出现，压枪后立刻转移！";
    spawnSprayWave();
    const tick = () => {
      if (!gameRuntime || gameRuntime.type !== "spray") return;
      const remaining = Math.max(0, gameRuntime.endAt - performance.now());
      const timeNode = el("game-time");
      if (timeNode) timeNode.textContent = `${(remaining / 1000).toFixed(1)}s`;
      if (remaining <= 0) { finishSprayChallenge(); return; }
      gameRuntime.timer = setTimeout(tick, 50);
    };
    tick();
  }

  function spawnSprayWave() {
    if (!gameRuntime || gameRuntime.type !== "spray") return;
    const runtime = gameRuntime;
    runtime.wave += 1;
    runtime.field.querySelectorAll(".spray-target").forEach((target) => target.remove());
    const formations = [
      [[24,58],[49,35],[74,57]], [[18,32],[50,62],[82,31]], [[30,48],[56,30],[78,61]]
    ];
    sample(formations).forEach(([x,y], index) => {
      const target = document.createElement("button");
      target.type = "button";
      target.className = `spray-target strafe-${index + 1}`;
      target.dataset.action = "hit-spray-target";
      target.style.left = `${x}%`;
      target.style.top = `${y}%`;
      target.setAttribute("aria-label", "扫射转移到下一名对手");
      target.innerHTML = "<span class=\"enemy-head\"></span><span class=\"enemy-body\"></span>";
      runtime.field.appendChild(target);
    });
    const waveNode = el("spray-wave");
    if (waveNode) waveNode.textContent = String(runtime.wave);
  }

  function hitSprayTarget(target) {
    if (!gameRuntime || gameRuntime.type !== "spray") return;
    gameRuntime.hits += 1;
    gameRuntime.chain += 1;
    gameRuntime.maxChain = Math.max(gameRuntime.maxChain, gameRuntime.chain);
    target.remove();
    const hitsNode = el("game-hits");
    const chainNode = el("spray-chain");
    if (hitsNode) hitsNode.textContent = String(gameRuntime.hits);
    if (chainNode) chainNode.textContent = String(gameRuntime.chain);
    if (!gameRuntime.field.querySelector(".spray-target")) gameRuntime.timer = setTimeout(() => spawnSprayWave(), 160);
  }

  function missSprayTarget() {
    if (!gameRuntime || gameRuntime.type !== "spray") return;
    gameRuntime.misses += 1;
    gameRuntime.chain = 0;
    const chainNode = el("spray-chain");
    if (chainNode) chainNode.textContent = "0";
  }

  function finishSprayChallenge() {
    if (!gameRuntime || gameRuntime.type !== "spray") return;
    const { hits, misses, maxChain } = gameRuntime;
    const accuracy = Math.round(hits / Math.max(1, hits + misses) * 100);
    const bonus = clamp(Math.floor(hits / 3 + maxChain / 3 - misses * 0.18), 0, 8);
    const score = Math.max(0, hits * 110 + maxChain * 45 - misses * 20);
    clearGameRuntime();
    finishMiniGame({ type: "spray", label: "扫射转移", score, bonus, hits, accuracy, maxChain, summary: `${hits} 杀 · 最长 ${maxChain} 连杀` });
  }

  function beginDeagleChallenge(field) {
    gameRuntime = { type: "deagle", field, bullets: 7, kills: 0, targetKills: 5, misses: 0, endAt: performance.now() + 10000, timer: null };
    const message = el("game-message");
    if (message) message.textContent = "只有 7 发子弹，瞄准头部完成翻盘！";
    spawnDeagleTarget();
    const tick = () => {
      if (!gameRuntime || gameRuntime.type !== "deagle") return;
      const remaining = Math.max(0, gameRuntime.endAt - performance.now());
      const timeNode = el("game-time");
      if (timeNode) timeNode.textContent = `${(remaining / 1000).toFixed(1)}s`;
      if (remaining <= 0) { finishDeagleChallenge(); return; }
      gameRuntime.timer = setTimeout(tick, 50);
    };
    tick();
  }

  function spawnDeagleTarget() {
    if (!gameRuntime || gameRuntime.type !== "deagle") return;
    const runtime = gameRuntime;
    runtime.field.querySelector(".deagle-target")?.remove();
    const target = document.createElement("button");
    target.type = "button";
    target.className = "deagle-target";
    target.dataset.action = "hit-deagle-target";
    const positions = [[18,52],[35,29],[55,58],[72,33],[86,55]];
    const [x,y] = sample(positions);
    target.style.left = `${x}%`;
    target.style.top = `${y}%`;
    target.setAttribute("aria-label", "沙鹰爆头目标");
    target.innerHTML = "<span class=\"enemy-head\"></span><span class=\"enemy-body\"></span>";
    runtime.field.appendChild(target);
  }

  function hitDeagleTarget() {
    if (!gameRuntime || gameRuntime.type !== "deagle") return;
    gameRuntime.bullets -= 1;
    gameRuntime.kills += 1;
    updateDeagleHud();
    if (gameRuntime.kills >= gameRuntime.targetKills || gameRuntime.bullets <= 0) finishDeagleChallenge();
    else spawnDeagleTarget();
  }

  function missDeagleTarget() {
    if (!gameRuntime || gameRuntime.type !== "deagle") return;
    gameRuntime.bullets -= 1;
    gameRuntime.misses += 1;
    updateDeagleHud();
    if (gameRuntime.bullets <= 0) finishDeagleChallenge();
  }

  function updateDeagleHud() {
    if (!gameRuntime) return;
    const bulletsNode = el("deagle-bullets");
    const killsNode = el("game-hits");
    if (bulletsNode) bulletsNode.textContent = String(gameRuntime.bullets);
    if (killsNode) killsNode.textContent = `${gameRuntime.kills} / ${gameRuntime.targetKills}`;
  }

  function finishDeagleChallenge() {
    if (!gameRuntime || gameRuntime.type !== "deagle") return;
    const { kills, misses, bullets } = gameRuntime;
    const bonus = clamp(kills + (kills >= 5 ? 3 : 0) - misses, 0, 8);
    const score = kills * 350 + bullets * 80 - misses * 100;
    clearGameRuntime();
    finishMiniGame({ type: "deagle", label: "沙鹰翻盘", score, bonus, hits: kills, bullets, summary: `${kills}/5 爆头 · 剩余 ${bullets} 发` });
  }

  function beginReactionChallenge(field) {
    gameRuntime = { type: "reaction", field, round: 0, totalRounds: 5, times: [], falseStarts: 0, targetVisible: false, timer: null, waitTimer: null, timeoutTimer: null };
    scheduleReactionRound();
  }

  function scheduleReactionRound() {
    if (!gameRuntime || gameRuntime.type !== "reaction") return;
    const runtime = gameRuntime;
    runtime.targetVisible = false;
    runtime.field.querySelector(".reaction-target")?.remove();
    const roundNode = el("reaction-round");
    const message = el("game-message");
    if (roundNode) roundNode.textContent = `${runtime.round + 1} / ${runtime.totalRounds}`;
    if (message) message.textContent = "架住角度……等待目标出现";
    runtime.waitTimer = setTimeout(() => showReactionTarget(), randomBetween(650, 1500));
  }

  function showReactionTarget() {
    if (!gameRuntime || gameRuntime.type !== "reaction") return;
    const runtime = gameRuntime;
    runtime.targetVisible = false;
    const target = document.createElement("button");
    target.type = "button";
    const fromRight = Math.random() > 0.5;
    target.className = `reaction-target ${fromRight ? "from-right" : "from-left"}`;
    target.dataset.action = "hit-reaction-target";
    target.setAttribute("aria-label", "敌人经过掩体缝隙，立即开枪");
    target.innerHTML = "<span class=\"reaction-head\"></span><span class=\"reaction-body\"></span>";
    runtime.field.appendChild(target);
    const message = el("game-message");
    if (message) message.textContent = "听到脚步，继续架住掩体缝隙……";
    requestAnimationFrame(() => requestAnimationFrame(() => target.classList.add("is-crossing")));
    runtime.enterTimer = setTimeout(() => {
      if (!gameRuntime || gameRuntime.type !== "reaction") return;
      runtime.targetVisible = true;
      runtime.shownAt = performance.now();
      if (message) message.textContent = "过点！开枪！";
    }, 145);
    runtime.timeoutTimer = setTimeout(() => completeReactionRound(null), 900);
  }

  function hitReactionTarget() {
    if (!gameRuntime || gameRuntime.type !== "reaction" || !gameRuntime.targetVisible) return;
    const reaction = Math.round(performance.now() - gameRuntime.shownAt);
    clearTimeout(gameRuntime.timeoutTimer);
    completeReactionRound(reaction);
  }

  function falseStartReaction() {
    if (!gameRuntime || gameRuntime.type !== "reaction" || gameRuntime.targetVisible) return;
    const runtime = gameRuntime;
    runtime.falseStarts += 1;
    clearTimeout(runtime.waitTimer);
    clearTimeout(runtime.enterTimer);
    clearTimeout(runtime.timeoutTimer);
    runtime.field.querySelector(".reaction-target")?.remove();
    const message = el("game-message");
    if (message) message.textContent = "抢枪！重新架点，等待目标。";
    runtime.waitTimer = setTimeout(() => scheduleReactionRound(), 650);
    const falseNode = el("reaction-false");
    if (falseNode) falseNode.textContent = String(runtime.falseStarts);
  }

  function completeReactionRound(reaction) {
    if (!gameRuntime || gameRuntime.type !== "reaction") return;
    const runtime = gameRuntime;
    runtime.targetVisible = false;
    runtime.field.querySelector(".reaction-target")?.remove();
    if (reaction !== null) runtime.times.push(reaction);
    runtime.round += 1;
    const averageNode = el("reaction-average");
    if (averageNode && runtime.times.length) averageNode.textContent = `${Math.round(runtime.times.reduce((sum, value) => sum + value, 0) / runtime.times.length)}ms`;
    if (runtime.round >= runtime.totalRounds) {
      const hits = runtime.times.length;
      const average = hits ? Math.round(runtime.times.reduce((sum, value) => sum + value, 0) / hits) : 999;
      const falseStarts = runtime.falseStarts;
      const bonus = clamp((average <= 240 ? 8 : average <= 310 ? 7 : average <= 390 ? 5 : average <= 520 ? 3 : 1) - Math.min(3, falseStarts), 0, 8);
      const score = Math.max(0, (1000 - average) * hits - falseStarts * 120);
      clearGameRuntime();
      finishMiniGame({ type: "reaction", label: "狙击架点", score, bonus, average, falseStarts, hits, summary: `${average}ms 平均反应 · ${hits}/5 命中` });
      return;
    }
    runtime.timer = setTimeout(() => scheduleReactionRound(), 420);
  }

  function finishMiniGame(result) {
    const scenarioComboBonus = comboScenarioBonus(result.type);
    result.baseBonus = result.bonus;
    result.comboBonus = scenarioComboBonus;
    result.bonus = clamp(result.bonus + scenarioComboBonus, 0, 12);
    if (scenarioComboBonus) result.summary += ` · 组合 +${scenarioComboBonus}`;
    state.currentEvent.minigame = null;
    state.currentEvent.trainingScore = result;
    state.currentEvent.competition.interactionsUsed = (state.currentEvent.competition.interactionsUsed || 0) + 1;
    state.currentEvent.stage = "resolution";
    if (result.bonus >= 7) applyEffects({ mentality: 1 });
    saveGame();
    render();
    notify(`关键回合完成：比赛状态 +${result.bonus}`);
  }

  function chooseDecision(index) {
    const event = state.currentEvent;
    const option = event.options[index];
    if (!option) return;
    applyEffects(option.effects);
    addHistory(event.tag, option.label, option.outcome);
    state.currentEvent = {
      type: "outcome", tag: event.tag, title: option.label,
      desc: option.outcome, effects: option.effects
    };
    saveGame();
    render();
  }

  function simulateTournament(managed = false) {
    const event = state.currentEvent;
    const tournament = TOURNAMENTS.find((item) => item.id === event.tournamentId);
    const opponent = tournamentOpponent(event);
    const scenario = event.trainingScore;
    const playedMaps = event.veto?.selected || [];
    const powerModel = matchPowerBreakdown(event);
    const power = powerModel.total;
    const opponentPower = powerModel.opponentPower;
    const winChance = powerModel.winChance;
    const abilityComboBonus = powerModel.comboBonus;
    const won = Math.random() < winChance;
    const bestOf = currentMatchBestOf(event);
    const closeness = Math.abs(power - opponentPower);
    const clean = closeness >= 8 ? Math.random() < 0.64 : Math.random() < 0.36;
    const seriesScore = bestOf === 1
      ? `${won ? 13 : randomBetween(5, 11)}-${won ? randomBetween(5, 11) : 13}`
      : won ? `2-${clean ? 0 : 1}` : `${clean ? 0 : 1}-2`;
    const ratingBase = 0.55 + state.stats.mechanics * 0.0037 + state.stats.gameSense * 0.0019 + state.stats.mentality * 0.0011;
    const performance = (won ? 0.07 : -0.055) + (power - opponentPower) / 180 + randomBetween(-7, 7) / 100 + (scenario?.bonus || 0) / 200 + abilityComboBonus / 450;
    const rating = Math.max(0.72, Math.min(1.55, ratingBase + performance));
    const mapCount = bestOf === 1 ? 1 : clean ? 2 : 3;
    const match = {
      number: event.competition.matches.length + 1, phase: event.competition.phase, phaseLabel: phaseLabel(event.competition.phase),
      opponentId: opponent.id, opponent: opponent.name, won, score: seriesScore, bestOf, rating,
      warmup: scenario, comboBonus: abilityComboBonus, combos: activeAbilityCombos().map((combo) => combo.name),
      winChance, powerBreakdown: powerModel,
      developmentGain: (won ? 1 : 0) + (rating >= 1.18 ? 1 : 0), managed,
      playedMaps: playedMaps.map((entry) => entry.mapId)
    };
    event.competition.matches.push(match);
    if ((state.seasonData?.patchChaosMatches || 0) > 0) state.seasonData.patchChaosMatches -= 1;
    if ((state.seasonData?.specialMatchBonus?.matches || 0) > 0) state.seasonData.specialMatchBonus.matches -= 1;
    if ((state.seasonData?.preparationPenalty?.matches || 0) > 0) state.seasonData.preparationPenalty.matches -= 1;
    event.competition.faced.push(opponent.id);
    event.matchResult = match;
    state.career.maps += mapCount;
    state.career.bestRating = Math.max(state.career.bestRating, rating);
    ensureDevelopmentState();
    state.development.points += match.developmentGain;
    if (state.seasonData) state.seasonData.matchLoad = (state.seasonData.matchLoad || 0) + (bestOf === 1 ? 1 : 2);
    advanceCompetition(event, won);
    saveGame();
    if (!managed) render();
  }

  function simulateToKeyMatch() {
    const event = state.currentEvent;
    if (event?.type !== "tournament" || event.resolved) return;
    if (isKeyTournamentMatch(event)) {
      notify("当前已经是晋级、淘汰或季后赛关键场");
      return;
    }
    let simulated = 0;
    while (!event.resolved && !isKeyTournamentMatch(event) && simulated < 8) {
      event.veto = createVetoState(event);
      autoCompleteVeto(false);
      event.trainingMapId = event.veto.selected[0]?.mapId || "mirage";
      event.trainingScore = { type: "managed", label: "托管模拟", score: 0, bonus: randomBetween(1, 3), comboBonus: 0, summary: "推进至下一场关键比赛" };
      event.mapBonus = 0;
      simulateTournament(true);
      simulated += 1;
      if (!event.resolved) prepareTournamentMatch(event);
    }
    saveGame();
    render();
    notify(event.resolved ? `已托管 ${simulated} 场，赛事旅程结束` : `已托管 ${simulated} 场，抵达关键比赛`);
  }

  function recordStage(comp) {
    comp.stageHistory.push({ phase: comp.phase, label: phaseLabel(comp.phase), wins: comp.wins, losses: comp.losses });
  }

  function moveCompetitionTo(comp, phase) {
    recordStage(comp);
    comp.phase = phase;
    comp.wins = 0;
    comp.losses = 0;
  }

  function completeKnockoutAi(event, ids, sixTeam = false, startingPhase = null) {
    const simulation = event.competition.simulation;
    let active = seedKnockoutTeams(ids);
    let phase = startingPhase || (active.length >= 16 ? "r16" : "qf");
    let firstRound = true;
    while (active.length > 1) {
      if (sixTeam && firstRound && active.length === 6) {
        const pairs = knockoutPairs(active, true, "qf");
        const results = pairs.map(([teamA, teamB]) => {
          const winner = simulateAiSeries(event, teamA, teamB, "qf");
          const loser = winner === teamA ? teamB : teamA;
          markSimulationEliminated(event, loser, "qf");
          return winner;
        });
        active = [active[0], results[1], active[1], results[0]];
        phase = "sf";
        firstRound = false;
        continue;
      }
      const pairs = (firstRound && ["r16", "qf"].includes(phase)) ? knockoutPairs(active, false, phase) : knockoutPairs(active, false, phase);
      const winners = [];
      pairs.forEach(([teamA, teamB]) => {
        const winner = simulateAiSeries(event, teamA, teamB, phase);
        const loser = winner === teamA ? teamB : teamA;
        winners.push(winner);
        markSimulationEliminated(event, loser, phase);
        if (phase === "final") simulation.runnerUpId = loser;
      });
      active = winners;
      if (phase === "final") break;
      phase = nextKnockoutPhase(phase);
      firstRound = false;
    }
    simulation.championId = active[0] || simulation.championId;
    return simulation.championId;
  }

  function fillFieldWithoutPlayer(event) {
    const tournament = TOURNAMENTS.find((item) => item.id === event.tournamentId);
    const ids = event.competition.field.filter((id) => id !== team().id);
    vrsTable(tournament.region || null).forEach((entry) => {
      if (ids.length < tournament.teamCount && entry.team.id !== team().id && !ids.includes(entry.team.id)) ids.push(entry.team.id);
    });
    return ids.slice(0, tournament.teamCount);
  }

  function completeTournamentAiAfterExit(event, playedPhase = null, advancers = null) {
    const tournament = TOURNAMENTS.find((item) => item.id === event.tournamentId);
    const simulation = event.competition.simulation;
    if (advancers) {
      if (tournament.major) {
        let next = advancers;
        if (playedPhase === "stage1") next = simulateClosedStage(event, "stage2", [...next, ...simulation.majorBuckets.stage2], 8).advancers;
        if (["stage1", "stage2"].includes(playedPhase)) next = simulateClosedStage(event, "stage3", [...next, ...simulation.majorBuckets.stage3], 8).advancers;
        completeKnockoutAi(event, next, false, "qf");
      } else completeKnockoutAi(event, advancers, tournament.format === "groups", tournament.format === "single" ? "r16" : "qf");
      return;
    }
    const field = fillFieldWithoutPlayer(event);
    if (tournament.major) {
      simulation.majorBuckets = majorStageBuckets(field);
      const stage1 = simulateClosedStage(event, "stage1", simulation.majorBuckets.stage1, 8).advancers;
      const stage2 = simulateClosedStage(event, "stage2", [...stage1, ...simulation.majorBuckets.stage2], 8).advancers;
      const stage3 = simulateClosedStage(event, "stage3", [...stage2, ...simulation.majorBuckets.stage3], 8).advancers;
      completeKnockoutAi(event, stage3, false, "qf");
    } else if (tournament.format === "single") completeKnockoutAi(event, field, false, "r16");
    else {
      const phase = firstMainPhase(tournament);
      const slots = tournament.format === "groups" ? 6 : 8;
      const main = simulateClosedStage(event, phase, field, slots).advancers;
      completeKnockoutAi(event, main, tournament.format === "groups", "qf");
    }
  }

  function beginMainEventAfterQualifier(event) {
    const tournament = TOURNAMENTS.find((item) => item.id === event.tournamentId);
    const competition = event.competition;
    const simulation = competition.simulation;
    if (tournament.major) {
      const pool = unique([team().id, ...simulation.majorBuckets.stage1]).slice(0, 16);
      initializeInteractiveStage(event, "stage1", pool, 8);
    } else if (tournament.format === "single") initializeKnockout(event, competition.field, false);
    else initializeInteractiveStage(event, firstMainPhase(tournament), competition.field, tournament.format === "groups" ? 6 : 8);
  }

  function transitionAfterInteractiveStage(event, playedPhase, playerAdvanced) {
    const tournament = TOURNAMENTS.find((item) => item.id === event.tournamentId);
    const competition = event.competition;
    const simulation = competition.simulation;
    const advancers = completeInteractiveStage(event);
    if (!playerAdvanced) {
      completeTournamentAiAfterExit(event, playedPhase, advancers);
      return false;
    }
    if (!tournament.major) {
      initializeKnockout(event, advancers, tournament.format === "groups");
      return true;
    }
    if (playedPhase === "stage1") initializeInteractiveStage(event, "stage2", [...advancers, ...simulation.majorBuckets.stage2], 8);
    if (playedPhase === "stage2") initializeInteractiveStage(event, "stage3", [...advancers, ...simulation.majorBuckets.stage3], 8);
    if (playedPhase === "stage3") initializeKnockout(event, advancers, false);
    return true;
  }

  function advancePlayerKnockout(event, won) {
    const competition = event.competition;
    const simulation = competition.simulation;
    const knockout = simulation.knockout;
    const phase = knockout.phase;
    const result = knockout.round?.results.find((entry) => !entry.winner && [entry.teamA, entry.teamB].includes(team().id));
    if (!result) return { handled: false };
    const opponentId = result.teamA === team().id ? result.teamB : result.teamA;
    result.winner = won ? team().id : opponentId;
    result.loser = won ? opponentId : team().id;
    const lastMatch = competition.matches[competition.matches.length - 1];
    recordSimulationMatch(event, phase, result.teamA, result.teamB, result.winner, lastMatch?.score);
    markSimulationEliminated(event, result.loser, phase);
    if (phase === "final") {
      simulation.championId = result.winner;
      simulation.runnerUpId = result.loser;
      return { handled: true, complete: true, champion: won };
    }
    const nextActive = knockoutNextActive(knockout);
    const nextPhase = nextKnockoutPhase(phase);
    if (!won) {
      completeKnockoutAi(event, nextActive, false, nextPhase);
      return { handled: true, complete: true, champion: false };
    }
    knockout.active = nextActive;
    knockout.phase = nextPhase;
    knockout.round = null;
    competition.phase = nextPhase;
    competition.wins = 0;
    competition.losses = 0;
    return { handled: true, complete: false };
  }

  function advanceSimulationCompetition(event, won) {
    const competition = event.competition;
    const tournament = TOURNAMENTS.find((item) => item.id === event.tournamentId);
    const simulation = competition.simulation;
    if (!simulation?.initialized) return false;
    const playedPhase = competition.phase;
    if (playedPhase === "qualifier") {
      const opponentId = event.opponentId;
      const winnerId = won ? team().id : opponentId;
      recordSimulationMatch(event, "qualifier", team().id, opponentId, winnerId, competition.matches[competition.matches.length - 1]?.score);
      if (!won) {
        markSimulationEliminated(event, team().id, "qualifier");
        completeTournamentAiAfterExit(event);
        finalizeTournament(event, eliminationOutcome(tournament, competition, "qualifier"));
        return true;
      }
      competition.wins += 1;
      if (competition.wins >= competition.qualifierWins) {
        beginMainEventAfterQualifier(event);
        competition.route = { code: "qualified", label: tournament.major ? "通过地区资格赛 · 晋级 Stage 1" : "通过资格赛 · 晋级正赛", detail: `${competition.qualifierWins}-0 连胜取得正赛席位` };
      }
      event.stage = "matchResult";
      return true;
    }
    if (["swiss", "group", "stage1", "stage2", "stage3"].includes(playedPhase)) {
      const stage = simulation.currentStage;
      const opponentId = stage.pendingPlayer?.opponentId || event.opponentId;
      const winnerId = won ? team().id : opponentId;
      const loserId = won ? opponentId : team().id;
      recordStageSeries(event, stage, winnerId, loserId, false);
      recordSimulationMatch(event, playedPhase, team().id, opponentId, winnerId, competition.matches[competition.matches.length - 1]?.score);
      stage.pendingPlayer = null;
      const playerRecord = stage.records[team().id];
      competition.wins = playerRecord.wins;
      competition.losses = playerRecord.losses;
      if (playerRecord.qualified || playerRecord.eliminated) {
        const advanced = transitionAfterInteractiveStage(event, playedPhase, playerRecord.qualified);
        if (!advanced) {
          finalizeTournament(event, eliminationOutcome(tournament, competition, playedPhase));
          return true;
        }
      }
      event.stage = "matchResult";
      return true;
    }
    if (["r16", "qf", "sf", "final"].includes(playedPhase)) {
      const result = advancePlayerKnockout(event, won);
      if (!result.handled) return false;
      if (result.complete) {
        if (result.champion) finalizeTournament(event, { stage: "冠军", rank: "#1", placement: 1, factor: 1, fame: tournament.major ? 2600 : 1700, finishValue: 8 });
        else finalizeTournament(event, eliminationOutcome(tournament, competition, playedPhase));
      } else event.stage = "matchResult";
      return true;
    }
    return false;
  }

  function advanceCompetition(event, won) {
    const comp = event.competition;
    const tournament = TOURNAMENTS.find((item) => item.id === event.tournamentId);
    if (advanceSimulationCompetition(event, won)) return;
    const playedPhase = comp.phase;
    if (playedPhase === "qualifier") {
      if (!won) { finalizeTournament(event, eliminationOutcome(tournament, comp, "qualifier")); return; }
      comp.wins += 1;
      if (comp.wins >= comp.qualifierWins) {
        moveCompetitionTo(comp, tournament.major ? "stage1" : firstMainPhase(tournament));
        comp.route = { code: "qualified", label: tournament.major ? "通过地区资格赛 · 晋级 Stage 1" : "通过资格赛 · 晋级正赛", detail: `${comp.qualifierWins}-0 连胜取得正赛席位` };
      }
      event.stage = "matchResult";
      return;
    }

    if (["swiss", "group", "stage1", "stage2", "stage3"].includes(playedPhase)) {
      if (won) comp.wins += 1; else comp.losses += 1;
      const winTarget = playedPhase === "group" ? 2 : 3;
      const lossTarget = playedPhase === "group" ? 2 : 3;
      if (comp.wins >= winTarget) {
        if (playedPhase === "stage1") moveCompetitionTo(comp, "stage2");
        else if (playedPhase === "stage2") moveCompetitionTo(comp, "stage3");
        else if (playedPhase === "stage3" || playedPhase === "swiss") moveCompetitionTo(comp, "qf");
        else if (playedPhase === "group") moveCompetitionTo(comp, comp.losses === 0 ? "sf" : "qf");
      } else if (comp.losses >= lossTarget) {
        finalizeTournament(event, eliminationOutcome(tournament, comp, playedPhase));
        return;
      }
      event.stage = "matchResult";
      return;
    }

    const nextRound = { r16: "qf", qf: "sf", sf: "final" }[playedPhase];
    if (!won) {
      finalizeTournament(event, eliminationOutcome(tournament, comp, playedPhase));
    } else if (playedPhase === "final") {
      finalizeTournament(event, { stage: "冠军", rank: "#1", placement: 1, factor: 1, fame: tournament.major ? 2600 : 1700, finishValue: 8 });
    } else {
      moveCompetitionTo(comp, nextRound);
      event.stage = "matchResult";
    }
  }

  function eliminationOutcome(tournament, comp, phase) {
    if (phase === "qualifier") return { stage: tournament.major ? "Major 地区资格赛出局" : "资格赛出局", rank: "未晋级", placement: null, factor: 0, fame: -30, finishValue: 1 };
    if (phase === "r16") return { stage: "十六强", rank: "#9–16", placement: randomBetween(9, 16), factor: 0.015, fame: 80, finishValue: 2 };
    if (phase === "qf") return { stage: "八强", rank: "#5–8", placement: randomBetween(5, 8), factor: 0.075, fame: 300, finishValue: 5 };
    if (phase === "sf") return { stage: "四强", rank: "#3–4", placement: randomBetween(3, 4), factor: 0.18, fame: 620, finishValue: 6 };
    if (phase === "final") return { stage: "亚军", rank: "#2", placement: 2, factor: 0.42, fame: 1100, finishValue: 7 };
    if (tournament.major && ["stage1", "stage2", "stage3"].includes(phase)) {
      const range = {
        stage1: comp.wins === 0 ? [31, 32] : comp.wins === 1 ? [28, 30] : [25, 27],
        stage2: comp.wins === 0 ? [23, 24] : comp.wins === 1 ? [20, 22] : [17, 19],
        stage3: comp.wins === 0 ? [15, 16] : comp.wins === 1 ? [12, 14] : [9, 11]
      }[phase];
      const placement = randomBetween(range[0], range[1]);
      return { stage: `${phaseLabel(phase)} 淘汰`, rank: `#${range[0]}–${range[1]}`, placement, factor: phase === "stage3" ? 0.035 : 0.01, fame: phase === "stage3" ? 220 : 70, finishValue: phase === "stage3" ? 4 : phase === "stage2" ? 3 : 2 };
    }
    const lower = tournament.teamCount;
    const placement = randomBetween(9, Math.max(9, lower));
    return { stage: phase === "group" ? "小组赛淘汰" : "瑞士制淘汰", rank: `#9–${lower}`, placement, factor: 0.02, fame: 100, finishValue: 3 };
  }

  function simulateFinalStandings(tournament, event, placement) {
    const simulation = event.competition.simulation;
    if (simulation?.championId) {
      const qualifierExit = simulation.eliminations.some((entry) => entry.teamId === team().id && entry.phase === "qualifier");
      const ledgerIds = simulation.ledger.filter((match) => match.phase !== "qualifier").flatMap((match) => [match.teamA, match.teamB]);
      let participants = unique([...event.competition.field, ...ledgerIds]);
      if (qualifierExit) participants = participants.filter((id) => id !== team().id);
      participants = participants.slice(0, tournament.teamCount);
      const eliminationMap = Object.fromEntries(simulation.eliminations.map((entry) => [entry.teamId, entry]));
      const phaseWeight = { final: 100, sf: 90, qf: 80, r16: 70, stage3: 60, stage2: 50, stage1: 40, swiss: 35, group: 35, qualifier: 0 };
      const fixed = [simulation.championId, simulation.runnerUpId].filter(Boolean);
      const rest = participants.filter((id) => !fixed.includes(id)).sort((a, b) => {
        const ae = eliminationMap[a] || {};
        const be = eliminationMap[b] || {};
        return (phaseWeight[be.phase] || 0) - (phaseWeight[ae.phase] || 0)
          || (be.wins || 0) - (ae.wins || 0)
          || (ae.losses || 0) - (be.losses || 0)
          || vrsEntry(a).globalRank - vrsEntry(b).globalRank;
      });
      return unique([...fixed, ...rest]).map((teamId, index) => ({ teamId, rank: index + 1 }));
    }
    const current = team();
    const field = unique(event.competition.field).map((id) => TEAMS.find((candidate) => candidate.id === id)).filter(Boolean);
    const others = field.filter((candidate) => candidate.id !== current.id);
    if (placement == null && others.length < tournament.teamCount) {
      vrsTable(tournament.region || null).forEach((entry) => {
        if (others.length < tournament.teamCount && entry.team.id !== current.id && !others.some((candidate) => candidate.id === entry.team.id)) others.push(entry.team);
      });
    }
    others.sort((a, b) => {
      const aScore = hiddenTeamStrength(a) + randomBetween(-13, 13);
      const bScore = hiddenTeamStrength(b) + randomBetween(-13, 13);
      return bScore - aScore;
    });
    if (placement == null) return others.map((candidate, index) => ({ teamId: candidate.id, rank: index + 1 }));
    const target = Math.max(1, Math.min(field.length, placement));
    others.splice(target - 1, 0, current);
    return others.map((candidate, index) => ({ teamId: candidate.id, rank: index + 1 }));
  }

  function updateVrsAfterTournament(tournament, event, outcome) {
    ensureVrsState();
    const presentation = tournamentPresentation(tournament, event);
    const current = team();
    const standings = simulateFinalStandings(tournament, event, outcome.placement);
    const fieldIds = standings.map((entry) => entry.teamId);
    const beforeStrength = Object.fromEntries(fieldIds.map((id) => {
      const candidate = TEAMS.find((item) => item.id === id);
      return [id, hiddenTeamStrength(candidate)];
    }));
    const expected = [...fieldIds].sort((a, b) => beforeStrength[b] - beforeStrength[a]);
    standings.forEach((standing) => {
      const expectedRank = expected.indexOf(standing.teamId) + 1;
      const fieldSize = Math.max(8, standings.length);
      const performanceGap = expectedRank - standing.rank;
      const finishScore = (fieldSize + 1 - standing.rank) / fieldSize;
      let delta = Math.round(tournament.vrsWeight * (performanceGap * 3.6 + (finishScore - 0.45) * 40));
      if (standing.rank === 1) delta = Math.max(delta, Math.round(72 * tournament.vrsWeight));
      const entry = state.vrs.teams[standing.teamId];
      const before = entry.points;
      entry.points = Math.max(350, Math.min(2500, before + delta));
      entry.lastDelta = delta;
      const formDelta = performanceGap === 0 ? 0 : Math.sign(performanceGap) * Math.max(1, Math.min(3, Math.round(Math.abs(performanceGap) / Math.max(1, fieldSize / 6))));
      state.teamForm[standing.teamId] = Math.max(-8, Math.min(8, (state.teamForm[standing.teamId] || 0) + formDelta));
      entry.history = [{
        year: state.year, tournamentId: tournament.id, tournamentName: presentation.name,
        rank: standing.rank, expectedRank, delta, before, after: entry.points
      }, ...(entry.history || [])].slice(0, 12);
    });
    if (!fieldIds.includes(current.id)) {
      const delta = -Math.max(4, Math.round(8 * tournament.vrsWeight));
      state.vrs.teams[current.id].points = Math.max(350, state.vrs.teams[current.id].points + delta);
      state.vrs.teams[current.id].lastDelta = delta;
    }
    TEAMS.filter((candidate) => !fieldIds.includes(candidate.id)).forEach((candidate) => {
      const entry = state.vrs.teams[candidate.id];
      const strengthBeforeDecay = hiddenTeamStrength(candidate);
      const decay = Math.random() < 0.18 ? 1 : 0;
      entry.points = Math.max(350, entry.points - decay);
      entry.lastDelta = -decay;
      entry.lastStrengthDelta = hiddenTeamStrength(candidate) - strengthBeforeDecay;
    });
    standings.forEach((standing) => {
      const candidate = TEAMS.find((item) => item.id === standing.teamId);
      state.vrs.teams[standing.teamId].lastStrengthDelta = hiddenTeamStrength(candidate) - beforeStrength[standing.teamId];
    });
    const after = vrsEntry(current.id);
    state.career.peakVrsRank = Math.min(state.career.peakVrsRank || 999, after.globalRank);
    state.career.peakVrsPoints = Math.max(state.career.peakVrsPoints || 0, after.points);
    return {
      before: event.competition.vrsBefore, after: after.points, delta: after.points - event.competition.vrsBefore,
      globalRank: after.globalRank, regionRank: after.regionRank, trend: strengthTrendLabel(after.lastStrengthDelta), standings
    };
  }

  function finalizeTournament(event, outcome) {
    const tournament = TOURNAMENTS.find((item) => item.id === event.tournamentId);
    const presentation = tournamentPresentation(tournament, event);
    const currentTeam = team();
    const ratings = event.competition.matches.map((match) => match.rating);
    const rating = ratings.length ? ratings.reduce((sum, value) => sum + value, 0) / ratings.length : 0.9;
    const playerShare = Math.round(tournament.prize * outcome.factor * 0.08);
    const vrs = updateVrsAfterTournament(tournament, event, outcome);
    ensureDevelopmentState();
    const developmentAward = Math.max(1, Math.min(5, 1 + Math.floor((outcome.finishValue || 0) / 2)));
    state.development.points += developmentAward;
    const lastMatch = event.competition.matches[event.competition.matches.length - 1];
    const finalLedger = [...(event.competition.simulation?.ledger || [])].reverse().find((match) => match.phase === "final");
    const tournamentResult = {
      tournamentId: tournament.id, stage: outcome.stage, rank: outcome.rank, placement: outcome.placement,
      tournamentName: presentation.name, location: presentation.location, majorHost: event.majorEdition || null,
      finishValue: outcome.finishValue, rating, prize: playerShare, opponent: lastMatch?.opponent || "—",
      warmup: lastMatch?.warmup || null, playedMaps: event.competition.matches.flatMap((match) => match.playedMaps || []),
      matches: event.competition.matches, path: event.competition.route.label, developmentAward,
      finalMatch: finalLedger ? { teamA: simulationTeam(finalLedger.teamA)?.name, teamB: simulationTeam(finalLedger.teamB)?.name, winner: simulationTeam(finalLedger.winner)?.name, score: finalLedger.score } : null,
      vrs
    };
    event.competition.complete = true;
    event.result = tournamentResult;
    event.resolved = true;
    event.stage = "complete";
    state.seasonData.results.push(tournamentResult);
    state.career.money += playerShare;
    state.career.earnings += playerShare;
    applyEffects({ fame: outcome.fame, mentality: outcome.stage === "冠军" ? 2 : outcome.stage.includes("资格赛") ? -1 : 0 });
    if (outcome.stage === "冠军") {
      state.career.titles.push({ year: state.year, tournament: presentation.name, team: currentTeam.name, major: tournament.major });
      if (rating >= 1.22) state.career.awards.push({ year: state.year, name: `${presentation.name} MVP` });
    }
    addHistory("赛事", `${presentation.name} · ${outcome.stage}`, `${event.competition.matches.length} 场 · Rating ${rating.toFixed(2)} · VRS ${vrs.delta >= 0 ? "+" : ""}${vrs.delta} · 发展点 +${developmentAward}`);
  }

  function continueTournament() {
    const event = state.currentEvent;
    if (!event?.competition || event.resolved) return;
    prepareTournamentMatch(event);
    saveGame();
    render();
  }

  function finishSeason() {
    const ratings = state.seasonData.results.map((result) => result.rating);
    const averageRating = ratings.length ? ratings.reduce((sum, value) => sum + value, 0) / ratings.length : 0;
    const best = [...state.seasonData.results].sort((a, b) => (b.finishValue || stageValue(b.stage)) - (a.finishValue || stageValue(a.stage)))[0];
    state.career.money += state.seasonData.salary;
    state.career.earnings += state.seasonData.salary;
    const workingLanguage = teamLanguage(team());
    if (languageLevel(workingLanguage) < 92) state.languages[workingLanguage] = clamp((state.languages[workingLanguage] || 0) + 2, 0, 100);
    const growth = state.age <= 23 ? 2 : state.age <= 28 ? 1 : 0;
    if (averageRating >= 1.15) applyEffects({ mechanics: growth, mentality: 1, fame: 350 });
    if (averageRating < 0.95) applyEffects({ mentality: -2, fame: -100 });
    if (state.profile.role === "igl" && best && stageValue(best.stage) >= 4) applyEffects({ gameSense: 2, teamwork: 1 });
    const matchLoad = state.seasonData.matchLoad || 0;
    const overloadPenalty = Math.min(3, Math.ceil(Math.max(0, matchLoad - 12) / 8));
    if (overloadPenalty > 0) applyEffects({ fitness: -overloadPenalty });
    const seasonDevelopment = Math.max(1, growth + (averageRating >= 1.15 ? 2 : averageRating >= 1.02 ? 1 : 0));
    state.development.points += seasonDevelopment;
    const statChanges = Object.fromEntries(STAT_META.map(([key]) => [key, state.stats[key] - (state.seasonData.startStats?.[key] || state.stats[key])]));
    const endVrs = vrsEntry(team().id);
    const worldRank = endVrs.globalRank;
    state.career.seasonHistory.push({ year: state.year, team: team().name, rating: averageRating, best: best?.stage || "无", tournament: best?.tournamentName || (best ? TOURNAMENTS.find((t) => t.id === best.tournamentId)?.name : "—"), worldRank, vrsPoints: endVrs.points, tournaments: state.seasonData.results.length });
    addHistory("赛季", `${state.year} 赛季结束`, `平均 Rating ${averageRating.toFixed(2)} · VRS #${worldRank} / ${endVrs.points} 分`);
    state.currentEvent = { type: "review", averageRating, best, worldRank, vrsPoints: endVrs.points, vrsDelta: endVrs.points - (state.seasonData.startVrs || endVrs.points), seasonEarnings: state.career.money - state.seasonData.startMoney, seasonDevelopment, statChanges };
    saveGame();
    render();
  }

  function stageValue(stage) {
    if (stage === "冠军") return 8;
    if (stage === "亚军") return 7;
    if (stage === "四强") return 6;
    if (stage === "八强") return 5;
    if (stage?.includes("Stage 3")) return 4;
    if (stage?.includes("小组") || stage?.includes("瑞士")) return 3;
    if (stage?.includes("Stage 2") || stage === "十六强") return 2;
    if (stage?.includes("资格赛") || stage?.includes("Stage 1")) return 1;
    return 0;
  }

  function rivalEraLabel(rival, year) {
    if (year === rival.debut) return rival.future ? "模拟新生代 · 首秀" : "年度新秀";
    if (year < rival.primeStart) return rival.future ? "模拟新生代 · 上升期" : "上升期";
    if (year <= rival.primeEnd) return "巅峰期";
    return "生涯后期";
  }

  function rivalAwardEntry(rival, year) {
    if (year < rival.debut || year > rival.retire) return null;
    let curve = rival.peak;
    if (year < rival.primeStart) curve -= (rival.primeStart - year) * 3.1;
    if (year > rival.primeEnd) curve -= (year - rival.primeEnd) * 3.4;
    const form = ((stableHash(`${rival.id}-${year}-hltv`) % 101) - 50) / 10;
    const score = Math.max(55, Math.round((curve + form) * 10) / 10);
    const rating = Math.max(0.96, Math.min(1.4, Math.round((0.82 + score * 0.0048) * 100) / 100));
    return { ...rival, score, rating, era: rivalEraLabel(rival, year), isPlayer: false };
  }

  function awardRivals() {
    ensureWorldState();
    return [...AWARD_RIVALS, ...state.world.prospects].filter((rival, index, list) => list.findIndex((entry) => entry.id === rival.id) === index);
  }

  function playerAwardScore(review) {
    const bestValue = review.best?.finishValue || stageValue(review.best?.stage);
    const titles = state.career.titles.filter((title) => title.year === state.year);
    const majorTitles = titles.filter((title) => title.major).length;
    const mvpAwards = state.career.awards.filter((award) => award.year === state.year && award.name.includes("MVP")).length;
    const rankBonus = Math.max(0, 30 - (review.worldRank || 100)) * 0.25;
    return Math.round((42 + (review.averageRating - 1) * 70 + (overall() - 60) * 0.55 + bestValue * 2.4
      + titles.length * 5 + majorTitles * 8 + mvpAwards * 3 + rankBonus) * 10) / 10;
  }

  function beginAnnualAwards() {
    const review = state.currentEvent;
    if (review?.type !== "review") return;
    const playerEntry = {
      id: "career-player", nickname: state.profile.nickname, country: country()?.name || "—", role: role()?.name || "职业选手",
      score: playerAwardScore(review), rating: review.averageRating, era: "你的年度表现", isPlayer: true, future: false
    };
    const rivalPool = awardRivals();
    const rivals = rivalPool.map((rival) => rivalAwardEntry(rival, state.year)).filter(Boolean);
    const rankings = [...rivals, playerEntry].sort((a, b) => b.score - a.score || stableHash(`${state.year}-${a.id}`) - stableHash(`${state.year}-${b.id}`));
    const playerRank = rankings.findIndex((entry) => entry.isPlayer) + 1;
    const top20 = rankings.slice(0, 20).map((entry, index) => ({ ...entry, rank: index + 1 }));
    const winner = top20[0];
    const recordedPrevious = [...(state.career.awardHistory || [])].reverse().find((entry) => entry.year === state.year - 1);
    const previousWinner = recordedPrevious
      ? { nickname: recordedPrevious.winner }
      : rivalPool.map((rival) => rivalAwardEntry(rival, state.year - 1)).filter(Boolean).sort((a, b) => b.score - a.score)[0] || null;
    const newcomers = rivalPool.filter((rival) => rival.debut === state.year).map((rival) => ({ nickname: rival.nickname, future: !!rival.future, country: rival.country }));
    const departures = rivalPool.filter((rival) => rival.retire === state.year).map((rival) => rival.nickname);
    const accolade = playerRank === 1 ? "HLTV 年度最佳选手（模拟）" : playerRank <= 3 ? `HLTV Top 3 · #${playerRank}（模拟）` : playerRank <= 20 ? `HLTV Top 20 · #${playerRank}（模拟）` : null;
    if (accolade && !state.career.awards.some((award) => award.year === state.year && award.name === accolade)) state.career.awards.push({ year: state.year, name: accolade });
    const fameGain = playerRank === 1 ? 1500 : playerRank <= 3 ? 900 : playerRank <= 10 ? 500 : playerRank <= 20 ? 250 : 80;
    applyEffects({ fame: fameGain });
    state.career.awardHistory.push({
      year: state.year, rank: playerRank, score: playerEntry.score, winner: winner.nickname,
      top5: top20.slice(0, 5).map((entry) => entry.nickname), accolade
    });
    addHistory("年度颁奖", accolade || `${state.year} HLTV Awards`, playerRank <= 20 ? `年度 Top 20 第 ${playerRank} 名 · 年度指数 ${playerEntry.score}` : `未入选 Top 20 · 综合排名 #${playerRank}`);
    state.currentEvent = {
      type: "awards", year: state.year, top20, playerEntry: { ...playerEntry, rank: playerRank }, playerRank,
      winner, previousWinner, newcomers, departures, accolade, fameGain
    };
    saveGame();
    render();
  }

  function createAgingEvent() {
    const terminal = state.age >= 36;
    const phase = state.age <= 30 ? "身体开始要求新的训练方式" : state.age <= 32 ? "一线席位不再只看巅峰名气" : state.age <= 34 ? "职业生涯进入必须选择方向的阶段" : "最后一份选手合同已经摆在桌上";
    let options;
    if (terminal) {
      options = [
        { label: "把比赛经验带到教练席", hint: "结束选手生涯，根据积累的教练潜力成为助理教练、战术教练或主教练", risk: "转型教练", effects: { gameSense: 1, influence: 3 }, action: "coach" },
        { label: "以职业选手身份正式退役", hint: "结束生涯并保留完整选手评价", risk: "退役", effects: { mentality: 2 }, action: "retire" }
      ];
    } else if (state.age >= 35) {
      options = [
        { label: "签下最后一份一年合同", hint: "允许再完成一个赛季；下一年必须在教练与退役之间选择", risk: "最终赛季", effects: { mentality: 3, fitness: -2 }, action: "final" },
        { label: "现在转向教练席", hint: "不再参加下一赛季，以现有履历开启教练生涯", risk: "教练转型", effects: { gameSense: 1, influence: 3 }, action: "coach" },
        { label: "在还能竞争时主动退役", hint: "以当前状态完成生涯总结", risk: "体面告别", effects: { mentality: 2 }, action: "retire" }
      ];
    } else if (state.age >= 33) {
      options = [
        { label: "寻找本国队伍完成最后一舞", hint: "转会窗口强力优先本国和地区俱乐部", risk: "回到故乡", effects: { mentality: 3, influence: 4 }, action: "domestic" },
        { label: "去二线队伍担任老将核心", hint: "降低俱乐部层级，换取首发、话语权与教练经验", risk: "传帮带", effects: { teamwork: 3, gameSense: 2 }, action: "mentor" },
        { label: "继续争夺最后的一线席位", hint: "保留开放市场，但年龄会继续压低合同长度和薪资", risk: "继续竞争", effects: { mechanics: 2, fitness: -3 }, action: "international" },
        { label: "提前转型教练", hint: "立即结束选手生涯，进入教练结局", risk: "转型", effects: { influence: 3 }, action: "coach" }
      ];
    } else if (state.age >= 31) {
      options = [
        { label: "接受更科学的负荷管理", hint: "保护身体，接受少量枪法下降", risk: "延长生涯", effects: { fitness: 5, mechanics: -1, mentality: 1 }, action: "continue" },
        { label: "转去二线队伍成为绝对核心", hint: "未来报价优先 B/C 级队伍与老将核心位置", risk: "降级核心", effects: { teamwork: 2, mentality: 2 }, action: "tier2" },
        { label: "开始寻找回到本国的机会", hint: "未来报价优先本国俱乐部和同赛区队伍", risk: "本国回归", effects: { influence: 3, cohesion: 2 }, action: "domestic" },
        { label: "一边比赛一边学习教练工作", hint: "保持开放市场并显著积累教练潜力", risk: "双重身份", effects: { gameSense: 2, teamwork: 2, fitness: -1 }, action: "coach_prep" }
      ];
    } else {
      options = [
        { label: "减少无效加练，重新设计日程", hint: "恢复身体并稳定当前市场路线", risk: "科学训练", effects: { fitness: 5, mentality: 1 }, action: "continue" },
        { label: "把经验转化为团队职责", hint: "提高意识与团队，开始积累教练潜力", risk: "角色转型", effects: { gameSense: 2, teamwork: 2, mechanics: -1 }, action: "coach_prep" },
        { label: "提前关注本国俱乐部", hint: "保留比赛能力，未来转会优先本国方向", risk: "规划归途", effects: { influence: 2, mentality: 2 }, action: "domestic" }
      ];
    }
    return {
      type: "aging", terminal, tag: "生涯后期", title: `${state.age} 岁：${phase}`,
      desc: terminal
        ? "选手生涯不能再无限延长。你必须决定把经验带到教练席，还是以职业选手身份正式离开服务器。"
        : `年龄增长已经产生永久变化：${state.career.lastAgingChange || "恢复速度开始下降"}。选择会真实改变下一转会窗、合同角色与最终结局。`,
      options
    };
  }

  function coachingTitle() {
    const potential = state.career.coachingPotential || 0;
    if (potential >= 35 || state.profile.role === "igl") return "主教练 / 战术负责人";
    if (potential >= 18) return "战术教练";
    return "助理教练";
  }

  function chooseAgingPath(index) {
    const event = state.currentEvent;
    const option = event?.options?.[index];
    if (event?.type !== "aging" || !option) return;
    applyEffects(option.effects || {});
    if (["mentor", "coach_prep"].includes(option.action)) state.career.coachingPotential = clamp(state.career.coachingPotential + (option.action === "mentor" ? 10 : 7), 0, 100);
    if (option.action === "domestic") state.career.lateCareerPath = "domestic";
    if (["tier2", "mentor"].includes(option.action)) state.career.lateCareerPath = "tier2";
    if (option.action === "international") state.career.lateCareerPath = null;
    if (option.action === "final") {
      state.career.finalSeason = true;
      state.career.lateCareerPath = state.career.lateCareerPath || "last_dance";
    }
    addHistory("生涯抉择", option.label, `年龄 ${state.age} · ${option.risk}`);
    if (option.action === "coach") {
      state.career.endRole = "coach";
      state.career.coachingTitle = coachingTitle();
      retire(`转型成为${state.career.coachingTitle}`, "coach");
      return;
    }
    if (option.action === "retire") {
      retire("主动结束职业选手生涯", "retired");
      return;
    }
    state.currentEvent = createContractEvent(false);
    saveGame();
    render();
  }

  function prepareNextSeason() {
    const restPlan = state.currentEvent?.type === "offseason" ? state.currentEvent.selectedPlan : null;
    state.age += 1;
    state.year += 1;
    state.season += 1;
    state.contract.yearsLeft = Math.max(0, state.contract.yearsLeft - 1);
    const agingBefore = { mechanics: state.stats.mechanics, gameSense: state.stats.gameSense, teamwork: state.stats.teamwork, fitness: state.stats.fitness };
    if (state.age >= 29 && state.age <= 30) applyEffects({ mechanics: -1, fitness: -1 });
    if (state.age >= 31 && state.age <= 32) applyEffects({ mechanics: -1, fitness: -2, gameSense: 1 });
    if (state.age >= 33) applyEffects({ mechanics: -2, fitness: -2, gameSense: 1, teamwork: 1 });
    state.career.lastAgingChange = `枪法 ${agingBefore.mechanics}→${state.stats.mechanics} · 意识 ${agingBefore.gameSense}→${state.stats.gameSense} · 团队 ${agingBefore.teamwork}→${state.stats.teamwork} · 状态 ${agingBefore.fitness}→${state.stats.fitness}`;
    ensureWorldState();
    state.world.teamStrengthEffects = state.world.teamStrengthEffects.filter((effect) => effect.expiresYear >= state.year);
    const criticalFitness = state.stats.fitness;
    if ((restPlan?.fitnessBefore ?? criticalFitness) <= 20) state.career.injuryWarnings += 1;
    else if (criticalFitness >= 32) state.career.injuryWarnings = Math.max(0, state.career.injuryWarnings - 1);
    if (state.age >= 30 && criticalFitness <= 12 && state.career.injuryWarnings >= 3) {
      retire("反复严重伤病后告别赛场", "retired");
      return;
    }
    state.currentEvent = state.age >= 29 ? createAgingEvent() : createContractEvent(false);
    saveGame();
    render();
  }

  function offseasonRecoveryTarget(nextAge = state.age + 1) {
    return nextAge <= 28 ? 56 : nextAge <= 31 ? 52 : nextAge <= 34 ? 47 : 43;
  }

  function beginOffseasonRest() {
    const fitnessBefore = state.stats.fitness;
    const target = offseasonRecoveryTarget();
    const deficit = Math.max(0, target - fitnessBefore);
    const recoveryBonus = hasPerk("resilient") ? 2 : 0;
    state.currentEvent = {
      type: "offseason",
      tag: "休赛期",
      title: "把下一个赛季交给怎样的身体",
      fitnessBefore,
      matchLoad: state.seasonData?.matchLoad || 0,
      target,
      options: [
        {
          id: "full_rehab", label: "完全休养与系统康复", risk: "恢复最多",
          recovery: Math.min(18, Math.max(3, Math.ceil(deficit * 0.75)) + recoveryBonus),
          effects: { mentality: 2, mechanics: -1 },
          hint: "最大幅度恢复身体状态；长时间离开服务器会略微影响手感。"
        },
        {
          id: "balanced_rest", label: "平衡休息与轻量训练", risk: "推荐",
          recovery: Math.min(12, Math.max(2, Math.ceil(deficit * 0.5)) + recoveryBonus),
          effects: { mentality: 1, gameSense: 1 },
          hint: "获得中等恢复，同时通过复盘和低强度训练保持比赛感觉。"
        },
        {
          id: "short_bootcamp", label: "短暂休息后提前集训", risk: "恢复最少",
          recovery: Math.min(7, Math.max(1, Math.ceil(deficit * 0.28)) + Math.floor(recoveryBonus / 2)),
          effects: { mechanics: 2, gameSense: 1 },
          hint: "更早回到训练室换取能力成长，但身体恢复幅度最低。"
        }
      ]
    };
    saveGame();
    render();
  }

  function chooseOffseasonRest(index) {
    const event = state.currentEvent;
    const option = event?.options?.[index];
    if (event?.type !== "offseason" || !option) return;
    const before = state.stats.fitness;
    applyEffects({ fitness: option.recovery }, false);
    applyEffects(option.effects);
    const after = state.stats.fitness;
    if (before <= 20 && option.id !== "short_bootcamp") state.career.rehabCount += 1;
    addHistory("休赛期", option.label, `身体状态 ${before}→${after} · ${effectsToText(option.effects)}`);
    event.selectedPlan = { id: option.id, label: option.label, fitnessBefore: before, fitnessAfter: after };
    prepareNextSeason();
  }

  function effectsToText(effects) {
    const labels = { mechanics: "枪法", gameSense: "意识", teamwork: "团队", mentality: "心态", fitness: "状态" };
    return Object.entries(effects || {}).map(([key, value]) => `${labels[key] || key} ${value > 0 ? "+" : ""}${value}`).join(" · ");
  }

  function addHistory(type, title, detail) {
    state.career.history.unshift({ year: state.year, type, title, detail });
    state.career.history = state.career.history.slice(0, 40);
  }

  function renderCareer() {
    const currentTeam = team();
    const event = state.currentEvent;
    const currentVrs = currentTeam ? vrsEntry(currentTeam.id) : null;
    root.innerHTML = `
      <section class="career-page">
        <div class="career-topbar">
          <div class="season-tag"><b>${state.year} SEASON</b><span>第 ${state.season} 个职业赛季 · ${state.age} 岁</span></div>
          <div class="quick-stats">
            <span class="quick-stat">总收入 <b>${formatMoney(state.career.earnings)}</b></span>
            <span class="quick-stat">粉丝 <b>${Math.round(state.career.fans / 100) / 10}K</b></span>
            <span class="quick-stat">影响力 <b>${state.career.influence}</b></span>
            <span class="quick-stat">发展点 <b>${state.development.points} DP</b></span>
            ${currentVrs ? `<span class="quick-stat">VRS <b>#${currentVrs.globalRank} · ${currentVrs.points}</b></span>` : ""}
            <span class="quick-stat">冠军 <b>${state.career.titles.length}</b></span>
            <span class="quick-stat">最佳 Rating <b>${state.career.bestRating ? state.career.bestRating.toFixed(2) : "—"}</b></span>
          </div>
        </div>
        <div class="career-layout">
          <aside class="career-side left">
            <section class="panel">
              <div class="player-card-head">
                <div class="mini-avatar">${esc(state.profile.nickname.slice(0,2).toUpperCase())}</div>
                <div><h2>${esc(state.profile.nickname)}</h2><p>${country()?.flag} ${role()?.name} · ${state.age} 岁</p></div>
              </div>
              <div class="overall-block"><span>综合评价<br>OVERALL</span><b>${overall()}</b></div>
              <div class="compact-stats">${STAT_META.slice(0,4).map(([key,label]) => `<div class="compact-stat"><span>${label}</span><b>${state.stats[key]}</b></div>`).join("")}</div>
              <div class="potential-note">角色潜力：${STAT_META.map(([key,label]) => `${label} ${state.development.potential[key]}`).join(" · ")}</div>
            </section>
            <section class="panel">
              <div class="panel-title">当前俱乐部</div>
              ${currentTeam ? `
                <div class="team-lockup"><div class="team-logo">${currentTeam.short}</div><div><strong>${currentTeam.name}</strong><small>${currentTeam.country} · ${currentTeam.identity}</small></div></div>
                <div class="contract-lines"><div class="contract-line"><span>月薪</span><b>${formatMoney(state.contract.salary)}</b></div><div class="contract-line"><span>剩余</span><b>${state.contract.yearsLeft} 年</b></div><div class="contract-line"><span>定位</span><b>${state.contract.role}</b></div><div class="contract-line"><span>沟通</span><b>${teamLanguage(currentTeam)} ${languageCompatibility(currentTeam)}%</b></div><div class="contract-line"><span>VRS 全球 / 地区</span><b>#${currentVrs.globalRank} / #${currentVrs.regionRank}</b></div><div class="contract-line"><span>VRS 积分</span><b>${currentVrs.points}${currentVrs.lastDelta ? ` (${currentVrs.lastDelta > 0 ? "+" : ""}${currentVrs.lastDelta})` : ""}</b></div><div class="contract-line"><span>实力趋势</span><b>${strengthTrendLabel(currentVrs.lastStrengthDelta)}</b></div></div>`
                : `<p class="text-muted">等待签下第一份职业合同</p>`}
            </section>
          </aside>

          <main class="event-stage">${renderEvent(event)}</main>

          <aside class="career-side right">
            <section class="panel">
              <div class="panel-title">队内状态</div>
              <div class="progress-block"><div class="progress-head"><span>阵容默契</span><b>${state.career.cohesion}</b></div><div class="progress-track"><div class="progress-fill" style="width:${state.career.cohesion}%"></div></div></div>
              <div class="progress-block"><div class="progress-head"><span>身体状态</span><b>${state.stats.fitness}</b></div><div class="progress-track"><div class="progress-fill cyan" style="width:${state.stats.fitness}%"></div></div></div>
              <div class="panel-title" style="margin-top:20px">已激活能力</div>
              <div class="ability-mini-list">${state.abilities.map((id) => `<span class="ability-mini">${ABILITY(id)?.name}</span>`).join("")}</div>
              <div class="panel-title combo-panel-title">能力组合</div>
              <div class="combo-mini-list">${activeAbilityCombos().length ? activeAbilityCombos().map((combo) => `<span class="combo-mini"><b>${combo.name}</b><small>${combo.desc}</small></span>`).join("") : `<span class="text-muted">尚未激活组合</span>`}</div>
            </section>
            <section class="panel">
              <div class="panel-title">生涯动态</div>
              <div class="timeline">${state.career.history.slice(0,5).map((item) => `
                <div class="timeline-item"><time>${item.year} · ${item.type}</time><b>${esc(item.title)}</b><span>${esc(item.detail)}</span></div>`).join("") || `<p class="text-muted">你的故事即将开始。</p>`}</div>
            </section>
          </aside>
        </div>
      </section>`;
  }

  function ABILITY(id) { return ABILITIES.find((item) => item.id === id); }

  function renderEvent(event) {
    if (!event) return "";
    if (event.type === "contracts") return renderContracts(event);
    if (event.type === "easter") return renderEasterEgg(event);
    if (event.type === "decision") return renderDecision(event);
    if (event.type === "growth") return renderGrowthOpportunity(event);
    if (event.type === "outcome") return renderOutcome(event);
    if (event.type === "tournament") return renderTournament(event);
    if (event.type === "review") return renderReview(event);
    if (event.type === "awards") return renderAnnualAwards(event);
    if (event.type === "offseason") return renderOffseason(event);
    if (event.type === "aging") return renderAgingEvent(event);
    return "";
  }

  function renderGrowthOpportunity(event) {
    const potentialLabels = Object.fromEntries(STAT_META);
    return `${eventHeader("PLAYER DEVELOPMENT", event.title, event.desc, `${role()?.code} · ${state.development.points} DP`)}
      <div class="event-body">
        <div class="development-overview"><div><span>可用发展点</span><b>${state.development.points}</b></div><div><span>当前 / 潜力</span><b>${STAT_META.map(([key,label]) => `${label} ${state.stats[key]}/${state.development.potential[key]}`).join(" · ")}</b></div></div>
        <div class="growth-choice-list">${event.options.map((option, index) => `
          <button class="growth-choice" data-action="choose-growth" data-index="${index}" ${state.development.points < option.cost ? "disabled" : ""}>
            <span>${String(index + 1).padStart(2,"0")} · 消耗 ${option.cost} DP</span><b>${option.label}</b><p>${option.hint}</p>
            <div>${effectsToChips(option.effects)}${Object.entries(option.potential || {}).map(([key,value]) => `<span class="effect-chip potential">${potentialLabels[key] || key}潜力 +${value}</span>`).join("")}</div>
          </button>`).join("")}</div>
      </div>`;
  }

  function eventHeader(tag, title, desc, right = `${state.year} · WEEK ${randomBetween(2, 38)}`) {
    return `<div class="event-header"><div class="event-kicker"><span>${tag}</span><span>${right}</span></div><h1>${esc(title)}</h1><p>${esc(desc)}</p></div>`;
  }

  function renderContracts(event) {
    return `${eventHeader(event.initial ? "ROOKIE CONTRACT" : "TRANSFER WINDOW", event.title, event.desc, `${state.year} · OFF-SEASON`)}
      <div class="event-body"><div class="offer-list">${event.offers.map((offer, index) => {
        const offerTeam = TEAMS.find((item) => item.id === offer.teamId);
        return `<article class="offer-card">
          <div class="offer-team"><div class="team-logo">${offerTeam.short}</div><div><h3>${offerTeam.name}</h3><small>${offer.stay ? "留队方案" : `${offerTeam.region} · ${teamTier(offerTeam)}`}</small></div></div>
          <div class="offer-detail"><span>队内角色</span><b>${offer.role}</b></div>
          <div class="offer-detail"><span>阵容需求</span><b>${offer.demand || roleDemand(offerTeam).label}</b></div>
          <div class="offer-detail"><span>队内语言</span><b>${offer.language || teamLanguage(offerTeam)} · ${offer.communication ?? languageCompatibility(offerTeam)}%</b></div>
          <div class="offer-detail"><span>商业价值</span><b>个人影响力 ${state.career.influence}</b></div>
          ${offer.path ? `<div class="offer-detail"><span>生涯后期匹配</span><b>${offer.path}</b></div>` : ""}
          <div class="offer-detail"><span>俱乐部 VRS</span><b>全球 #${vrsEntry(offerTeam.id).globalRank} · ${vrsEntry(offerTeam.id).points} 分</b></div>
          <div class="offer-detail"><span>合同期限</span><b>${offer.years} 年</b></div>
          <div class="offer-detail"><span>月薪</span><b>${formatMoney(offer.salary)}</b></div>
          <div class="offer-detail"><span>签字费</span><b>${formatMoney(offer.bonus)}</b></div>
          <div class="offer-detail"><span>赛季目标</span><b>${offer.goal}</b></div>
          <button class="button ${index === 0 ? "button-primary" : ""}" data-action="accept-offer" data-index="${index}">${offer.stay ? "选择留队" : "接受合同"}</button>
        </article>`;
      }).join("")}</div></div>`;
  }

  function renderDecision(event) {
    return `${eventHeader(event.tag, event.title, event.desc)}
      <div class="event-body"><div class="decision-list">${event.options.map((option, index) => `
        <button class="decision-button" data-action="choose-decision" data-index="${index}">
          <span class="decision-index">0${index + 1}</span><span class="decision-copy"><strong>${option.label}</strong><small>${option.hint}</small></span><span class="decision-risk">${option.risk}</span>
        </button>`).join("")}</div></div>`;
  }

  function renderEasterEgg(event) {
    return `${eventHeader(`EASTER EGG · ${event.tag}`, event.title, event.desc, `${state.year} · 随机彩蛋`)}
      <div class="event-body easter-body">
        <div class="easter-impact-banner"><span>已经发生的世界影响</span>${event.impactNotes?.length ? event.impactNotes.map((note) => `<b>${esc(note)}</b>`).join("") : `<b>影响将由你的选择写入后续比赛与生涯。</b>`}</div>
        <div class="easter-choice-grid">${event.options.map((option, index) => `
          <button class="easter-choice" data-action="choose-easter" data-index="${index}">
            <span>${String(index + 1).padStart(2, "0")} · ${option.risk}</span><h3>${option.label}</h3><p>${option.hint}</p>
            <div class="ability-effects">${effectsToChips(option.effects || {})}</div>
          </button>`).join("")}</div>
      </div>`;
  }

  function renderAgingEvent(event) {
    const pathLabel = { domestic: "本国回归", tier2: "二线核心", last_dance: "最后一舞" }[state.career.lateCareerPath] || "开放市场";
    return `${eventHeader(event.terminal ? "CAREER FINALE" : "VETERAN CROSSROADS", event.title, event.desc, `${state.year} · ${state.age} 岁`)}
      <div class="event-body aging-body">
        <div class="aging-status-grid"><div><span>当前市场路线</span><b>${pathLabel}</b><small>影响下一批合同的俱乐部层级与地区</small></div><div><span>教练潜力</span><b>${state.career.coachingPotential || 0}</b><small>${coachingTitle()}</small></div><div><span>生涯期限</span><b>${event.terminal ? "必须结算" : state.age >= 35 ? "最多 1 季" : `${36 - state.age} 年内`}</b><small>36 岁后不再提供选手续约</small></div></div>
        <div class="aging-choice-grid">${event.options.map((option, index) => `
          <button class="aging-choice ${["coach", "retire"].includes(option.action) ? "terminal" : ""}" data-action="choose-aging" data-index="${index}">
            <span>${option.risk}</span><h3>${option.label}</h3><p>${option.hint}</p><div class="ability-effects">${effectsToChips(option.effects || {})}</div>
          </button>`).join("")}</div>
      </div>`;
  }

  function renderOutcome(event) {
    return `${eventHeader("DECISION MADE · " + event.tag, event.title, event.desc)}
      <div class="event-body">
        <div class="season-summary-banner"><b>选择已经产生影响</b><span>职业生涯里没有绝对正确的答案，只有你愿意承担的结果。</span></div>
        ${event.impactNotes?.length ? `<div class="outcome-impact-list"><span>持续 / 延迟影响</span>${event.impactNotes.map((note) => `<b>${esc(note)}</b>`).join("")}</div>` : ""}
        <div class="ability-effects">${effectsToChips(event.effects)}</div>
        <div class="event-actions"><button class="button button-primary" data-action="advance-event">继续赛季 <span class="button-arrow">→</span></button></div>
      </div>`;
  }

  function signedImpact(value) {
    const rounded = Math.round((value || 0) * 10) / 10;
    return `${rounded >= 0 ? "+" : ""}${rounded.toFixed(1)}`;
  }

  function renderMatchProjection(model, label = "赛前模型胜率") {
    const chance = Math.round(model.winChance * 100);
    const specialLabels = [
      model.patchChaos ? "补丁混乱：差距向 50% 压缩" : null,
      model.eventPressure ? `赛事难度 ${model.eventPressure > 0 ? "+" : ""}${model.eventPressure.toFixed(1)}` : null,
      model.rawPlayerTotal > model.playerTotal ? "个人加成超出软上限 · 超出部分减半" : null,
      model.rawPreparationTotal > model.preparationTotal ? "备战加成超出软上限 · 超出部分减半" : null,
      model.specialBonus ? `${state.seasonData?.specialMatchBonus?.label || "彩蛋修正"} ${model.specialBonus > 0 ? "+" : ""}${model.specialBonus.toFixed(1)}` : null,
      model.preparationPenalty ? `${state.seasonData?.preparationPenalty?.label || "准备修正"} ${-model.preparationPenalty > 0 ? "+" : ""}${(-model.preparationPenalty).toFixed(1)}` : null
    ].filter(Boolean);
    return `<div class="match-win-model" data-win-chance="${chance}">
      <div class="match-win-head"><span>${label}</span><b>${chance}%</b><small>${specialLabels.length ? specialLabels.join(" · ") : "VRS / 队伍基线与个人因素共同计算"}</small></div>
      <div class="match-impact-breakdown">
        <span><i>队伍基线</i><b>${model.teamBase.toFixed(1)} vs ${model.opponentPower.toFixed(1)}</b></span>
        <span><i>个人 OVR ${model.playerOverall}</i><b>${signedImpact(model.playerImpact)}</b></span>
        <span><i>能力牌</i><b>${signedImpact(model.abilityBonus)}</b></span>
        <span><i>组合 / 特性</i><b>${signedImpact(model.comboBonus + model.perkBonus)}</b></span>
        <span><i>地图 / 训练 / 临场</i><b>${signedImpact(model.preparationTotal)}</b></span>
        <span><i>团队 / 沟通 / 状态</i><b>${signedImpact(model.teamContextTotal + model.conditionTotal)}</b></span>
      </div>
    </div>`;
  }

  function tournamentStageOrder(tournament, event) {
    const prefix = event.competition.route.code === "qualifier" || event.competition.stageHistory.some((stage) => stage.phase === "qualifier") ? ["qualifier"] : [];
    if (tournament.major) return [...prefix, "stage1", "stage2", "stage3", "qf", "sf", "final"];
    if (tournament.format === "swiss") return [...prefix, "swiss", "qf", "sf", "final"];
    if (tournament.format === "groups") return [...prefix, "group", "qf", "sf", "final"];
    return [...prefix, "r16", "qf", "sf", "final"];
  }

  function renderTournamentProgress(tournament, event) {
    const comp = event.competition;
    const completed = new Set(comp.stageHistory.map((stage) => stage.phase));
    const stages = tournamentStageOrder(tournament, event);
    const activeIndex = stages.indexOf(comp.phase);
    const matches = comp.matches.slice(-6);
    return `<div class="tournament-progress">
      <div class="route-summary"><div><span>参赛路径</span><b>${comp.route.label}</b><small>${comp.route.detail}</small></div><div><span>赛事长度</span><b>${tournament.length}</b><small>${tournament.formatLabel}</small></div></div>
      <div class="stage-track">${stages.map((phase, index) => { const skipped = index < activeIndex && !completed.has(phase); return `<div class="stage-step ${comp.phase === phase ? "active" : completed.has(phase) ? "done" : skipped ? "skipped" : ""}"><i>${completed.has(phase) ? "✓" : skipped ? "—" : index + 1}</i><span>${phaseLabel(phase)}</span>${["swiss", "group", "stage1", "stage2", "stage3", "qualifier"].includes(phase) && comp.phase === phase ? `<b>${comp.wins}-${comp.losses}</b>` : ""}</div>`; }).join("")}</div>
      ${matches.length ? `<div class="match-ledger">${matches.map((match) => `<span class="${match.won ? "won" : "lost"}"><i>${match.won ? "W" : "L"}</i><b>${match.phaseLabel}</b>${match.opponent} · ${match.score}</span>`).join("")}</div>` : ""}
    </div>`;
  }

  function renderMajorAllocation() {
    return `<div class="major-allocation"><div class="major-allocation-head"><b>Major 地区邀请名额</b><span>${MAJOR_REGION_SLOTS.label}</span></div>
      <div class="major-slot-grid"><span>地区</span><span>Stage 1</span><span>Stage 2</span><span>Stage 3</span>
      ${[["欧洲", "Europe"], ["美洲", "Americas"], ["亚洲", "Asia"]].map(([label, key]) => `<b>${label}</b><em>${MAJOR_REGION_SLOTS[key].stage1}</em><em>${MAJOR_REGION_SLOTS[key].stage2}</em><em>${MAJOR_REGION_SLOTS[key].stage3}</em>`).join("")}</div>
      <small>每有一支该地区队伍在上一届进入 Stage 3 / 淘汰赛，下一届分别获得一个 Stage 2 / Stage 3 名额。地区 VRS 发邀请，全球 VRS 仅用于赛事种子。</small></div>`;
  }

  function renderEventField(tournament, event) {
    const ids = event.competition.field;
    const entries = ids.map((id) => ({ candidate: TEAMS.find((teamItem) => teamItem.id === id), vrs: vrsEntry(id) })).filter((entry) => entry.candidate).sort((a, b) => a.vrs.globalRank - b.vrs.globalRank);
    const visible = entries.slice(0, 8);
    return `<div class="event-field"><div class="field-head"><b>正赛队伍观察</b><span>${tournament.teamCount} 队 · VRS 决定种子，玩家比赛另计个人能力</span></div><div class="field-team-grid">${visible.map((entry) => `<div class="${entry.candidate.id === team().id ? "current" : ""}"><span class="team-logo">${entry.candidate.short}</span><b>${entry.candidate.name}</b><small>VRS #${entry.vrs.globalRank} · ${entry.vrs.points}</small></div>`).join("")}</div></div>`;
  }

  function renderMatchResult(tournament, event) {
    const match = event.matchResult;
    const comp = event.competition;
    const next = phaseLabel(comp.phase);
    const transitioned = match.phase !== comp.phase;
    return `${eventHeader(match.won ? "MATCH WON" : "MATCH LOST", `${team().short} ${match.score} ${TEAMS.find((candidate) => candidate.id === match.opponentId)?.short || "OPP"}`, `${match.phaseLabel}结束。个人 Rating ${match.rating.toFixed(2)}，赛事仍在继续。`, `${match.bestOf === 1 ? "BO1" : "BO3"} · MATCH ${match.number}`)}
      <div class="event-body">${renderTournamentProgress(tournament, event)}
        <div class="match-result-panel ${match.won ? "won" : "lost"}"><span>${match.won ? "胜利" : "失利"}</span><b>${match.score}</b><p>${match.opponent} · ${match.playedMaps.map((id) => mapById(id)?.name).filter(Boolean).join(" / ")}</p><small>${transitioned ? `已经进入 ${next}` : `下一场仍在 ${next}，当前战绩 ${comp.wins}-${comp.losses}`}${match.winChance != null ? ` · 模型胜率 ${Math.round(match.winChance * 100)}% · 个人能力 ${signedImpact(match.powerBreakdown?.playerTotal)}` : ""}</small></div>
        <div class="event-actions"><button class="button button-primary" data-action="continue-tournament">准备下一场 <span class="button-arrow">→</span></button></div>
      </div>`;
  }

  function renderTournament(event) {
    const tournament = TOURNAMENTS.find((item) => item.id === event.tournamentId);
    const presentation = tournamentPresentation(tournament, event);
    if (event.resolved) return renderTournamentResult(tournament, event.result);
    if (event.stage === "matchResult") return renderMatchResult(tournament, event);
    if (event.minigame) return renderMiniGame(tournament, event.minigame.type);
    if (event.stage === "veto") return renderVetoRoom(tournament, event);
    if (event.stage === "training") return renderMapTraining(tournament, event);
    if (event.stage === "scenario") return renderScenarioBrief(tournament, event);
    if (event.stage === "resolution") return renderScenarioResolution(tournament, event);
    const opponent = tournamentOpponent(event);
    const opponentProfile = teamMapProfile(opponent);
    const ownProfile = teamMapProfile(team());
    const traits = playerMapTraits();
    const projection = matchPowerBreakdown(event);
    const expectation = projection.winChance >= 0.62 ? "对阵优势" : projection.winChance <= 0.38 ? "以下克上" : "实力接近";
    const bestOf = currentMatchBestOf(event);
    const entry = vrsEntry(team().id);
    return `${eventHeader(tournament.major ? "VALVE MAJOR" : `${tournament.tier}-TIER EVENT`, presentation.name, `${currentMatchLabel(event)}：${team().name} 对阵 ${opponent.name}。先查看赛制、资格路径与地图资料。`, presentation.code)}
      <div class="event-body">${renderTournamentProgress(tournament, event)}
      <div class="tournament-board">
        <figure class="event-promo"><img src="${presentation.image}" alt="${presentation.name} 赛事宣传视觉" onerror="this.onerror=null;this.src='${presentation.fallbackImage}'"><figcaption><span>${presentation.code}</span><div><b>${presentation.location}</b>${presentation.posterSource ? `<a class="event-promo-credit" href="${presentation.posterSource.url}" target="_blank" rel="noreferrer noopener" title="图片出处：${presentation.posterSource.credit}">图片来源 · ${presentation.posterSource.publisher} ↗</a>` : ""}</div></figcaption></figure>
        <div class="tournament-info"><dl>
          <div><dt>本轮对手</dt><dd>${opponent.name} · VRS #${vrsEntry(opponent.id).globalRank}</dd></div><div><dt>对阵判断</dt><dd>${expectation} · ${bestOf === 1 ? "BO1" : "BO3"}</dd></div>
          <div><dt>我方 VRS</dt><dd>全球 #${entry.globalRank} · ${team().region} #${entry.regionRank} · ${entry.points} 分</dd></div>
          ${presentation.historic ? `<div><dt>历史举办履历</dt><dd>${presentation.historic}</dd></div>` : ""}
          <div><dt>${team().name} 图池</dt><dd>首选 ${mapById(ownProfile.firstPick).name} · 永禁 ${mapById(ownProfile.permaban).name}</dd></div>
          <div><dt>${opponent.name} 图池</dt><dd>首选 ${mapById(opponentProfile.firstPick).name} · 永禁 ${mapById(opponentProfile.permaban).name}</dd></div>
        </dl>
          ${renderMatchProjection(projection)}
          <div class="opponent-lockup"><div class="team-logo">${opponent.short}</div><div><span>OPPONENT / ${teamTier(opponent)}</span><b>${opponent.name}</b><small>${opponent.country} · ${opponent.identity}</small></div></div>
          <div class="player-map-note"><span>你的强图：${traits.strong.map((map) => `${map.name} ${map.value}`).join(" / ")}</span><span>弱图：${traits.weak.map((map) => `${map.name} ${map.value}`).join(" / ")}</span></div>
          <div class="match-control-panel">
            <div><span>比赛节奏</span><div class="pace-options">${[["fast","快速"],["balanced","均衡"],["immersive","沉浸"]].map(([id,label]) => `<button class="pace-button ${state.preferences.pace === id ? "active" : ""}" data-action="set-pace" data-id="${id}">${label}</button>`).join("")}</div></div>
            <button class="veto-mode-button" data-action="toggle-veto-mode"><span>Ban/Pick</span><b>${state.preferences.vetoMode === "auto" ? "教练托管" : "手动操作"}</b></button>
          </div>
          <div class="match-start-actions"><button class="button button-primary" data-action="start-veto">${state.preferences.vetoMode === "auto" ? "由教练完成" : "进入"} ${bestOf === 1 ? "BO1" : "BO3"} 选图 <span class="button-arrow">→</span></button>${!isKeyTournamentMatch(event) ? `<button class="button" data-action="simulate-to-key">推进至关键比赛</button>` : ""}</div>
        </div>
      </div>${tournament.major ? renderMajorAllocation() : ""}${renderEventField(tournament, event)}</div>`;
  }

  function vetoMapStatus(veto, mapId) {
    const log = [...(veto?.log || [])].reverse().find((item) => item.mapId === mapId);
    if (!log) return "AVAILABLE";
    return log.action === "BAN" ? `BAN · ${log.team}` : log.action === "PICK" ? `PICK · ${log.team}` : "DECIDER";
  }

  function renderVetoRoom(tournament, event) {
    const opponent = tournamentOpponent(event);
    const veto = event.veto;
    const stageCopy = {
      bo1TeamBan: ["BO1 第一轮禁用", `对手已经永久禁用 ${mapById(teamMapProfile(opponent).permaban).name}。选择一张 BAN 图，双方将自动完成剩余禁用。`],
      teamBan1: ["第一轮禁用", `对手已经永久禁用 ${mapById(teamMapProfile(opponent).permaban).name}。选择 ${team().name} 的第一张 BAN 图。`],
      teamPick: ["选择本队一选", `${opponent.name} 已经锁定自己的选择。现在决定你们主动进入哪张地图。`],
      teamBan2: ["最后一轮禁用", "还剩两张候选图，禁用其中一张，另一张将成为决胜图。"]
    }[veto.stage] || [`BO${veto.bestOf} 地图确定`, "系列赛地图已经锁定。"];
    const ownProfile = teamMapProfile(team());
    let recommendation = ["teamBan1", "bo1TeamBan"].includes(veto.stage) ? ownProfile.permaban : veto.stage === "teamPick" ? bestMapFor(team(), veto.available) : bestMapFor(opponent, veto.available);
    if (!veto.available.includes(recommendation)) {
      recommendation = veto.stage === "teamPick"
        ? bestMapFor(team(), veto.available)
        : [...veto.available].sort((a,b) => (teamMapRate(team(), a) + mapSkill(a) * 0.2) - (teamMapRate(team(), b) + mapSkill(b) * 0.2))[0];
    }
    return `${eventHeader(`MATCH ROOM · BO${veto.bestOf} VETO`, stageCopy[0], stageCopy[1], `${team().short} vs ${opponent.short}`)}
      <div class="event-body veto-body">
        <div class="versus-strip"><div><span class="team-logo">${team().short}</span><b>${team().name}</b></div><strong>BO${veto.bestOf}</strong><div><b>${opponent.name}</b><span class="team-logo">${opponent.short}</span></div></div>
        <div class="veto-assist"><span>可随时交给教练组根据永禁图、首选图与地图胜率完成剩余流程。</span><button class="button button-small" data-action="auto-veto">托管剩余 Ban/Pick</button></div>
        <div class="map-table-wrap"><table class="map-intel-table"><thead><tr><th>地图</th><th>${team().short} 胜率</th><th>个人熟练</th><th>${opponent.short} 胜率</th><th>状态</th></tr></thead><tbody>
          ${MAPS.map((map) => `<tr class="${veto.available.includes(map.id) ? "available" : "locked"}"><td><b>${map.name}</b><small>${map.style}</small></td><td>${teamMapRate(team(), map.id)}%</td><td class="${mapSkill(map.id) >= 60 ? "positive" : mapSkill(map.id) < 48 ? "negative" : ""}">${mapSkill(map.id)}</td><td>${teamMapRate(opponent, map.id)}%</td><td>${vetoMapStatus(veto, map.id)}</td></tr>`).join("")}
        </tbody></table></div>
        <div class="veto-choice-grid">${veto.available.map((mapId) => { const map = mapById(mapId); return `<button class="veto-map-button ${recommendation === mapId ? "recommended" : ""}" data-action="veto-map" data-id="${mapId}"><span>${map.code}</span><b>${map.name}</b><small>${recommendation === mapId ? "教练建议" : map.style}</small></button>`; }).join("")}</div>
        <div class="veto-log">${veto.log.map((item, index) => `<span><i>${String(index + 1).padStart(2,"0")}</i>${item.team} <b>${item.action}</b> ${mapById(item.mapId).name}</span>`).join("")}</div>
      </div>`;
  }

  function renderMapTraining(tournament, event) {
    const opponent = tournamentOpponent(event);
    const traits = playerMapTraits();
    return `${eventHeader("MATCH PREPARATION", "选择一张地图进行针对训练", `BO${event.veto.bestOf || 3} 地图已经确定。你只能把最后一段个人训练时间投入其中一张地图。`, `${team().short} vs ${opponent.short}`)}
      <div class="event-body">
        <div class="series-map-list">${event.veto.selected.map((entry, index) => { const map = mapById(entry.mapId); const isWeak = traits.weak.some((item) => item.id === map.id); return `<button class="series-map-card ${isWeak ? "weak" : ""}" data-action="target-map-training" data-id="${map.id}"><span>MAP ${index + 1} · ${entry.pickedBy === "decider" ? "DECIDER" : entry.pickedBy === team().id ? `${team().short} PICK` : `${opponent.short} PICK`}</span><b>${map.name}</b><small>${map.style}</small><div><em>我方 ${teamMapRate(team(), map.id)}%</em><em>个人 ${mapSkill(map.id)}</em><em>对手 ${teamMapRate(opponent, map.id)}%</em></div><strong>${isWeak ? "弱图专项 · 训练收益更高" : "进行针对训练"}</strong></button>`; }).join("")}</div>
      </div>`;
  }

  function scenarioMeta(type, event = state.currentEvent) {
    const map = mapById(event.trainingMapId);
    const opponent = tournamentOpponent(event);
    const context = event.roundContext || (event.roundContext = generateRoundContext(event));
    const scoreText = `${team().short} ${context.ourScore}:${context.theirScore} ${opponent.short}`;
    const data = {
      reaction: { code: "AWP", title: `${context.situation} · 狙击架点`, desc: `${map.name} 当前 ${scoreText}。你用 AWP 守住狭窄缝隙，${opponent.name} 的突破手可能随时从掩体后过点。` },
      aim: { code: "RIFLE", title: `${context.situation} · 步枪快速多杀`, desc: `${map.name} 当前 ${scoreText}，防守方经济濒临崩溃。${opponent.name} 正在强攻包点，你必须连续完成多杀。` },
      spray: { code: "SPRAY", title: `${context.situation} · 扫射转移`, desc: `${map.name} 当前 ${scoreText}。转点被对手察觉，三名敌人从不同枪位同时出现。` },
      deagle: { code: "DEAGLE", title: `${context.situation} · 沙鹰翻盘`, desc: `${map.name} 当前 ${scoreText}，你只剩一把 Desert Eagle 和 7 发子弹。完成 5 次爆头抢回经济与士气。` }
    };
    return data[type] || data.aim;
  }

  function renderScenarioBrief(tournament, event) {
    const meta = scenarioMeta(event.scenarioType, event);
    const map = mapById(event.trainingMapId);
    const opponent = tournamentOpponent(event);
    const context = event.roundContext;
    return `${eventHeader("LIVE MATCH · KEY ROUND", meta.title, meta.desc, `${map.code} · ${context.ourScore}:${context.theirScore}`)}
      <div class="event-body"><div class="key-round-brief">
        <div class="round-scoreboard"><div><span>${team().short}</span><b>${context.ourScore}</b></div><strong>ROUND ${context.round}<br><small>${map.name}</small></strong><div><b>${context.theirScore}</b><span>${opponent.short}</span></div></div>
        <div class="scenario-callout"><span>${meta.code}</span><div><b>本回合任务</b><p>${meta.desc}</p></div></div>
        <div class="targeted-training-note">针对训练：${map.name} 熟练度提升至 <b>${mapSkill(map.id)}</b> · 本场地图加成 +${event.mapBonus}</div>
        <button class="button button-primary" data-action="enter-key-round">进入关键回合 <span class="button-arrow">→</span></button>
      </div></div>`;
  }

  function renderScenarioResolution(tournament, event) {
    const result = event.trainingScore;
    const map = mapById(event.trainingMapId);
    const projection = matchPowerBreakdown(event);
    return `${eventHeader("ROUND COMPLETE", result.label, result.summary, `${map?.code || tournamentPresentation(tournament, event).code} · IMPACT`)}
      <div class="event-body"><div class="scenario-result-panel"><span>关键回合影响</span><b>+${result.bonus}</b><p>${result.score} 分 · 将计入系列赛状态与个人 Rating 结算${result.comboBonus ? ` · 能力组合额外 +${result.comboBonus}` : ""}</p></div>
        ${renderMatchProjection(projection, "本场最终模型胜率")}
        <div class="event-actions"><button class="button button-primary" data-action="simulate-tournament">结算本场系列赛 <span class="button-arrow">→</span></button></div>
      </div>`;
  }

  function renderMiniGame(tournament, type) {
    const meta = scenarioMeta(type);
    const map = mapById(state.currentEvent.trainingMapId);
    const hud = {
      aim: `<div><span>剩余时间</span><b id="game-time">8.0s</b></div><div><span>击杀</span><b id="game-hits">0</b></div><div><span>命中率</span><b id="game-accuracy">100%</b></div>`,
      reaction: `<div><span>过点轮次</span><b id="reaction-round">1 / 5</b></div><div><span>平均反应</span><b id="reaction-average">—</b></div><div><span>抢枪</span><b id="reaction-false">0</b></div>`,
      spray: `<div><span>剩余时间</span><b id="game-time">7.0s</b></div><div><span>击杀</span><b id="game-hits">0</b></div><div><span>当前连杀</span><b id="spray-chain">0</b></div>`,
      deagle: `<div><span>剩余时间</span><b id="game-time">10.0s</b></div><div><span>爆头</span><b id="game-hits">0 / 5</b></div><div><span>剩余子弹</span><b id="deagle-bullets">7</b></div>`
    }[type];
    const scene = type === "reaction"
      ? `<div class="reaction-lane" aria-hidden="true"><div class="reaction-cover left"><span>A SITE</span></div><div class="reaction-gap"><i></i></div><div class="reaction-cover right"><span>CON</span></div></div>`
      : `<div class="combat-cover cover-a" aria-hidden="true"></div><div class="combat-cover cover-b" aria-hidden="true"></div><div class="field-crosshair" aria-hidden="true"></div>`;
    const context = state.currentEvent.roundContext || (state.currentEvent.roundContext = generateRoundContext(state.currentEvent));
    return `${eventHeader(`LIVE ROUND · ${map.name}`, meta.title, meta.desc, `${team().short} ${context.ourScore} : ${context.theirScore} ${tournamentOpponent().short}`)}
      <div class="event-body minigame-body">
        <div class="minigame-hud">${hud}</div>
        <div class="minigame-field ${type}-field" data-minigame-field data-game="${type}">
          <div class="field-grid" aria-hidden="true"></div>${scene}
          <div class="minigame-message" id="game-message">按下开始后进入回合。空枪和提前开枪都会影响结果。</div>
        </div>
        <div class="minigame-actions"><button class="button" data-action="cancel-minigame">返回战术暂停</button><button class="button button-primary" data-action="begin-minigame">回到服务器 <span class="button-arrow">→</span></button></div>
      </div>`;
  }

  function renderTournamentResult(tournament, result) {
    const isWin = result.stage === "冠军";
    const matches = result.matches || [];
    const keyImpact = matches.reduce((sum, match) => sum + (match.warmup?.bonus || 0), 0);
    const vrs = result.vrs || { before: vrsEntry(team().id).points, after: vrsEntry(team().id).points, delta: 0, globalRank: vrsEntry(team().id).globalRank, trend: "阵容强度稳定", standings: [] };
    const standings = (vrs.standings || []).map((standing) => ({ ...standing, candidate: TEAMS.find((candidate) => candidate.id === standing.teamId) })).filter((standing) => standing.candidate);
    return `${eventHeader(isWin ? "CHAMPIONS" : "EVENT RESULT", result.tournamentName || tournament.name, isWin ? "决胜局的最后一名对手倒下，舞台灯光全部转向了你们。" : `这一次旅程停在了${result.stage}。结果已经写下，但赛季还没有结束。`, result.majorHost?.code || tournament.code)}
      <div class="event-body">
        <div class="result-hero"><div class="result-rank">${result.rank}</div><h2>${result.stage}</h2><p>代表 ${team().name} · ${matches.length} 场系列赛 · ${result.path || "赛事正赛"}${result.finalMatch ? ` · 决赛 ${result.finalMatch.teamA} ${result.finalMatch.score} ${result.finalMatch.teamB} · 冠军 ${result.finalMatch.winner}` : ""}</p></div>
        <div class="result-metrics four"><div class="result-metric"><span>赛事平均 RATING</span><b>${result.rating.toFixed(2)}</b></div><div class="result-metric"><span>关键回合总影响</span><b>+${keyImpact}</b></div><div class="result-metric"><span>赛事奖金分成</span><b>${formatMoney(result.prize)}</b></div><div class="result-metric"><span>VRS 变化</span><b>${vrs.delta >= 0 ? "+" : ""}${vrs.delta} · #${vrs.globalRank}</b></div></div>
        ${matches.length ? `<div class="result-match-list"><div class="field-head"><b>完整赛程</b><span>${matches.filter((match) => match.won).length} 胜 ${matches.filter((match) => !match.won).length} 负</span></div>${matches.map((match) => `<div><i class="${match.won ? "won" : "lost"}">${match.won ? "W" : "L"}</i><span>${match.phaseLabel}</span><b>${match.opponent}</b><strong>${match.score}</strong><small>Rating ${match.rating.toFixed(2)} · BO${match.bestOf}${match.winChance != null ? ` · 胜率 ${Math.round(match.winChance * 100)}%` : ""}${match.powerBreakdown ? ` · 个人 ${signedImpact(match.powerBreakdown.playerTotal)}` : ""}</small></div>`).join("")}</div>` : ""}
        ${standings.length ? `<div class="final-standings"><div class="field-head"><b>赛事完整名次</b><span>${standings.length} 支参赛队 · 名次同步结算 VRS 与实力状态</span></div>${standings.map((standing) => `<div class="${standing.teamId === team().id ? "current" : ""}"><span>#${standing.rank}</span><b>${standing.candidate.name}</b><small>VRS ${state.vrs.teams[standing.teamId].points} · ${state.vrs.teams[standing.teamId].lastDelta >= 0 ? "+" : ""}${state.vrs.teams[standing.teamId].lastDelta}</small></div>`).join("")}</div>` : ""}
        <div class="vrs-update-note"><b>模拟 VRS：${vrs.before} → ${vrs.after} · ${vrs.trend || "阵容强度稳定"}</b><span>开局使用 Valve ${VRS_SNAPSHOT_DATE} 快照；赛事后的积分、动态名次与实力趋势为游戏模型，并非 Valve 官方实时计算。</span></div>
        <div class="event-actions"><button class="button button-primary" data-action="advance-event">返回赛季 <span class="button-arrow">→</span></button></div>
      </div>`;
  }

  function renderReview(event) {
    const bestTournament = event.best?.tournamentName || (event.best ? TOURNAMENTS.find((t) => t.id === event.best.tournamentId)?.name : "无赛事记录");
    const reviewVrs = event.vrsPoints ?? vrsEntry(team().id).points;
    const reviewVrsDelta = event.vrsDelta ?? 0;
    const statGrowth = STAT_META.map(([key,label]) => ({ label, value: event.statChanges?.[key] || 0 })).filter((item) => item.value !== 0);
    const summary = event.averageRating >= 1.2 ? "你打出了明星级赛季，市场价值快速上升。" : event.averageRating >= 1.05 ? "这是一个稳步向上的赛季，你证明了自己属于这里。" : "赛季充满波动，休赛期的每个决定都会更加重要。";
    return `${eventHeader("SEASON REVIEW", `${state.year} 赛季报告`, summary, `${team().short} · FINAL`)}
      <div class="event-body">
        <div class="season-summary-banner"><b>${team().name} · VRS 世界 #${event.worldRank} · ${reviewVrs} 分</b><span>最佳战绩：${bestTournament} ${event.best?.stage || "—"} · 赛季 VRS ${reviewVrsDelta >= 0 ? "+" : ""}${reviewVrsDelta}</span></div>
        <div class="season-growth-report"><div><span>赛季成长</span><b>${statGrowth.length ? statGrowth.map((item) => `${item.label} ${item.value > 0 ? "+" : ""}${item.value}`).join(" · ") : "能力保持稳定"}</b></div><div><span>休赛期发展点</span><b>+${event.seasonDevelopment || 0} · 当前 ${state.development.points} DP</b></div></div>
        <div class="summary-grid"><div class="summary-cell"><span>平均 RATING</span><b>${event.averageRating.toFixed(2)}</b></div><div class="summary-cell"><span>赛季收入</span><b>${formatMoney(event.seasonEarnings)}</b></div><div class="summary-cell"><span>当前 OVR</span><b>${overall()}</b></div><div class="summary-cell"><span>个人影响力</span><b>${state.career.influence}</b></div></div>
        <div class="event-actions"><button class="button button-primary" data-action="annual-awards">参加 ${state.year} HLTV 年度颁奖典礼 <span class="button-arrow">→</span></button><button class="button button-danger" data-action="retire">宣布退役</button></div>
      </div>`;
  }

  function renderAnnualAwards(event) {
    const podium = event.top20.slice(0, 3);
    const playerInTop20 = event.playerRank <= 20;
    const winnerChanged = event.previousWinner && event.previousWinner.nickname !== event.winner.nickname;
    return `${eventHeader("HLTV AWARDS · SIMULATION", `${event.year} 年度颁奖典礼`, `${event.winner.nickname} 领跑这一年的个人榜单。你的赛事成绩、Rating、OVR、冠军、MVP 与 VRS 排名共同决定年度位置。`, `TOP 20 · ${event.year}`)}
      <div class="event-body awards-body">
        <div class="awards-disclaimer">非官方玩法模拟：榜单并非 HLTV.org 的真实评选或预测，真实选手仅作为生涯时代竞争资料。</div>
        <div class="awards-podium">${podium.map((entry) => `<div class="podium-card rank-${entry.rank} ${entry.isPlayer ? "current" : ""}"><span>#${entry.rank}</span><div class="award-avatar">${esc(entry.nickname.slice(0, 2).toUpperCase())}</div><b>${esc(entry.nickname)}</b><small>${entry.country} · ${entry.role}</small><em>年度指数 ${entry.score} · Rating ${entry.rating.toFixed(2)}</em><i>${entry.era}${entry.future ? " · 虚构未来选手" : ""}</i></div>`).join("")}</div>
        <div class="player-award-result ${playerInTop20 ? "placed" : "outside"}"><div><span>你的年度排名</span><b>${playerInTop20 ? `#${event.playerRank}` : `#${event.playerRank} · 未入选 TOP 20`}</b><small>${event.accolade || "继续积累大赛成绩，下一年仍有机会"}</small></div><div><span>年度指数</span><b>${event.playerEntry.score}</b><small>年度影响力 +${event.fameGain}</small></div></div>
        <div class="awards-era-panel"><div><span>时代领跑变化</span><b>${winnerChanged ? `${event.previousWinner.nickname} → ${event.winner.nickname}` : `${event.winner.nickname} 延续领先`}</b><small>选手会按照上升期、巅峰期和生涯后期逐年更迭。</small></div><div><span>本届新面孔</span><b>${event.newcomers.length ? event.newcomers.map((item) => `${item.nickname}${item.future ? "〔模拟〕" : ""}`).join(" · ") : "没有顶级新人首秀"}</b><small>${event.departures.length ? `告别榜单：${event.departures.join(" · ")}` : "本年度没有著名选手结束生涯周期"}</small></div></div>
        <div class="award-ranking-list"><div class="field-head"><b>年度 TOP 20</b><span>真实名将会逐渐淡出，未来年份由年轻选手和模拟新生代接班</span></div>${event.top20.map((entry) => `<div class="${entry.isPlayer ? "current" : ""}"><span>#${entry.rank}</span><b>${esc(entry.nickname)}</b><small>${entry.country} · ${entry.role}${entry.future ? " · 模拟新生代" : ""}</small><strong>${entry.score}</strong><em>${entry.era}</em></div>`).join("")}</div>
        <div class="event-actions"><button class="button button-primary" data-action="next-season">安排休赛期恢复 <span class="button-arrow">→</span></button></div>
      </div>`;
  }

  function renderOffseason(event) {
    const loadLabel = event.matchLoad >= 22 ? "赛程负荷很高" : event.matchLoad >= 14 ? "赛程负荷适中" : "赛程负荷可控";
    const warning = state.career.injuryWarnings || 0;
    return `${eventHeader("OFF-SEASON · RECOVERY", event.title, `本赛季比赛负荷 ${event.matchLoad}，${loadLabel}。选择休息方式决定身体恢复与休赛期训练收益。`, `${state.year} → ${state.year + 1}`)}
      <div class="event-body">
        <div class="offseason-health-summary">
          <div><span>当前身体状态</span><b>${event.fitnessBefore}</b><small>下赛季理想恢复线 ${event.target}</small></div>
          <div><span>严重伤病预警</span><b>${warning} / 3</b><small>${warning ? "本次充分康复可以避免风险继续累积" : "目前没有连续严重伤病记录"}</small></div>
          <div><span>赛季比赛负荷</span><b>${event.matchLoad}</b><small>比赛负荷只在过量时造成少量长期损耗</small></div>
        </div>
        <div class="offseason-choice-grid">${event.options.map((option, index) => {
          const after = clamp(event.fitnessBefore + option.recovery);
          return `<button class="offseason-choice ${option.id === "balanced_rest" ? "recommended" : ""}" data-action="choose-offseason" data-index="${index}">
            <span>${option.risk}${option.id === "balanced_rest" ? " · 教练建议" : ""}</span>
            <h3>${option.label}</h3>
            <div class="offseason-recovery"><i>状态</i><b>${event.fitnessBefore} → ${after}</b><strong>+${option.recovery}</strong></div>
            <p>${option.hint}</p>
            <div class="ability-effects">${effectsToChips({ fitness: option.recovery, ...option.effects })}</div>
          </button>`;
        }).join("")}</div>
      </div>`;
  }

  function retire(reason = "主动选择退役", endRole = "retired") {
    state.retiredReason = reason;
    state.career.endRole = state.career.endRole || endRole;
    state.phase = "retired";
    saveGame();
    render();
  }

  function careerGrade() {
    const vrsLegacy = state.career.peakVrsRank && state.career.peakVrsRank < 999 ? Math.max(0, 100 - state.career.peakVrsRank) * 0.15 : 0;
    const score = state.career.titles.length * 14 + state.career.titles.filter((t) => t.major).length * 24 + state.career.awards.length * 9 + state.career.peakOverall * 0.5 + state.career.seasonHistory.length * 2 + state.career.bestRating * 14 + state.career.influence * 0.35 + Math.min(12, state.career.sponsorIncome / 50000) + activeAbilityCombos().length * 2 + vrsLegacy;
    if (score >= 135) return { grade: "S+", title: "时代传奇" };
    if (score >= 105) return { grade: "S", title: "名人堂级生涯" };
    if (score >= 82) return { grade: "A", title: "冠军级选手" };
    if (score >= 62) return { grade: "B", title: "一线赛场常客" };
    if (score >= 45) return { grade: "C", title: "可靠职业选手" };
    return { grade: "D", title: "未竟的旅程" };
  }

  function renderRetirement() {
    const grade = careerGrade();
    const majors = state.career.titles.filter((title) => title.major).length;
    const years = state.career.seasonHistory.length;
    const favoriteTeam = favoriteTeamName();
    const epilogue = buildEpilogue(grade, majors, favoriteTeam);
    const becameCoach = state.career.endRole === "coach";
    root.innerHTML = `
      <section class="retirement-page">
        <div class="retirement-hero" data-rating="${grade.grade}">
          <p class="eyebrow">CAREER COMPLETE · ${state.retiredReason}</p>
          <h1>${esc(state.profile.nickname)}<br>${becameCoach ? "走向了教练席" : "离开了服务器"}</h1>
          <p>${state.age} 岁，${years} 个完整赛季。${becameCoach ? `你以${esc(state.career.coachingTitle || coachingTitle())}的身份开启下一段生涯，比赛经验将继续影响后来者。` : "聚光灯熄灭之后，冠军、失利、转会与那些无人知晓的训练夜晚，共同构成了这段职业生涯。"}</p>
          <div class="career-grade"><span>生涯评价</span><b>${grade.grade}</b><span>${grade.title}</span></div>
        </div>
        <div class="retirement-grid">
          <section class="retirement-section">
            <h2>生涯数据</h2>
            <div class="legacy-metrics">
              <div class="legacy-metric"><span>职业赛季</span><b>${years}</b></div><div class="legacy-metric"><span>赛事冠军</span><b>${state.career.titles.length}</b></div>
              <div class="legacy-metric"><span>MAJOR 冠军</span><b>${majors}</b></div><div class="legacy-metric"><span>生涯总收入</span><b>${formatMoney(state.career.earnings)}</b></div>
              <div class="legacy-metric"><span>最佳 RATING</span><b>${state.career.bestRating ? state.career.bestRating.toFixed(2) : "—"}</b></div><div class="legacy-metric"><span>巅峰 OVR</span><b>${state.career.peakOverall}</b></div>
              <div class="legacy-metric"><span>个人影响力</span><b>${state.career.influence}</b></div><div class="legacy-metric"><span>商业收入</span><b>${formatMoney(state.career.sponsorIncome)}</b></div>
              <div class="legacy-metric"><span>VRS 生涯最高</span><b>#${state.career.peakVrsRank === 999 ? "—" : state.career.peakVrsRank}</b></div><div class="legacy-metric"><span>VRS 峰值积分</span><b>${state.career.peakVrsPoints || "—"}</b></div>
              <div class="legacy-metric"><span>能力组合</span><b>${activeAbilityCombos().length}</b></div><div class="legacy-metric"><span>完整赛事</span><b>${state.career.seasonHistory.reduce((sum, season) => sum + (season.tournaments || 0), 0)}</b></div>
              <div class="legacy-metric"><span>职业结局</span><b>${becameCoach ? "转型教练" : "选手退役"}</b></div><div class="legacy-metric"><span>随机彩蛋</span><b>${state.career.easterEggs?.length || 0}</b></div>
            </div>
          </section>
          <section class="retirement-section">
            <h2>效力轨迹</h2>
            <div class="career-path">${state.career.teamHistory.map((entry) => {
              const itemTeam = TEAMS.find((t) => t.id === entry.teamId);
              return `<div class="path-row"><time>${entry.year}</time><b>${itemTeam?.name || entry.teamId}</b><span>来自 ${entry.from}</span></div>`;
            }).join("") || `<p class="text-muted">没有留下俱乐部记录。</p>`}</div>
          </section>
        </div>
        <div class="epilogue">${epilogue}</div>
        ${activeAbilityCombos().length ? `<div class="retirement-section" style="margin-top:34px"><h2>标志性能力组合</h2><div class="career-path">${activeAbilityCombos().map((combo) => `<div class="path-row"><time>COMBO</time><b>${combo.name}</b><span>${combo.desc}</span></div>`).join("")}</div></div>` : ""}
        ${state.career.titles.length ? `<div class="retirement-section" style="margin-top:34px"><h2>冠军荣誉</h2><div class="career-path">${state.career.titles.map((title) => `<div class="path-row"><time>${title.year}</time><b>${title.tournament}</b><span>${title.team}${title.major ? " · MAJOR" : ""}</span></div>`).join("")}</div></div>` : ""}
        <div class="event-actions" style="margin-top:36px"><button class="button button-primary" data-action="restart-career">创建新选手</button><button class="button" data-action="back-home">返回标题页</button></div>
      </section>`;
  }

  function favoriteTeamName() {
    const counts = {};
    state.career.seasonHistory.forEach((season) => { counts[season.team] = (counts[season.team] || 0) + 1; });
    return Object.entries(counts).sort((a,b) => b[1] - a[1])[0]?.[0] || team()?.name || "职业赛场";
  }

  function buildEpilogue(grade, majors, favoriteTeam) {
    if (state.career.endRole === "coach") return `<b>${esc(state.profile.nickname)}</b> 没有真正离开比赛。作为${esc(state.career.coachingTitle || coachingTitle())}，你把在 ${esc(favoriteTeam)}、转会窗口与大赛舞台积累的经验重新整理成战术、训练和临场判断。下一代选手会在你的暂停之后回到服务器。`;
    if (majors > 0) return `后来，人们仍会在讨论 Major 历史时提起 <b>${esc(state.profile.nickname)}</b>。那座奖杯让你和 ${esc(favoriteTeam)} 的名字永远留在了 CS 的时间线上。你以 ${grade.title} 的身份离开，但你的比赛录像仍在被下一代选手反复观看。`;
    if (state.career.titles.length >= 2) return `<b>${esc(state.profile.nickname)}</b> 没有捧起 Major，却一次次站上国际赛事的最后舞台。${esc(favoriteTeam)} 的支持者记得你的每个关键回合，而你证明了一段职业生涯不需要用唯一一座奖杯来定义。`;
    if (state.career.seasonHistory.length >= 5) return `在瞬息万变的职业圈里，坚持本身就是成就。<b>${esc(state.profile.nickname)}</b> 用漫长而扎实的生涯赢得了对手与队友的尊重。离开 ${esc(favoriteTeam)} 之后，你开始偶尔出现在分析台，把那些赛场经验交给后来者。`;
    return `<b>${esc(state.profile.nickname)}</b> 的故事比预想中更早结束，但这并不抹去它曾经真实发生。那些训练、选择与登上舞台的瞬间已经足够珍贵；或许下一位年轻选手，会从你的未竟之路继续出发。`;
  }

  function showRestartConfirm() {
    const overlay = document.createElement("div");
    overlay.className = "confirm-overlay";
    overlay.innerHTML = `<div class="confirm-box" role="dialog" aria-modal="true" aria-labelledby="confirm-title"><h2 id="confirm-title">重新开始生涯？</h2><p>当前进度将被新的选手档案覆盖，此操作无法撤销。</p><div class="confirm-actions"><button class="button button-small" data-cancel>取消</button><button class="button button-small button-danger" data-confirm>重新开始</button></div></div>`;
    document.body.appendChild(overlay);
    overlay.querySelector("[data-cancel]").addEventListener("click", () => overlay.remove());
    overlay.addEventListener("click", (event) => { if (event.target === overlay) overlay.remove(); });
    overlay.querySelector("[data-confirm]").addEventListener("click", () => { overlay.remove(); resetCareer(); });
    overlay.querySelector("[data-cancel]").focus();
  }

  function resetCareer() {
    clearGameRuntime();
    try { localStorage.removeItem(SAVE_KEY); } catch (_) {}
    state = createDefaultState();
    state.phase = "setup";
    render();
  }

  root.addEventListener("input", (event) => {
    if (event.target.id === "nickname") {
      state.profile.nickname = event.target.value;
      const startButton = root.querySelector('[data-action="start-draft"]');
      if (startButton) startButton.disabled = !state.profile.nickname.trim() || !state.profile.country || !state.profile.role;
    }
  });

  root.addEventListener("change", (event) => {
    if (event.target.id !== "country-select") return;
    state.profile.country = event.target.value || null;
    renderSetup();
  });

  root.addEventListener("click", (event) => {
    const target = event.target.closest("[data-action]");
    if (!target) {
      const field = event.target.closest("[data-minigame-field]");
      if (field?.dataset.game === "aim") missAimTarget();
      if (field?.dataset.game === "reaction") falseStartReaction();
      if (field?.dataset.game === "spray") missSprayTarget();
      if (field?.dataset.game === "deagle") missDeagleTarget();
      return;
    }
    const action = target.dataset.action;
    if (action === "new-game") {
      if (hasSave()) showRestartConfirm(); else { state.phase = "setup"; render(); }
    }
    if (action === "continue-game") { if (loadGame()) render(); else notify("存档读取失败"); }
    if (action === "select-role") { state.profile.role = target.dataset.id; renderSetup(); }
    if (action === "start-draft") {
      if (!state.profile.nickname.trim() || !state.profile.country || !state.profile.role) return;
      state.profile.nickname = state.profile.nickname.trim();
      initializeProspect();
      state.phase = "draft";
      state.draftRound = 0;
      generateDraftChoices();
      saveGame();
      render();
    }
    if (action === "pick-ability") {
      const ability = ABILITY(target.dataset.id);
      if (!ability || state.abilities.includes(ability.id)) return;
      const previousCombos = activeAbilityCombos().map((combo) => combo.id);
      state.abilities.push(ability.id);
      applyEffects(ability.effects, false);
      const newCombos = unlockNewCombos(previousCombos);
      state.draftRound += 1;
      if (state.draftRound >= 4) {
        startCareer();
        if (newCombos.length) notify(`激活组合：${newCombos.map((combo) => combo.name).join("、")}`);
      } else {
        generateDraftChoices();
        saveGame();
        render();
        notify(newCombos.length ? `已获得 ${ability.name} · 激活组合：${newCombos.map((combo) => combo.name).join("、")}` : `已获得能力：${ability.name}`);
      }
    }
    if (action === "accept-offer") acceptOffer(Number(target.dataset.index));
    if (action === "choose-decision") chooseDecision(Number(target.dataset.index));
    if (action === "choose-easter") chooseEasterEgg(Number(target.dataset.index));
    if (action === "choose-growth") chooseGrowthOpportunity(Number(target.dataset.index));
    if (action === "advance-event") nextSeasonEvent();
    if (action === "simulate-tournament") simulateTournament();
    if (action === "simulate-to-key") simulateToKeyMatch();
    if (action === "continue-tournament") continueTournament();
    if (action === "start-veto") startVeto();
    if (action === "auto-veto") autoCompleteVeto(true);
    if (action === "toggle-veto-mode") { state.preferences.vetoMode = state.preferences.vetoMode === "auto" ? "manual" : "auto"; saveGame(); render(); notify(`Ban/Pick 已切换为${state.preferences.vetoMode === "auto" ? "教练托管" : "手动操作"}`); }
    if (action === "set-pace" && ["fast", "balanced", "immersive"].includes(target.dataset.id)) { state.preferences.pace = target.dataset.id; saveGame(); render(); }
    if (action === "veto-map") vetoMap(target.dataset.id);
    if (action === "target-map-training") targetedMapTraining(target.dataset.id);
    if (action === "enter-key-round") enterKeyRound();
    if (action === "select-minigame") selectMiniGame(target.dataset.game);
    if (action === "cancel-minigame") { clearGameRuntime(); state.currentEvent.minigame = null; state.currentEvent.stage = "scenario"; saveGame(); render(); }
    if (action === "begin-minigame") beginMiniGame();
    if (action === "hit-aim-target") hitAimTarget();
    if (action === "hit-reaction-target") hitReactionTarget();
    if (action === "hit-spray-target") hitSprayTarget(target);
    if (action === "hit-deagle-target") hitDeagleTarget();
    if (action === "annual-awards") beginAnnualAwards();
    if (action === "next-season") beginOffseasonRest();
    if (action === "choose-offseason") chooseOffseasonRest(Number(target.dataset.index));
    if (action === "choose-aging") chooseAgingPath(Number(target.dataset.index));
    if (action === "retire") retire();
    if (action === "restart-career") showRestartConfirm();
    if (action === "back-home") renderWelcome();
  });

  el("brand-home").addEventListener("click", () => { clearGameRuntime(); renderWelcome(); });
  restartButton.addEventListener("click", showRestartConfirm);

  render();
})();
